import React from "react";

export const Add = {
  viewBox: "0 0 30 30",
  body: () => (
    <g>
      <circle
        cx="15"
        cy="15"
        r="13.5"
        stroke="#000000"
        strokeWidth="3"
        fill="transparent"
      />
      <path d="M13.681 8.821V13.467H9.035V16.25H13.681V20.873H16.441V16.25H21.087V13.467H16.441V8.821H13.681Z" />
    </g>
  )
};

export const Agenda = {
  viewBox: "0 0 20 23",
  body: () => (
    <path d="M17.8947 2.41364H15.7895V1.70494C15.7895 1.17998 15.4526 0.76001 15.0316 0.76001H13.8737C13.4526 0.76001 13.1158 1.17998 13.1158 1.70494V2.41364H6.88421V1.70494C6.88421 1.17998 6.54737 0.76001 6.12632 0.76001H4.96842C4.54737 0.76001 4.21053 1.17998 4.21053 1.70494V2.41364H2.10526C0.947368 2.41364 0 3.59481 0 5.03846V20.3149C0 21.7585 0.947368 22.9397 2.10526 22.9397H17.8947C19.0526 22.9397 20 21.7585 20 20.3149V5.03846C20 3.56856 19.0526 2.41364 17.8947 2.41364ZM17.8947 21.4961H2.10526C1.57895 21.4961 1.15789 20.9711 1.15789 20.3149V8.13574H18.8421V20.2886C18.8421 20.9448 18.4211 21.4961 17.8947 21.4961Z" />
  )
};

export const ArrowForwards = {
  viewBox: "0 0 20 20",
  body: () => (
    <g fill="none" fillRule="evenodd" stroke="#822D50">
      <path strokeLinecap="square" d="M16 10.5H2" />
      <path d="M10.99 16.52L17 10.51 10.99 4.5" />
    </g>
  )
};

export const ArrowLeft = {
  viewBox: "0 0 17 38",
  body: () => (
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#A2646F"
      strokeWidth="3"
      d="M15 36.402l-13-17.7L15 1"
    />
  )
};

export const ArrowRight = {
  viewBox: "0 0 17 38",
  body: () => (
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#A2646F"
      strokeWidth="3"
      d="M2 1l13 17.701L2 36.402"
    />
  )
};

export const Ball = {
  viewBox: "0 0 35 35",
  body: () => (
    <path
      d="M34.5 17.5C34.5 26.8888 26.8888 34.5 17.5 34.5C8.11116 34.5 0.5 26.8888 0.5 17.5C0.5 8.11116 8.11116 0.5 17.5 0.5C26.8888 0.5 34.5 8.11116 34.5 17.5Z"
      fill="#00D2C8"
      stroke="#00D2C8"
    />
  )
};

export const BarChart = {
  viewBox: "0 0 20 20",
  body: () => (
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#C5C5C5"
        d="M12.5 17.5h5V4A1.5 1.5 0 0 0 16 2.5h-2A1.5 1.5 0 0 0 12.5 4v13.5zM2.5 17.5h5V13A1.5 1.5 0 0 0 6 11.5H4A1.5 1.5 0 0 0 2.5 13v4.5zM7.5 17.5h5V8A1.5 1.5 0 0 0 11 6.5H9A1.5 1.5 0 0 0 7.5 8v9.5z"
      />
    </g>
  )
};

export const BarChartThin = {
  viewBox: "0 0 24 24",
  strokeOutline: true,
  body: () => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3H22V21H18V3Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8H14V21H10V8Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 13H6V21H2V13Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
};

export const Bell = {
  viewBox: "0 0 16 20",
  body: () => [
    <mask key="bell-mask" id="path-1-inside-1" fill="white">
      <path
        key="bell-mask-path"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.85742C11.1559 1.85742 13.7143 4.41579 13.7143 7.57171L13.7143 14.4289L16 16.7146H0L2.28571 14.4289V7.57171C2.28571 4.41579 4.84409 1.85742 8 1.85742Z"
      />
    </mask>,
    <path
      key="bell-path-1"
      d="M13.7143 7.57171H12.5714H12.5714H13.7143ZM13.7143 14.4289H12.5714V14.9022L12.9062 15.237L13.7143 14.4289ZM16 16.7146V17.8574H18.7591L16.8081 15.9064L16 16.7146ZM0 16.7146L-0.808122 15.9064L-2.7591 17.8574H0V16.7146ZM2.28571 14.4289L3.09384 15.237L3.42857 14.9022V14.4289H2.28571ZM14.8571 7.57171C14.8571 3.78461 11.7871 0.714565 8 0.714565V3.00028C10.5247 3.00028 12.5714 5.04698 12.5714 7.57171H14.8571ZM14.8571 14.4289L14.8571 7.57171H12.5714L12.5714 14.4289H14.8571ZM12.9062 15.237L15.1919 17.5227L16.8081 15.9064L14.5224 13.6207L12.9062 15.237ZM16 15.5717H0V17.8574H16V15.5717ZM0.808122 17.5227L3.09384 15.237L1.47759 13.6207L-0.808122 15.9064L0.808122 17.5227ZM1.14286 7.57171V14.4289H3.42857V7.57171H1.14286ZM8 0.714565C4.2129 0.714565 1.14286 3.78461 1.14286 7.57171H3.42857C3.42857 5.04698 5.47527 3.00028 8 3.00028V0.714565Z"
      fill="#929292"
      mask="url(#path-1-inside-1)"
    />,
    <path
      key="bell-path-2"
      d="M10.2858 16.7148C10.2858 17.9772 9.26244 19.0006 8.00007 19.0006C6.7377 19.0006 5.71436 17.9772 5.71436 16.7148"
      stroke="#929292"
      strokeWidth="1.14286"
      strokeLinecap="square"
    />,
    <line
      key="bell-line"
      x1="7.99986"
      y1="2.42906"
      x2="7.99986"
      y2="1.2862"
      stroke="#929292"
      strokeWidth="1.14286"
      strokeLinecap="square"
    />
  ]
};

export const Bin = {
  viewBox: "0 0 23 29",
  body: () => [
    <path
      key={1}
      d="M5.75 8.23584V21.0422H17.25V8.23584H15.87V19.6502H7.13V8.23584H5.75Z"
      fill="#000"
    />,
    <path
      key={2}
      d="M3.54102 6.00891H19.457V4.61691H14.558V2.15771H8.44002V4.61691H3.54102V6.00891ZM9.82002 3.54971H13.178V4.61691H9.82002V3.54971Z"
      fill="#000"
    />,
    <path
      key={3}
      d="M10.3488 8.23584H8.96875V17.5738H10.3488V8.23584Z"
      fill="#000"
    />,
    <path
      key={4}
      d="M14.0284 8.23584H12.6484V17.5738H14.0284V8.23584Z"
      fill="#000"
    />
  ]
};

export const BlankUser = {
  viewBox: "0 0 40 40",
  body: () => [
    <path
      key={1}
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#FAFABE"
    />,
    <path
      key={2}
      d="M23.8255 27.0272V26.0653C25.4586 24.7901 26.7785 22.7096 27.1365 20.9199V20.8975C27.1588 20.8975 27.1812 20.8975 27.1812 20.8975C27.7405 20.9199 28.255 20.7856 28.7025 20.5172C29.1946 20.2263 29.5526 19.7789 29.6868 19.2644C29.821 18.7946 29.7315 18.3248 29.4407 18.0339C29.217 17.8102 28.9038 17.6984 28.5011 17.676C28.2327 17.6536 27.9418 17.676 27.651 17.7655C27.651 17.6089 27.651 17.4747 27.651 17.3628C27.651 17.3181 27.651 17.2733 27.651 17.2062C27.8076 16.3561 27.9866 15.4836 28.2327 14.8125C28.9038 13.0675 27.7629 12.7543 26.9799 12.978C26.2192 13.2017 25.8389 13.0451 25.8389 13.0451C25.8389 13.0451 26.5996 12.5977 26.4877 11.9937C26.3311 11.0764 25.1454 11.1659 23.9821 11.4791C23.3557 11.6357 23.0425 11.9266 22.9083 12.1503C23.0425 11.8147 23.2215 11.3225 23.1991 11.0317C23.1544 10.2711 22.5951 8.97354 20.0224 8.7722C16.9351 8.52611 14.877 10.3606 15.4586 12.5753C14.2058 12.5082 13.2438 12.5753 13.3557 14.0295C13.4228 15.0362 13.4228 17.1167 13.6689 18.3248C13.6913 18.459 13.7136 18.5709 13.736 18.7051C13.5794 18.7051 13.4228 18.7051 13.2662 18.7275C12.9754 18.7722 12.6398 18.8169 12.349 19.063C12.0134 19.3762 11.8568 19.8684 11.9687 20.3606C12.0134 20.5843 12.1253 20.8975 12.4608 21.1659C13.0649 21.7029 13.8926 21.591 14.2953 21.4791C15.0112 23.3807 16.1298 24.9467 17.4497 25.9758V26.8706C11.745 28.5932 10.0224 35.1033 10 35.1928L10.4698 35.3047C10.4922 35.2375 12.1029 29.0854 17.4497 27.3852V28.6827C17.4497 30.4501 18.8814 31.8818 20.6488 31.8818C22.4161 31.8818 23.8479 30.4501 23.8479 28.6827V27.5194C29.4407 29.3986 29.5302 35.3718 29.5302 35.6626H30C29.9776 35.5955 29.8881 28.9736 23.8255 27.0272ZM14.6532 21.1436C14.6309 21.0765 14.5861 21.0317 14.5414 21.0093C14.519 20.987 14.4743 20.987 14.4295 20.987C14.4072 20.987 14.3848 20.987 14.34 21.0093C14.2953 21.0317 13.3557 21.3673 12.7517 20.8527C12.5727 20.6961 12.4609 20.5172 12.4161 20.2935C12.349 20.025 12.4161 19.6671 12.6622 19.4433C12.8412 19.2867 13.0649 19.2644 13.311 19.2196C13.5347 19.1973 13.7584 19.1973 13.9821 19.242C14.0045 19.242 14.0268 19.242 14.0492 19.242C14.0716 19.2644 14.1163 19.2644 14.1387 19.2644C14.7204 19.3091 14.4743 16.6022 14.7427 15.8863C15.0336 15.1704 16.1745 14.9243 16.1745 14.9243C16.1745 14.9243 17.047 16.2219 19.2394 15.9982C21.4541 15.7744 22.1253 14.7006 22.1253 14.7006C22.1253 14.7006 22.7069 15.8416 23.8479 16.1548C24.9888 16.468 26.7338 15.4612 26.7338 15.4612C26.7338 15.4612 26.1521 19.8237 26.7338 19.8684C27.0246 19.8908 27.2036 19.1973 27.3826 18.28C27.4049 18.28 27.4273 18.28 27.4273 18.2577C27.7405 18.1458 28.0761 18.0787 28.4116 18.1011C28.7025 18.1234 28.9038 18.1905 29.038 18.3248C29.2394 18.5261 29.2394 18.8617 29.1723 19.1078C29.0604 19.4881 28.7919 19.846 28.4116 20.0697C28.0537 20.2711 27.6286 20.3829 27.1588 20.3829C27.0917 20.3829 27.0022 20.3829 26.9351 20.3606C26.8233 20.3382 26.689 20.4277 26.6667 20.5619L26.6219 20.7856C26.0626 24.0295 22.953 26.7812 20.8277 26.8035C18.3669 26.8259 15.8166 24.4993 14.6532 21.1436ZM20.6488 31.4344C19.1499 31.4344 17.9195 30.204 17.9195 28.7051V26.3561C18.8367 26.9601 19.821 27.2957 20.8054 27.2957H20.8277C21.6779 27.2957 22.528 26.9601 23.3557 26.4232V28.7275C23.3557 30.204 22.1477 31.4344 20.6488 31.4344Z"
      fill="#28283C"
    />
  ]
};

export const Blocks = {
  viewBox: "0 0 385.419 385.419",
  pathOutline: true,
  body: () => (
    <g>
      <path
        stroke="none"
        d="M188.998,331.298l-0.231-107.449l-92.494-53.907L3.946,223.654l0.225,108.29l92.102,53.475L188.998,331.298z
		 M105.656,358.292l0.165-75.232l64.289-37.558l0.165,75.067L105.656,358.292z M96.26,191.586l64.603,37.658l-64.384,37.606
		L31.874,229.05L96.26,191.586z M22.703,245.356l64.411,37.691l-0.164,75.335l-64.092-37.217L22.703,245.356z"
      />
      <path
        stroke="none"
        d="M288.748,169.948l-92.324,53.706l0.231,108.29l92.104,53.475l92.714-54.121l-0.231-107.449L288.748,169.948z
		 M288.735,191.586l64.605,37.658l-64.386,37.606l-64.606-37.801L288.735,191.586z M215.179,245.356l64.404,37.691l-0.164,75.335
		l-64.076-37.217L215.179,245.356z M298.137,358.292l0.159-75.232l64.289-37.558l0.164,75.067L298.137,358.292z"
      />
      <path
        stroke="none"
        d="M285.216,53.892L192.719,0l-92.324,53.697l0.222,108.295l92.102,53.479l92.717-54.121L285.216,53.892z M192.707,21.635
		l64.609,37.649l-64.384,37.619l-64.609-37.811L192.707,21.635z M119.149,75.401l64.411,37.698l-0.161,75.335l-64.095-37.211
		L119.149,75.401z M202.099,188.343l0.162-75.234l64.292-37.564l0.164,75.073L202.099,188.343z"
      />
    </g>
  )
};

export const BoldCalendarCircle = {
  viewBox: "0 0 34 34",
  body: () => [
    <circle
      key={1}
      cx="17"
      cy="17"
      r="15.5"
      transform="rotate(90 17 17)"
      fill="white"
      stroke="#00D2C8"
      strokeWidth="3"
    />,
    <path
      key={2}
      d="M23.3307 25H10.6693C9.74933 25 9 24.2513 9 23.3307V12.0033C9 11.0827 9.74933 10.3333 10.67 10.3333H23.33C24.2507 10.3333 25 11.0827 25 12.0033V23.3307C25 24.2513 24.2513 25 23.3307 25ZM10.67 11.6667C10.4847 11.6667 10.3333 11.818 10.3333 12.0033V23.3307C10.3333 23.516 10.484 23.6667 10.6693 23.6667H23.3307C23.516 23.6667 23.6667 23.516 23.6667 23.3307V12.0033C23.6667 11.818 23.5153 11.6667 23.33 11.6667H10.67ZM24.3333 14.3333H9.66667C9.29867 14.3333 9 14.0347 9 13.6667C9 13.2987 9.29867 13 9.66667 13H24.3333C24.702 13 25 13.2987 25 13.6667C25 14.0347 24.702 14.3333 24.3333 14.3333ZM12.3333 12.3333C11.9653 12.3333 11.6667 12.0347 11.6667 11.6667V9.66667C11.6667 9.29867 11.9653 9 12.3333 9C12.7013 9 13 9.29867 13 9.66667V11.6667C13 12.0347 12.7013 12.3333 12.3333 12.3333ZM21.6667 12.3333C21.298 12.3333 21 12.0347 21 11.6667V9.66667C21 9.29867 21.298 9 21.6667 9C22.0353 9 22.3333 9.29867 22.3333 9.66667V11.6667C22.3333 12.0347 22.0353 12.3333 21.6667 12.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={3}
      d="M13 22.3333C13.3682 22.3333 13.6667 22.0349 13.6667 21.6667C13.6667 21.2985 13.3682 21 13 21C12.6319 21 12.3334 21.2985 12.3334 21.6667C12.3334 22.0349 12.6319 22.3333 13 22.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={4}
      d="M13 19.6666C13.3682 19.6666 13.6667 19.3681 13.6667 18.9999C13.6667 18.6317 13.3682 18.3333 13 18.3333C12.6319 18.3333 12.3334 18.6317 12.3334 18.9999C12.3334 19.3681 12.6319 19.6666 13 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={5}
      d="M15 22.3333C15.3682 22.3333 15.6667 22.0349 15.6667 21.6667C15.6667 21.2985 15.3682 21 15 21C14.6319 21 14.3334 21.2985 14.3334 21.6667C14.3334 22.0349 14.6319 22.3333 15 22.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={6}
      d="M15 19.6666C15.3682 19.6666 15.6667 19.3681 15.6667 18.9999C15.6667 18.6317 15.3682 18.3333 15 18.3333C14.6319 18.3333 14.3334 18.6317 14.3334 18.9999C14.3334 19.3681 14.6319 19.6666 15 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={7}
      d="M15 17.0001C15.3682 17.0001 15.6667 16.7016 15.6667 16.3334C15.6667 15.9652 15.3682 15.6667 15 15.6667C14.6319 15.6667 14.3334 15.9652 14.3334 16.3334C14.3334 16.7016 14.6319 17.0001 15 17.0001Z"
      fill="#00D2C8"
    />,
    <path
      key={8}
      d="M19 22.3333C19.3682 22.3333 19.6667 22.0349 19.6667 21.6667C19.6667 21.2985 19.3682 21 19 21C18.6319 21 18.3334 21.2985 18.3334 21.6667C18.3334 22.0349 18.6319 22.3333 19 22.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={9}
      d="M19 19.6666C19.3682 19.6666 19.6667 19.3681 19.6667 18.9999C19.6667 18.6317 19.3682 18.3333 19 18.3333C18.6319 18.3333 18.3334 18.6317 18.3334 18.9999C18.3334 19.3681 18.6319 19.6666 19 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={10}
      d="M19 17.0001C19.3682 17.0001 19.6667 16.7016 19.6667 16.3334C19.6667 15.9652 19.3682 15.6667 19 15.6667C18.6319 15.6667 18.3334 15.9652 18.3334 16.3334C18.3334 16.7016 18.6319 17.0001 19 17.0001Z"
      fill="#00D2C8"
    />,
    <path
      key={11}
      d="M21 19.6666C21.3682 19.6666 21.6667 19.3681 21.6667 18.9999C21.6667 18.6317 21.3682 18.3333 21 18.3333C20.6319 18.3333 20.3334 18.6317 20.3334 18.9999C20.3334 19.3681 20.6319 19.6666 21 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={12}
      d="M21 17.0001C21.3682 17.0001 21.6667 16.7016 21.6667 16.3334C21.6667 15.9652 21.3682 15.6667 21 15.6667C20.6319 15.6667 20.3334 15.9652 20.3334 16.3334C20.3334 16.7016 20.6319 17.0001 21 17.0001Z"
      fill="#00D2C8"
    />,
    <path
      key={13}
      d="M17 22.3333C17.3682 22.3333 17.6667 22.0349 17.6667 21.6667C17.6667 21.2985 17.3682 21 17 21C16.6319 21 16.3334 21.2985 16.3334 21.6667C16.3334 22.0349 16.6319 22.3333 17 22.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={14}
      d="M17 19.6666C17.3682 19.6666 17.6667 19.3681 17.6667 18.9999C17.6667 18.6317 17.3682 18.3333 17 18.3333C16.6319 18.3333 16.3334 18.6317 16.3334 18.9999C16.3334 19.3681 16.6319 19.6666 17 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={15}
      d="M17 17.0001C17.3682 17.0001 17.6667 16.7016 17.6667 16.3334C17.6667 15.9652 17.3682 15.6667 17 15.6667C16.6319 15.6667 16.3334 15.9652 16.3334 16.3334C16.3334 16.7016 16.6319 17.0001 17 17.0001Z"
      fill="#00D2C8"
    />
  ]
};

export const BoldCircleTick = {
  viewBox: "0 0 34 34",
  body: () => [
    <circle
      key={1}
      cx="17"
      cy="17"
      r="15.5"
      transform="rotate(90 17 17)"
      fill="white"
      stroke="#00D2C8"
      strokeWidth="3"
    />,
    <path
      key={2}
      d="M10 17.7576L14.4681 22L25 12"
      stroke="#00D2C8"
      strokeWidth="4"
      fill="transparent"
    />
  ]
};

export const BoldClock = {
  viewBox: "0 0 24 24",
  pathOutline: true,
  body: () => (
    <>
      <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" />
      <path d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" />
    </>
  )
};

export const BoldEmailCircle = {
  viewBox: "0 0 34 34",
  body: () => [
    <circle
      key={1}
      cx="17"
      cy="17"
      r="15.5"
      transform="rotate(90 17 17)"
      fill="white"
      stroke="#00D2C8"
      strokeWidth="3"
    />,
    <path
      key={2}
      d="M10.7727 24.125H23.7727C24.276 24.125 24.7587 23.9251 25.1146 23.5692C25.4705 23.2133 25.6705 22.7306 25.6705 22.2273V12.7727C25.6705 12.2694 25.4705 11.7867 25.1146 11.4308C24.7587 11.0749 24.276 10.875 23.7727 10.875H10.7727C10.2694 10.875 9.78672 11.0749 9.43083 11.4308C9.07494 11.7867 8.875 12.2694 8.875 12.7727V22.2273C8.875 22.7306 9.07494 23.2133 9.43083 23.5692C9.78672 23.9251 10.2694 24.125 10.7727 24.125ZM10.4433 12.4433C10.5307 12.3559 10.6492 12.3068 10.7727 12.3068H23.7727C23.8963 12.3068 24.0148 12.3559 24.1022 12.4433C24.1895 12.5307 24.2386 12.6492 24.2386 12.7727V22.2273C24.2386 22.3508 24.1895 22.4693 24.1022 22.5567C24.0148 22.6441 23.8963 22.6932 23.7727 22.6932H10.7727C10.6492 22.6932 10.5307 22.6441 10.4433 22.5567C10.3559 22.4693 10.3068 22.3508 10.3068 22.2273V12.7727C10.3068 12.6492 10.3559 12.5307 10.4433 12.4433Z"
      fill="#00D2C8"
      stroke="#00D2C8"
      strokeWidth="0.25"
    />,
    <path
      key={3}
      d="M25.0724 12.283L24.9486 12.2653L25.0724 12.283C25.0857 12.1899 25.0805 12.0951 25.0572 12.0041C25.0339 11.913 24.9928 11.8274 24.9364 11.7522L24.8364 11.8272L24.9364 11.7522C24.88 11.677 24.8093 11.6136 24.7284 11.5657C24.6475 11.5178 24.558 11.4863 24.4649 11.473C24.3718 11.4597 24.2771 11.4649 24.186 11.4882C24.0949 11.5116 24.0093 11.5526 23.9341 11.609L17.2728 16.605L10.6114 11.609C10.4595 11.4951 10.2686 11.4462 10.0806 11.473C9.89265 11.4999 9.72305 11.6003 9.60913 11.7522C9.4952 11.9041 9.44629 12.095 9.47314 12.283C9.48644 12.376 9.51793 12.4656 9.56583 12.5465C9.61373 12.6274 9.6771 12.6981 9.75231 12.7545L16.8432 18.0726C16.9671 18.1656 17.1179 18.2158 17.2728 18.2158C17.4277 18.2158 17.5784 18.1656 17.7023 18.0726L24.7932 12.7545C24.8684 12.698 24.9318 12.6274 24.9797 12.5465C25.0276 12.4656 25.0591 12.376 25.0724 12.283Z"
      fill="#00D2C8"
      stroke="#00D2C8"
      strokeWidth="0.25"
    />
  ]
};

export const BoldEnvelope = {
  viewBox: "0 0 24 24",
  body: () => (
    <path
      d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
      fill="#28283C"
    />
  )
};

export const BoldSearch = {
  viewBox: "0 0 16 16",
  body: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0903 6.87576C11.0903 5.76631 10.696 4.8173 9.90738 4.0287C9.11878 3.2401 8.16977 2.8458 7.06033 2.8458C5.95088 2.8458 5.00187 3.2401 4.21327 4.0287C3.42467 4.8173 3.03037 5.76631 3.03037 6.87576C3.03037 7.9852 3.42467 8.93421 4.21327 9.72281C5.00187 10.5114 5.95088 10.9057 7.06033 10.9057C8.16977 10.9057 9.11878 10.5114 9.90738 9.72281C10.696 8.93421 11.0903 7.9852 11.0903 6.87576ZM15.6959 14.36C15.6959 14.6718 15.582 14.9417 15.3541 15.1695C15.1262 15.3974 14.8564 15.5114 14.5445 15.5114C14.2207 15.5114 13.9508 15.3974 13.7349 15.1695L10.6495 12.0931C9.57605 12.8367 8.37966 13.2085 7.06033 13.2085C6.20276 13.2085 5.38268 13.0421 4.60007 12.7093C3.81747 12.3765 3.14282 11.9267 2.5761 11.36C2.00939 10.7933 1.55962 10.1186 1.22679 9.33601C0.893953 8.5534 0.727539 7.73333 0.727539 6.87576C0.727539 6.01819 0.893953 5.19811 1.22679 4.4155C1.55962 3.6329 2.00939 2.95825 2.5761 2.39153C3.14282 1.82482 3.81747 1.37505 4.60007 1.04222C5.38268 0.709383 6.20276 0.542969 7.06033 0.542969C7.9179 0.542969 8.73797 0.709383 9.52058 1.04222C10.3032 1.37505 10.9778 1.82482 11.5446 2.39153C12.1113 2.95825 12.561 3.6329 12.8939 4.4155C13.2267 5.19811 13.3931 6.01819 13.3931 6.87576C13.3931 8.19509 13.0213 9.39147 12.2777 10.4649L15.3631 13.5504C15.585 13.7723 15.6959 14.0421 15.6959 14.36Z"
    />
  )
};

export const BoldStarCircle = {
  viewBox: "0 0 40 40",
  body: () => [
    <circle
      key={1}
      cx="20"
      cy="20"
      r="18.5"
      transform="rotate(90 20 20)"
      fill="white"
      stroke="#00D2C8"
      strokeWidth="3"
    />,
    <path
      key={2}
      d="M19.0489 13.927C19.3483 13.0057 20.6517 13.0057 20.9511 13.9271L22.0206 17.2188C22.1545 17.6309 22.5385 17.9098 22.9717 17.9098H26.4329C27.4016 17.9098 27.8044 19.1494 27.0207 19.7188L24.2205 21.7533C23.87 22.0079 23.7234 22.4593 23.8572 22.8713L24.9268 26.1631C25.2261 27.0844 24.1717 27.8506 23.388 27.2812L20.5878 25.2467C20.2373 24.9921 19.7627 24.9921 19.4122 25.2467L16.612 27.2812C15.8283 27.8506 14.7739 27.0844 15.0732 26.1631L16.1428 22.8713C16.2766 22.4593 16.13 22.0079 15.7795 21.7533L12.9793 19.7188C12.1956 19.1494 12.5984 17.9098 13.5671 17.9098H17.0283C17.4615 17.9098 17.8455 17.6309 17.9794 17.2188L19.0489 13.927Z"
      fill="#00D2C8"
    />
  ]
};

export const BoldXCircle = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      d="M11 20.1667C16.0626 20.1667 20.1667 16.0627 20.1667 11C20.1667 5.93743 16.0626 1.83337 11 1.83337C5.93738 1.83337 1.83333 5.93743 1.83333 11C1.83333 16.0627 5.93738 20.1667 11 20.1667Z"
      stroke="#28283C"
      strokeWidth="2"
      fill="transparent"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={2}
      d="M13.75 8.25L8.25 13.75"
      stroke="#28283C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={3}
      d="M8.25 8.25L13.75 13.75"
      stroke="#28283C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ]
};

export const Briefcase = {
  viewBox: "0 0 24 24",
  strokeOutline: true,
  body: () => (
    <>
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" fill="none" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" fill="none" />
    </>
  )
};

export const Buffer = {
  viewBox: "0 0 46 49",
  body: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.425 27.5001L22.975 41.8501L4.55 27.5251L0.5 30.6751L23 48.1751L45.5 30.6751L41.425 27.5001ZM23 0.5L0.5 18L4.575 21.175L23 35.5L41.4 21.175L45.5 18L23 0.5ZM23 29.175L8.65001 18L23 6.82504L37.35 18L23 29.175Z"
    />
  )
};

export const BulbThin = {
  viewBox: "0 0 23 33",
  pathOutline: true,
  body: () => [
    <path
      key={0}
      d="M9.08258 11.2369C9.08431 11.2618 9.08568 11.2859 9.08982 11.3104C9.09362 11.3325 9.09948 11.3535 9.10535 11.3745C9.11121 11.3963 9.11708 11.4177 9.12535 11.4387C9.13329 11.4598 9.14295 11.4794 9.15295 11.4994C9.16295 11.5194 9.17296 11.5394 9.18503 11.5584C9.19676 11.5774 9.21021 11.5946 9.22401 11.6122C9.23746 11.6298 9.25091 11.6474 9.26644 11.6636C9.28299 11.6816 9.30162 11.6971 9.3199 11.7129C9.33129 11.7229 9.3406 11.7343 9.35302 11.7436C9.35647 11.7461 9.36026 11.7467 9.36371 11.7492C9.41614 11.7874 9.47409 11.8171 9.53653 11.8395C9.54963 11.844 9.56205 11.8478 9.57551 11.8516C9.63656 11.8695 9.70003 11.882 9.76661 11.882C9.76695 11.882 9.7673 11.882 9.76764 11.882C9.76764 11.882 9.76764 11.882 9.76798 11.882C9.76833 11.882 9.76833 11.882 9.76833 11.882H11.8466L9.21676 15.3769C8.98772 15.6815 9.04878 16.1141 9.35336 16.3431C9.47754 16.4366 9.62311 16.4818 9.76764 16.4818C9.97702 16.4818 10.184 16.3869 10.3196 16.2069L13.7804 11.607C13.7838 11.6022 13.7859 11.597 13.7893 11.5922C13.8038 11.5719 13.8159 11.5498 13.8283 11.5277C13.8383 11.5098 13.8494 11.4922 13.8576 11.4739C13.867 11.4532 13.8732 11.4315 13.8804 11.4097C13.8877 11.388 13.8956 11.367 13.9004 11.3449C13.9049 11.3252 13.9066 11.3049 13.9094 11.2849C13.9128 11.2597 13.9163 11.2345 13.917 11.209C13.917 11.2031 13.9187 11.1979 13.9187 11.1921C13.9187 11.1769 13.9153 11.1628 13.9142 11.1479C13.9125 11.1231 13.9111 11.0989 13.907 11.0744C13.9032 11.0524 13.8973 11.0313 13.8915 11.0103C13.8856 10.9886 13.8797 10.9672 13.8714 10.9461C13.8635 10.9251 13.8539 10.9054 13.8438 10.8854C13.8338 10.8654 13.8238 10.8454 13.8118 10.8264C13.8 10.8075 13.7866 10.7902 13.7728 10.7726C13.7593 10.755 13.7459 10.7374 13.7304 10.7212C13.7138 10.7033 13.6952 10.6878 13.6769 10.6719C13.6655 10.6619 13.6562 10.6505 13.6438 10.6412C13.639 10.6377 13.6338 10.6357 13.6289 10.6322C13.6083 10.6174 13.5858 10.6053 13.5634 10.5926C13.5458 10.5829 13.5289 10.5722 13.511 10.5643C13.4892 10.5546 13.4661 10.5477 13.4434 10.5401C13.423 10.5336 13.4034 10.526 13.383 10.5212C13.3616 10.5163 13.3392 10.5143 13.3171 10.5115C13.294 10.5084 13.2712 10.5053 13.2478 10.5046C13.2412 10.5046 13.2354 10.5029 13.2288 10.5029H11.1505L13.7804 7.0079C14.0094 6.70331 13.9484 6.27075 13.6438 6.04171C13.3395 5.81301 12.907 5.87407 12.6776 6.17831L9.21676 10.7778C9.21331 10.7826 9.21124 10.7878 9.20779 10.7926C9.19331 10.813 9.18123 10.8351 9.16882 10.8571C9.15881 10.8751 9.14778 10.8927 9.1395 10.9109C9.13018 10.9316 9.12397 10.9534 9.11673 10.9751C9.10949 10.9968 9.10155 11.0179 9.09672 11.04C9.09224 11.0596 9.09051 11.08 9.08775 11.1C9.0843 11.1252 9.08086 11.1503 9.08017 11.1759C9.08017 11.1817 9.07844 11.1869 9.07844 11.1928C9.0781 11.2079 9.08189 11.2221 9.08258 11.2369Z"
      // fill="#03C2B9"
      // stroke="#03C2B9"
      strokeWidth={0}
    />,
    <path
      key={1}
      d="M5.44749 20.0778C6.03631 20.4949 6.37402 21.1241 6.37402 21.8195C6.3754 23.015 7.34952 23.9878 8.5451 23.9878H14.4533C15.6496 23.9878 16.6234 23.0147 16.6244 21.8181C16.6244 21.131 16.9414 20.5021 17.4733 20.1344C20.3077 18.1696 22 14.942 22 11.5001C22 5.71056 17.2884 1 11.4968 1C11.1025 1 10.7017 1.02208 10.305 1.06588C5.39368 1.61228 1.49995 5.58259 1.04635 10.506C0.696575 14.3097 2.3423 17.8885 5.44749 20.0778ZM2.42026 10.6326C2.81419 6.35837 6.1943 2.91168 10.4568 2.43738C10.8028 2.39909 11.1529 2.37978 11.4968 2.37978C16.5275 2.37978 20.6202 6.47116 20.6202 11.5001C20.6202 14.4897 19.1501 17.2934 16.6882 18.9999C15.7841 19.6242 15.2443 20.6777 15.2443 21.8174C15.2439 22.2534 14.889 22.608 14.453 22.608H8.5451C8.10943 22.608 7.75448 22.2534 7.75379 21.8033C7.75379 20.6874 7.18981 19.6215 6.24397 18.9509C3.54547 17.0485 2.11637 13.9389 2.42026 10.6326Z"
      // fill="#03C2B9"
      // stroke="#03C2B9"
      strokeWidth={0}
    />,
    <path
      key={2}
      d="M7.9145 26.6757H15.0855C15.4664 26.6757 15.7754 26.3666 15.7754 25.9858C15.7754 25.605 15.4664 25.2959 15.0855 25.2959H7.9145C7.53368 25.2959 7.22461 25.605 7.22461 25.9858C7.22461 26.3666 7.53333 26.6757 7.9145 26.6757Z"
      // fill="#03C2B9"
      // stroke="#03C2B9"
      strokeWidth={0}
    />,
    <path
      key={3}
      d="M7.9145 29.4061H15.0855C15.4664 29.4061 15.7754 29.0971 15.7754 28.7163C15.7754 28.3354 15.4664 28.0264 15.0855 28.0264H7.9145C7.53368 28.0264 7.22461 28.3354 7.22461 28.7163C7.22461 29.0971 7.53333 29.4061 7.9145 29.4061Z"
      // fill="#03C2B9"
      // stroke="#03C2B9"
      strokeWidth={0}
    />,
    <path
      key={4}
      d="M13.9191 31.3549C13.9191 30.9741 13.61 30.665 13.2292 30.665H9.76801C9.3872 30.665 9.07812 30.9741 9.07812 31.3549C9.07812 31.7357 9.3872 32.0448 9.76801 32.0448H13.2288C13.61 32.0448 13.9191 31.7357 13.9191 31.3549Z"
      // fill="#03C2B9"
      // stroke="#03C2B9"
      strokeWidth={0}
    />
  ]
};

export const Bullet = {
  viewBox: "0 0 35 35",
  pathOutline: true,
  body: () => (
    <path d="M34.5 17.5C34.5 26.8888 26.8888 34.5 17.5 34.5C8.11116 34.5 0.5 26.8888 0.5 17.5C0.5 8.11116 8.11116 0.5 17.5 0.5C26.8888 0.5 34.5 8.11116 34.5 17.5Z" />
  )
};

export const Camera = {
  viewBox: "0 0 62 62",
  body: () => (
    <g>
      <path d="M23.2503 7.75L18.5228 12.9167H10.3337C7.49199 12.9167 5.16699 15.2417 5.16699 18.0833V49.0833C5.16699 51.925 7.49199 54.25 10.3337 54.25H51.667C54.5087 54.25 56.8337 51.925 56.8337 49.0833V18.0833C56.8337 15.2417 54.5087 12.9167 51.667 12.9167H43.4778L38.7503 7.75H23.2503ZM31.0003 46.5C23.8703 46.5 18.0837 40.7133 18.0837 33.5833C18.0837 26.4533 23.8703 20.6667 31.0003 20.6667C38.1303 20.6667 43.917 26.4533 43.917 33.5833C43.917 40.7133 38.1303 46.5 31.0003 46.5Z" />
      <path d="M31.0003 43.9167L34.2295 36.8125L41.3337 33.5833L34.2295 30.3542L31.0003 23.25L27.7712 30.3542L20.667 33.5833L27.7712 36.8125L31.0003 43.9167Z" />
    </g>
  )
};

export const Calendar = {
  viewBox: "0 0 20 20",
  body: () => (
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#822D50"
      transform="translate(2 1)"
    >
      <rect width="15" height="14" x=".5" y="2.5" rx="2" />
      <path strokeLinecap="square" d="M1 7.5h14M11.5.5V4M4.5.5V4" />
    </g>
  )
};

export const CalendarThick = {
  viewBox: "0 0 19 19",
  body: () => [
    <path
      key={1}
      d="M17.0177 19H1.98233C0.889833 19 0 18.111 0 17.0177V3.56646C0 2.47317 0.889833 1.58333 1.98313 1.58333H17.0169C18.1102 1.58333 19 2.47317 19 3.56646V17.0177C19 18.111 18.111 19 17.0177 19ZM1.98313 3.16667C1.76304 3.16667 1.58333 3.34638 1.58333 3.56646V17.0177C1.58333 17.2378 1.76225 17.4167 1.98233 17.4167H17.0177C17.2378 17.4167 17.4167 17.2378 17.4167 17.0177V3.56646C17.4167 3.34638 17.237 3.16667 17.0169 3.16667H1.98313ZM18.2083 6.33333H0.791667C0.354667 6.33333 0 5.97867 0 5.54167C0 5.10467 0.354667 4.75 0.791667 4.75H18.2083C18.6461 4.75 19 5.10467 19 5.54167C19 5.97867 18.6461 6.33333 18.2083 6.33333ZM3.95833 3.95833C3.52133 3.95833 3.16667 3.60367 3.16667 3.16667V0.791667C3.16667 0.354667 3.52133 0 3.95833 0C4.39533 0 4.75 0.354667 4.75 0.791667V3.16667C4.75 3.60367 4.39533 3.95833 3.95833 3.95833ZM15.0417 3.95833C14.6039 3.95833 14.25 3.60367 14.25 3.16667V0.791667C14.25 0.354667 14.6039 0 15.0417 0C15.4795 0 15.8333 0.354667 15.8333 0.791667V3.16667C15.8333 3.60367 15.4795 3.95833 15.0417 3.95833Z"
      fill="#28283C"
    />,
    <path
      key={2}
      d="M4.74967 15.8333C5.1869 15.8333 5.54134 15.4789 5.54134 15.0417C5.54134 14.6044 5.1869 14.25 4.74967 14.25C4.31245 14.25 3.95801 14.6044 3.95801 15.0417C3.95801 15.4789 4.31245 15.8333 4.74967 15.8333Z"
      fill="#28283C"
    />,
    <path
      key={3}
      d="M4.74967 12.6668C5.1869 12.6668 5.54134 12.3124 5.54134 11.8752C5.54134 11.4379 5.1869 11.0835 4.74967 11.0835C4.31245 11.0835 3.95801 11.4379 3.95801 11.8752C3.95801 12.3124 4.31245 12.6668 4.74967 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={4}
      d="M7.12467 15.8333C7.5619 15.8333 7.91634 15.4789 7.91634 15.0417C7.91634 14.6044 7.5619 14.25 7.12467 14.25C6.68745 14.25 6.33301 14.6044 6.33301 15.0417C6.33301 15.4789 6.68745 15.8333 7.12467 15.8333Z"
      fill="#28283C"
    />,
    <path
      key={5}
      d="M7.12467 12.6668C7.5619 12.6668 7.91634 12.3124 7.91634 11.8752C7.91634 11.4379 7.5619 11.0835 7.12467 11.0835C6.68745 11.0835 6.33301 11.4379 6.33301 11.8752C6.33301 12.3124 6.68745 12.6668 7.12467 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={6}
      d="M7.12467 9.49984C7.5619 9.49984 7.91634 9.1454 7.91634 8.70817C7.91634 8.27095 7.5619 7.9165 7.12467 7.9165C6.68745 7.9165 6.33301 8.27095 6.33301 8.70817C6.33301 9.1454 6.68745 9.49984 7.12467 9.49984Z"
      fill="#28283C"
    />,
    <path
      key={7}
      d="M11.8747 15.8333C12.3119 15.8333 12.6663 15.4789 12.6663 15.0417C12.6663 14.6044 12.3119 14.25 11.8747 14.25C11.4374 14.25 11.083 14.6044 11.083 15.0417C11.083 15.4789 11.4374 15.8333 11.8747 15.8333Z"
      fill="#28283C"
    />,
    <path
      key={8}
      d="M11.8747 12.6668C12.3119 12.6668 12.6663 12.3124 12.6663 11.8752C12.6663 11.4379 12.3119 11.0835 11.8747 11.0835C11.4374 11.0835 11.083 11.4379 11.083 11.8752C11.083 12.3124 11.4374 12.6668 11.8747 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={9}
      d="M11.8747 9.49984C12.3119 9.49984 12.6663 9.1454 12.6663 8.70817C12.6663 8.27095 12.3119 7.9165 11.8747 7.9165C11.4374 7.9165 11.083 8.27095 11.083 8.70817C11.083 9.1454 11.4374 9.49984 11.8747 9.49984Z"
      fill="#28283C"
    />,
    <path
      key={10}
      d="M14.2497 12.6668C14.6869 12.6668 15.0413 12.3124 15.0413 11.8752C15.0413 11.4379 14.6869 11.0835 14.2497 11.0835C13.8124 11.0835 13.458 11.4379 13.458 11.8752C13.458 12.3124 13.8124 12.6668 14.2497 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={11}
      d="M14.2497 9.49984C14.6869 9.49984 15.0413 9.1454 15.0413 8.70817C15.0413 8.27095 14.6869 7.9165 14.2497 7.9165C13.8124 7.9165 13.458 8.27095 13.458 8.70817C13.458 9.1454 13.8124 9.49984 14.2497 9.49984Z"
      fill="#28283C"
    />,
    <path
      key={12}
      d="M9.49967 15.8333C9.9369 15.8333 10.2913 15.4789 10.2913 15.0417C10.2913 14.6044 9.9369 14.25 9.49967 14.25C9.06245 14.25 8.70801 14.6044 8.70801 15.0417C8.70801 15.4789 9.06245 15.8333 9.49967 15.8333Z"
      fill="#28283C"
    />,
    <path
      key={13}
      d="M9.49967 12.6668C9.9369 12.6668 10.2913 12.3124 10.2913 11.8752C10.2913 11.4379 9.9369 11.0835 9.49967 11.0835C9.06245 11.0835 8.70801 11.4379 8.70801 11.8752C8.70801 12.3124 9.06245 12.6668 9.49967 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={14}
      d="M9.49967 9.49984C9.9369 9.49984 10.2913 9.1454 10.2913 8.70817C10.2913 8.27095 9.9369 7.9165 9.49967 7.9165C9.06245 7.9165 8.70801 8.27095 8.70801 8.70817C8.70801 9.1454 9.06245 9.49984 9.49967 9.49984Z"
      fill="#28283C"
    />
  ]
};

export const CalendarThin = {
  viewBox: "0 0 24 24",
  strokeOutline: true,
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      d="M16 2V6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={3}
      d="M8 2V6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={4}
      d="M3 10H21"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const Cancel = {
  viewBox: "0 0 20 20",
  body: () => [
    <path
      key="cancel-path"
      d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z"
      fill="#822D50"
    />
  ]
};

export const CartCheck = {
  viewBox: "0 0 32 32",
  body: () => (
    <>
      <path
        // style="stroke-width:0.0032425"
        // id="path4"
        d="m 23.805109,1.065325 c -2.542406,0.364159 -4.702765,2.013016 -5.673555,4.33481 -0.200493,0.475564 -0.494701,1.57448 -0.494701,1.846231 v 0.166462 l -5.648412,0.01868 C 6.6156258,7.449858 6.3210908,7.456298 6.0644339,7.567383 5.9142275,7.629203 5.7888379,7.672348 5.7764296,7.660113 5.7640216,7.647873 5.6823876,6.925356 5.5948758,6.060841 L 5.4384653,4.486361 5.2441766,4.319576 5.0502145,4.146673 H 2.7331184 0.4163489 L 0.22859099,4.313455 c -0.38825074,0.345805 -0.2628611,0.926334 0.23184021,1.061888 0.14400216,0.04315 0.9580552,0.06794 2.0101527,0.06794 0.9707901,0 1.7659041,0.01868 1.7659041,0.04315 0,0.407626 1.5905546,15.467895 1.6594536,15.733206 0.1126547,0.419854 0.3569033,0.82748 0.6824592,1.136258 l 0.2191053,0.209931 -0.1564105,0.24084 c -0.2880043,0.450772 -0.3506991,0.870633 -0.3255559,2.204272 0.018612,1.092798 0.031347,1.241231 0.1564105,1.506542 0.1877579,0.401509 0.4509456,0.722522 0.7513583,0.90766 l 0.2504527,0.154228 -0.031347,0.401509 c -0.056491,0.82137 0.2380444,1.580597 0.8454005,2.179801 1.2522637,1.234791 3.2751513,1.086681 4.3334523,-0.314896 0.344495,-0.450771 0.519845,-0.932452 0.557396,-1.543569 l 0.03135,-0.506474 h 2.335708 2.341913 v 0.351923 c 0.0062,1.333639 0.983199,2.519168 2.304361,2.790919 1.308755,0.27175 2.611305,-0.376716 3.193844,-1.580598 0.194289,-0.407626 0.22531,-0.537384 0.250453,-1.05577 0.01861,-0.500357 0.0062,-0.66682 -0.112655,-1.000391 -0.707602,-2.074836 -3.312703,-2.655043 -4.840562,-1.080563 l -0.275598,0.277868 H 15.551924 12.69637 L 12.351875,26.159441 C 11.368677,25.189961 9.8594297,25.054085 8.6884734,25.82587 8.4817764,25.961746 8.2502627,26.159441 8.174833,26.264406 L 8.037035,26.449544 7.8430729,26.258289 7.6487842,26.067033 7.6298452,24.912414 c -0.025143,-1.247348 0.0062,-1.420251 0.3007392,-1.624064 0.1691454,-0.117201 0.3631075,-0.117201 8.1157136,-0.135876 l 7.946569,-0.01868 0.413394,-0.141993 c 0.745154,-0.246958 1.452756,-0.802694 1.834803,-1.445043 0.08751,-0.154229 0.726541,-1.914168 1.421409,-3.914949 1.221243,-3.538233 1.258794,-3.643199 1.484104,-3.822219 1.503043,-1.191646 2.454894,-2.729098 2.774246,-4.476802 0.118859,-0.65458 0.100246,-1.951191 -0.03135,-2.593541 C 31.450936,4.70144 30.217611,2.997202 28.407625,1.953667 27.061646,1.176408 25.339497,0.84895505 23.805107,1.065325 Z m 2.411138,1.413812 c 2.135216,0.537062 3.75124,2.130217 4.295902,4.248197 0.269391,1.031301 0.194288,2.445112 -0.162615,3.352773 -0.701725,1.753822 -1.972928,2.964143 -3.707484,3.55079 C 25.990938,13.846945 25.364643,13.921 24.513038,13.883972 23.02273,13.822162 21.857978,13.328236 20.768329,12.31561 19.91052,11.519033 19.384471,10.630047 19.071323,9.481547 18.877035,8.7777 18.877035,7.536469 19.065123,6.770802 c 0.187758,-0.753432 0.720011,-1.79085 1.202304,-2.36494 0.908095,-1.074446 2.273014,-1.833995 3.663402,-2.050043 0.588417,-0.08661 1.678066,-0.03091 2.285422,0.123318 z m -8.529108,6.76157 c 0.288005,1.945078 1.553003,3.828335 3.299968,4.902781 1.127201,0.69773 2.141747,0.994273 3.525604,1.037418 1.026955,0.03703 1.621902,-0.02479 2.317096,-0.240841 0.219106,-0.06794 0.40719,-0.111083 0.413394,-0.09885 0.04376,0.0557 -2.079051,6.039047 -2.204114,6.21195 -0.169146,0.228609 -0.432007,0.4321 -0.826462,0.635913 l -0.2818,0.14811 H 16.008747 8.0873215 L 7.8368687,21.701313 C 7.5488644,21.553202 7.3611064,21.361624 7.2233085,21.089873 7.1482055,20.94788 6.9666515,19.385636 6.5532576,15.415307 6.2463142,12.4019 5.9896572,9.79612 5.9896572,9.617101 c 0,-0.351925 0.1315939,-0.598882 0.413394,-0.784343 C 6.5784008,8.721675 6.8037103,8.715557 12.095218,8.715557 h 5.516818 z M 11.086877,26.79535 c 0.519844,0.277869 0.78891,0.747315 0.78891,1.370667 0,0.438536 -0.09404,0.691612 -0.382047,1.018743 -0.45715,0.506474 -1.221243,0.66682 -1.8472114,0.376716 C 9.2772169,29.394691 8.919987,29.00574 8.8200672,28.666051 c -0.094042,-0.296543 -0.094042,-0.808812 -0.0062,-1.037418 0.1815537,-0.475563 0.6449077,-0.888985 1.139609,-1.012625 0.3131478,-0.07373 0.7951138,3.22e-4 1.1334048,0.179342 z m 10.457626,0 c 0.688664,0.370599 0.995607,1.235114 0.695195,1.975989 -0.131594,0.321013 -0.620091,0.765667 -0.958056,0.864515 -0.582539,0.172903 -1.271202,0.0061 -1.653249,-0.395069 -0.582213,-0.611439 -0.5636,-1.599273 0.03755,-2.185919 0.532252,-0.506474 1.233651,-0.605322 1.878558,-0.259516 z"
      />
      <path
        // style="stroke-width:0.00483537"
        // id="path6"
        d="M 26.888654,4.8813344 C 26.546446,5.0394996 26.614786,4.9693639 25.177105,6.9475633 24.570718,7.7915661 24.003602,8.5388376 23.915372,8.5915598 23.641505,8.7937355 23.318677,8.7148853 22.888239,8.354084 22.389462,7.9497313 21.998294,7.7915661 21.645886,7.8704205 c -0.596695,0.1320301 -0.987863,0.7825718 -0.762955,1.2662352 0.146876,0.3254983 2.376586,2.1890923 2.699414,2.2684033 0.322828,0.07014 0.850675,-0.04401 1.017443,-0.219597 0.459507,-0.465783 3.716347,-5.0906146 3.765308,-5.3368007 0.06833,-0.3603408 -0.17595,-0.7912821 -0.557428,-0.9673269 -0.361587,-0.1668754 -0.557426,-0.1668754 -0.919014,0 z"
      />
    </>
  )
};

export const CheckTag = {
  viewBox: "0 0 269.125 269.125",
  pathOutline: true,
  body: () => (
    <g>
      <path d="m262.125,54.661h-255.125c-3.866,0-7,3.134-7,7v145.804c0,3.866 3.134,7 7,7h255.125c3.866,0 7-3.134 7-7v-145.804c0-3.867-3.134-7-7-7zm-7,145.803h-241.125v-131.803h241.125v131.803z" />
      <path d="m41.507,102.96h186.111c3.866,0 7-3.134 7-7s-3.134-7-7-7h-186.111c-3.866,0-7,3.134-7,7s3.134,7 7,7z" />
      <path d="m41.507,125.458h186.111c3.866,0 7-3.134 7-7s-3.134-7-7-7h-186.111c-3.866,0-7,3.134-7,7s3.134,7 7,7z" />
      <path d="m41.507,147.955h186.111c3.866,0 7-3.134 7-7s-3.134-7-7-7h-186.111c-3.866,0-7,3.134-7,7s3.134,7 7,7z" />
      <path d="m229.176,170.851h-36.901c-3.866,0-7,3.134-7,7s3.134,7 7,7h36.901c3.866,0 7-3.134 7-7s-3.134-7-7-7z" />
    </g>
  )
};

export const ChevronDown = {
  viewBox: "0 0 12 8",
  body: () => (
    <path d="M 10.59,7.15493e-8 12,1.4100001 6,7.41 7.15493e-8,1.4100001 1.41,7.15493e-8 6,4.5800001 Z" />
  )
};

export const ChevronLeft = {
  viewBox: "0 0 20 20",
  body: () => (
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#565A5C"
      strokeLinecap="square"
      strokeWidth="2"
      d="M11.86 3L5 10l6.86 6.62"
    />
  )
};

export const ChevronNext = {
  viewBox: "0 0 8 12",
  body: () => (
    <path d="M0.59 10.59L2 12L8 6L2 -5.24537e-07L0.590001 1.41L5.17 6L0.59 10.59Z" />
  )
};

export const ChevronPrev = {
  viewBox: "0 0 8 12",
  body: () => <path d="M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z" />
};

export const ChevronUp = {
  viewBox: "0 0 12 8",
  body: () => (
    <path d="M10.59 7.41L12 6L6 7.15493e-08L7.15493e-08 6L1.41 7.41L6 2.83L10.59 7.41Z" />
  )
};

export const ChevronThick = {
  viewBox: "0 0 9 14",
  body: () => (
    <path
      d="M1.83329 0.5L0.305786 2.0275L5.26746 7L0.305786 11.9725L1.83329 13.5L8.33329 7L1.83329 0.5Z"
      fill="#000"
    />
  )
};

export const CirclePlus = {
  viewBox: "0 0 28 28",
  body: () => [
    <path
      key={1}
      d="M14.1818 1.18175C7.10253 1.18175 1.36364 6.92065 1.36364 13.9999C1.36364 21.0792 7.10253 26.8181 14.1818 26.8181C21.2611 26.8181 27 21.0792 27 13.9999C27 6.92065 21.2611 1.18175 14.1818 1.18175Z"
      fill="transparent"
      stroke="#03C2B9"
      strokeWidth="2"
    />,
    <path
      key={2}
      d="M14.1816 8.48486V20.303"
      stroke="#03C2B9"
      strokeWidth="1.8"
    />,
    <path
      key={3}
      d="M7.87891 14L20.485 14"
      stroke="#03C2B9"
      strokeWidth="1.8"
    />
  ]
};

export const CircleMinus = {
  viewBox: "0 0 28 28",
  body: () => [
    <path
      key={1}
      d="M14.1818 1.18175C7.10253 1.18175 1.36364 6.92065 1.36364 13.9999C1.36364 21.0792 7.10253 26.8181 14.1818 26.8181C21.2611 26.8181 27 21.0792 27 13.9999C27 6.92065 21.2611 1.18175 14.1818 1.18175Z"
      fill="white"
      stroke="#03C2B9"
      strokeWidth="2"
    />,
    <path
      key={2}
      d="M7.87891 14L20.485 14"
      stroke="#03C2B9"
      strokeWidth="1.8"
    />
  ]
};

export const Clock = {
  viewBox: "0 0 20 20",
  strokeOutline: true,
  body: () => (
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2 2)">
        <circle cx="8" cy="8" r="7.5" />
        <path strokeLinecap="square" d="M12.968 8H8V3.04" />
      </g>
    </g>
  )
};

export const Clock12h20m = {
  viewBox: "0 0 20 20",
  body: () => [
    <path
      key={0}
      d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
    />,
    <path key={1} d="M10.5 5H9V11L14.25 14.15L15 12.92L10.5 10.25V5Z" />
  ]
};

export const ClipBoard = {
  viewBox: "0 0 384 512",
  body: () => (
    <path d="M320 64h-49.61C262.1 27.48 230.7 0 192 0S121 27.48 113.6 64H64C28.65 64 0 92.66 0 128v320c0 35.34 28.65 64 64 64h256c35.35 0 64-28.66 64-64V128C384 92.66 355.3 64 320 64zM192 48c13.23 0 24 10.77 24 24S205.2 96 192 96S168 85.23 168 72S178.8 48 192 48zM336 448c0 8.82-7.178 16-16 16H64c-8.822 0-16-7.18-16-16V128c0-8.82 7.178-16 16-16h18.26C80.93 117.1 80 122.4 80 128v16C80 152.8 87.16 160 96 160h192c8.836 0 16-7.164 16-16V128c0-5.559-.9316-10.86-2.264-16H320c8.822 0 16 7.18 16 16V448z" />
  )
};

export const Cog = {
  viewBox: "0 0 24 24",
  strokeOutline: true,
  body: () => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4 15C19.1277 15.6171 19.2583 16.3378 19.73 16.82L19.79 16.88C20.1656 17.2551 20.3766 17.7642 20.3766 18.295C20.3766 18.8258 20.1656 19.3349 19.79 19.71C19.4149 20.0856 18.9058 20.2966 18.375 20.2966C17.8442 20.2966 17.3351 20.0856 16.96 19.71L16.9 19.65C16.4178 19.1783 15.6971 19.0477 15.08 19.32C14.4755 19.5791 14.0826 20.1724 14.08 20.83V21C14.08 22.1046 13.1846 23 12.08 23C10.9754 23 10.08 22.1046 10.08 21V20.91C10.0642 20.2327 9.63587 19.6339 9 19.4C8.38291 19.1277 7.66219 19.2583 7.18 19.73L7.12 19.79C6.74486 20.1656 6.23582 20.3766 5.705 20.3766C5.17418 20.3766 4.66514 20.1656 4.29 19.79C3.91445 19.4149 3.70343 18.9058 3.70343 18.375C3.70343 17.8442 3.91445 17.3351 4.29 16.96L4.35 16.9C4.82167 16.4178 4.95235 15.6971 4.68 15.08C4.42093 14.4755 3.82764 14.0826 3.17 14.08H3C1.89543 14.08 1 13.1846 1 12.08C1 10.9754 1.89543 10.08 3 10.08H3.09C3.76733 10.0642 4.36613 9.63587 4.6 9C4.87235 8.38291 4.74167 7.66219 4.27 7.18L4.21 7.12C3.83445 6.74486 3.62343 6.23582 3.62343 5.705C3.62343 5.17418 3.83445 4.66514 4.21 4.29C4.58514 3.91445 5.09418 3.70343 5.625 3.70343C6.15582 3.70343 6.66486 3.91445 7.04 4.29L7.1 4.35C7.58219 4.82167 8.30291 4.95235 8.92 4.68H9C9.60447 4.42093 9.99738 3.82764 10 3.17V3C10 1.89543 10.8954 1 12 1C13.1046 1 14 1.89543 14 3V3.09C14.0026 3.74764 14.3955 4.34093 15 4.6C15.6171 4.87235 16.3378 4.74167 16.82 4.27L16.88 4.21C17.2551 3.83445 17.7642 3.62343 18.295 3.62343C18.8258 3.62343 19.3349 3.83445 19.71 4.21C20.0856 4.58514 20.2966 5.09418 20.2966 5.625C20.2966 6.15582 20.0856 6.66486 19.71 7.04L19.65 7.1C19.1783 7.58219 19.0477 8.30291 19.32 8.92V9C19.5791 9.60447 20.1724 9.99738 20.83 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H20.91C20.2524 14.0026 19.6591 14.3955 19.4 15Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
};

export const CommentRight = {
  viewBox: "0 0 89 86",
  body: () => (
    <path d="M1.01363 46.7054C4.3724 62.046 19.7866 72.1381 38.163 72.6973C40.6368 72.7725 42.9429 73.9449 44.5913 75.7854C52.2659 84.3547 64.1728 88.1238 75.7568 84.7485C75.8057 84.7373 75.8533 84.72 75.9028 84.7113C75.9266 84.7072 75.952 84.7039 75.985 84.6963C75.9567 84.7028 75.9281 84.6991 75.9093 84.7034C76.8967 84.4293 77.72 83.6322 77.9443 82.5496C78.264 81.0263 77.3407 79.5301 75.8778 79.1607C75.6748 79.11 75.4651 79.0933 75.2571 79.0923C75.2313 79.0922 75.2025 79.0866 75.1766 79.0863C74.95 79.0915 74.7215 79.1236 74.5003 79.1801C74.7184 79.1181 74.9445 79.0928 75.1766 79.0863C75.2043 79.0859 75.2289 79.0905 75.2571 79.0923C75.4039 79.0931 75.55 79.092 75.705 79.1213C69.7783 78.004 64.9167 73.939 62.7137 68.2269C62.5992 67.9882 62.7515 67.7046 62.993 67.5934C80.7325 59.4266 91.4972 42.8385 87.9921 26.8296C83.8126 7.74027 60.9509 -3.29362 36.9391 2.19347C12.925 7.68086 -3.16591 27.6161 1.01363 46.7054ZM74.5128 84.7215C74.5187 84.7227 74.5256 84.7223 74.5198 84.7236C74.5132 84.7251 74.4993 84.7271 74.4933 84.7243C74.4825 84.7192 74.4776 84.7114 74.4613 84.7086C74.4788 84.7116 74.4956 84.7177 74.5128 84.7215Z" />
  )
};

export const Connectivity = {
  viewBox: "0 0 17 13",
  body: () => (
    <g>
      <path d="M8.89656 0.0191259C9.09044 0.02777 9.34945 0.0453669 9.65261 0.0839566C10.2915 0.167931 10.9204 0.316039 11.5296 0.526041C12.3946 0.825426 13.2142 1.24251 13.9654 1.76554C14.7649 2.32025 15.4812 2.98605 16.0928 3.74288C16.3246 4.02783 16.3138 4.26924 16.0604 4.53289C15.8939 4.70618 15.7274 4.87948 15.5609 5.05277C15.5195 5.09818 15.4686 5.13386 15.4118 5.15723C15.355 5.1806 15.2938 5.19109 15.2324 5.18793C15.1711 5.18477 15.1112 5.16805 15.0572 5.13896C15.0031 5.10988 14.9561 5.06916 14.9196 5.01974C13.979 3.8216 12.8154 2.91366 11.4003 2.34501C8.01023 0.985104 4.17194 2.0227 1.87632 4.91261C1.54691 5.32753 1.42034 5.3334 1.05204 4.95182C0.906943 4.80147 0.76061 4.65205 0.617674 4.49986C0.526204 4.40202 0.473523 4.2742 0.469488 4.14032C0.465454 4.00645 0.510343 3.87569 0.595755 3.77252C1.11162 3.1452 2.21158 1.8986 3.85057 1.09501C3.85057 1.09501 5.28178 0.393292 6.73276 0.134895C6.96213 0.0941444 7.18812 0.0654336 7.18812 0.0654336C7.29678 0.0515413 7.48078 0.0286961 7.72312 0.0138777C7.88397 0.0039987 8.08031 -0.00248432 8.30444 0.000911574L8.89656 0.0191259Z" />
      <path d="M8.74987 12.4117C8.64398 12.4491 8.34853 12.5371 8.02531 12.4182C7.59588 12.2602 7.28438 11.7965 7.33285 11.2911C7.38009 10.7971 7.75147 10.3958 8.23894 10.3356C8.66312 10.2828 8.999 10.4529 9.22313 10.8092C9.34233 10.986 9.40557 11.1946 9.40463 11.4078C9.4037 11.6211 9.33863 11.8291 9.21788 12.0048C9.11721 12.1589 8.98161 12.287 8.82211 12.3787L8.74987 12.4117Z" />
      <path d="M8.37181 3.50395C10.6177 3.56291 12.399 4.51407 13.7454 6.30216C13.9102 6.52135 13.8864 6.7992 13.695 7.00357C13.5036 7.20794 13.3128 7.4049 13.1193 7.60248C12.9066 7.82044 12.7099 7.80531 12.5407 7.55155C12.0808 6.86187 11.497 6.30402 10.7743 5.89651C8.52278 4.62737 5.71375 5.30995 4.23283 7.48085C4.20004 7.53456 4.16385 7.58612 4.12447 7.63521C3.99481 7.78123 3.80619 7.79821 3.66819 7.66207C3.44128 7.43855 3.219 7.20949 3.00568 6.97301C2.83249 6.78068 2.82878 6.50839 2.98808 6.29383C4.07107 4.8444 5.48499 3.9201 7.27741 3.60027C7.40584 3.57742 7.53488 3.55643 7.66454 3.54346C7.89923 3.51534 8.13546 3.50215 8.37181 3.50395Z" />
      <path d="M8.39333 7.01147C9.67111 7.04235 10.7322 7.56192 11.5669 8.54951C11.7454 8.76067 11.7333 9.03697 11.5395 9.24536C11.3403 9.45961 11.136 9.66892 10.9307 9.8773C10.7507 10.0601 10.5574 10.0496 10.3997 9.84427C10.2665 9.663 10.1134 9.4973 9.94309 9.35032C8.86258 8.45658 7.32609 8.6094 6.44161 9.69825C6.4021 9.74671 6.36598 9.79796 6.32646 9.84674C6.16469 10.0462 5.97483 10.0573 5.79423 9.8736C5.59295 9.66779 5.39362 9.46095 5.19625 9.25308C4.98632 9.02956 4.98261 8.75573 5.18359 8.52203C6.02299 7.54648 7.08313 7.03679 8.39333 7.01147Z" />
    </g>
  )
};

export const Contrast = {
  viewBox: "0 0 50 50",
  body: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 0C11.2 0 0 11.2 0 25C0 38.8 11.2 50 25 50C38.8 50 50 38.8 50 25C50 11.2 38.8 0 25 0ZM22.5 44.825C12.65 43.6 5 35.2 5 25C5 14.8 12.625 6.4 22.5 5.175V44.825ZM27.5 5.175C30.075 5.5 32.5 6.3 34.675 7.5H27.5V5.175ZM27.5 12.5H40.6C41.225 13.275 41.8 14.125 42.3 15H27.5V12.5ZM27.5 20H44.35C44.55 20.825 44.725 21.65 44.825 22.5H27.5V20ZM27.5 44.825V42.5H34.675C32.5 43.7 30.075 44.5 27.5 44.825ZM40.6 37.5H27.5V35H42.3C41.8 35.875 41.225 36.725 40.6 37.5ZM44.35 30H27.5V27.5H44.825C44.725 28.35 44.55 29.175 44.35 30Z"
    />
  )
};

export const Copy = {
  viewBox: "0 0 640 640",
  body: () => (
    <path
      fill="#000"
      d="M192 192v-128c0-35.2 28.8-64 64-64h320c35.346 0 64 28.654 64 64v0 320c0 35.346-28.654 64-64 64v0h-128v128c0 35.346-28.654 64-64 64v0h-320c-35.346 0-64-28.654-64-64v0-320c0-35.2 28.8-64 64-64h128zM256 192h128c35.346 0 64 28.654 64 64v0 128h128v-320h-320v128zM64 256v320h320v-320h-320z"
    />
  )
};

export const CricleCross = {
  viewBox: "0 0 20 20",
  body: () => (
    <path
      d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z"
      fill="#FBB231"
    />
  )
};

export const Cross = {
  viewBox: "0 0 20 20",
  strokeOutline: true,
  body: () => (
    <g fill="none" fillRule="evenodd" strokeLinecap="square" strokeWidth="2">
      <path d="M3 3l13.86 13.86M16.86 3L3 16.86" />
    </g>
  )
};

export const CubeCorners = {
  viewBox: "0 0 50 50",
  body: () => [
    <path
      key={1}
      d="M40 15C42.75 15 45 12.75 45 10C45 7.25 42.75 5 40 5C37.25 5 35 7.25 35 10C35 12.75 37.25 15 40 15Z"
    />,
    <path
      key={2}
      d="M40 35C42.75 35 45 32.75 45 30C45 27.25 42.75 25 40 25C37.25 25 35 27.25 35 30C35 32.75 37.25 35 40 35Z"
    />,
    <path
      key={3}
      d="M10 15C7.25 15 5 17.25 5 20C5 22.75 7.25 25 10 25C12.75 25 15 22.75 15 20C15 17.25 12.75 15 10 15Z"
    />,
    <path
      key={4}
      d="M20 5C17.25 5 15 7.25 15 10C15 12.75 17.25 15 20 15C22.75 15 25 12.75 25 10C25 7.25 22.75 5 20 5Z"
    />,
    <path
      key={5}
      d="M30 35C27.25 35 25 37.25 25 40C25 42.75 27.25 45 30 45C32.75 45 35 42.75 35 40C35 37.25 32.75 35 30 35Z"
    />,
    <path
      key={6}
      d="M10 45C12.75 45 15 42.75 15 40C15 37.25 12.75 35 10 35C7.25 35 5 37.25 5 40C5 42.75 7.25 45 10 45Z"
    />,
    <path
      key={7}
      d="M30 15C27.25 15 25 17.25 25 20C25 22.75 27.25 25 30 25C32.75 25 35 22.75 35 20C35 17.25 32.75 15 30 15Z"
    />,
    <path
      key={8}
      d="M25 30C25 32.75 22.75 35 20 35C17.25 35 15 32.75 15 30C15 27.25 17.25 25 20 25C22.75 25 25 27.25 25 30Z"
    />
  ]
};

export const Cutlery = {
  viewBox: "0 0 25 28",
  pathOutline: true,
  body: () => (
    <path
      d="M11.8754 22.0108L8.93272 26.7408C8.73981 27.0484 8.49117 27.3126 8.20114 27.5181C7.91112 27.7237 7.58545 27.8666 7.24289 27.9386C7.07898 27.9734 6.91224 27.991 6.74507 27.9912C6.252 27.9929 5.76996 27.8371 5.36223 27.5442C5.07731 27.3406 4.83485 27.0775 4.64976 26.7711C4.46467 26.4648 4.34085 26.1217 4.28594 25.7629C4.23102 25.4042 4.24615 25.0373 4.33041 24.685C4.41468 24.3326 4.56628 24.0022 4.7759 23.7141L8.82763 18.1631C8.96406 17.9779 9.16454 17.8576 9.38498 17.8285C9.60541 17.7995 9.82774 17.8642 10.003 18.0083C10.1784 18.1524 10.2923 18.3642 10.3198 18.597C10.3473 18.8299 10.2861 19.0647 10.1496 19.2499L6.0979 24.8009C6.02661 24.8997 5.97519 25.0129 5.94681 25.1334C5.91842 25.254 5.91367 25.3794 5.93284 25.502C5.952 25.6246 5.99469 25.7417 6.05826 25.8462C6.12184 25.9507 6.20498 26.0404 6.30256 26.1098C6.48609 26.2369 6.70985 26.2821 6.92484 26.2354C7.05091 26.2086 7.17075 26.1559 7.27752 26.0802C7.38429 26.0045 7.4759 25.9073 7.54712 25.7942L10.4898 21.0467C10.5456 20.9419 10.6212 20.8503 10.7119 20.7776C10.8026 20.705 10.9065 20.6528 11.0172 20.6244C11.1278 20.596 11.2428 20.592 11.3549 20.6125C11.4671 20.6331 11.5741 20.6778 11.6692 20.7439C11.7643 20.81 11.8455 20.8961 11.9077 20.9968C11.97 21.0975 12.012 21.2106 12.0311 21.3292C12.0502 21.4477 12.0459 21.5692 12.0187 21.6859C11.9914 21.8027 11.9417 21.9123 11.8726 22.0079L11.8754 22.0108ZM23.4387 0.683431C22.3325 -0.155056 20.8279 -0.225173 19.2266 0.490608C17.6282 1.26208 16.2583 2.47793 15.2634 4.00816C13.8225 6.14382 13.1504 8.60085 13.4657 10.5817C13.5248 10.9737 13.4915 11.3751 13.3689 11.7503C13.3028 11.969 13.3207 12.2064 13.4186 12.4114C13.5165 12.6164 13.6866 12.7726 13.8924 12.8465C14.0982 12.9204 14.3232 12.906 14.5191 12.8064C14.7149 12.7069 14.866 12.5301 14.9398 12.3142C15.1513 11.6638 15.2074 10.9683 15.103 10.2895C14.8623 8.77907 15.4431 6.76319 16.6158 5.03071C17.4339 3.76231 18.5629 2.7525 19.8821 2.10915C20.4905 1.83745 21.6383 1.4781 22.4846 2.10915C23.3309 2.74021 23.3834 4.01109 23.3392 4.70642C23.1916 6.23483 22.6533 7.69208 21.7821 8.92223C20.6094 10.6752 18.9915 11.8993 17.5617 12.1505C16.9277 12.2609 16.3288 12.5327 15.8165 12.9423C15.6789 13.0536 15.5477 13.1736 15.4238 13.3016C15.2749 13.4659 15.1922 13.6848 15.1932 13.9122C15.1943 14.1396 15.2789 14.3577 15.4294 14.5204C15.5798 14.683 15.7842 14.7776 15.9994 14.7841C16.2145 14.7905 16.4237 14.7084 16.5826 14.555C16.6585 14.4768 16.7388 14.4036 16.8232 14.3359C17.1157 14.0982 17.4582 13.9389 17.8216 13.8713C19.6885 13.5412 21.6825 12.0687 23.1234 9.93016C24.1726 8.43429 24.816 6.66473 24.9847 4.81159C25.1009 2.97978 24.5505 1.51023 23.4387 0.671745V0.683431ZM11.4854 11.4318C11.7315 10.8155 11.8241 10.1429 11.7544 9.47806C11.6847 8.81323 11.455 8.17832 11.0872 7.63382L6.15321 0.359138C6.02406 0.17326 5.83076 0.0486333 5.61522 0.0122653C5.39968 -0.0241026 5.17925 0.0307181 5.0017 0.164847C4.82416 0.298977 4.7038 0.501609 4.66671 0.728833C4.62962 0.956057 4.67879 1.18957 4.80356 1.37876L9.73201 8.65929C9.93738 8.96303 10.0647 9.31783 10.1015 9.68907C10.1384 10.0603 10.0835 10.4353 9.9422 10.7774C9.82838 11.0423 9.78448 11.3347 9.81515 11.6237C9.84583 11.9128 9.94993 12.1877 10.1164 12.4193L19.2432 24.8885C19.3073 24.9771 19.3539 25.0784 19.3803 25.1863C19.4067 25.2943 19.4122 25.4068 19.3967 25.5171C19.3811 25.6273 19.3447 25.7332 19.2897 25.8283C19.2347 25.9235 19.1621 26.006 19.0764 26.071C18.9906 26.136 18.8933 26.1821 18.7904 26.2066C18.6874 26.2311 18.5808 26.2335 18.477 26.2137C18.3731 26.1939 18.274 26.1522 18.1857 26.0912C18.0974 26.0302 18.0215 25.9511 17.9627 25.8585L9.69329 12.7407C9.53847 12.4999 9.32484 12.3078 9.07504 12.1849C8.82525 12.062 8.54862 12.0127 8.27449 12.0425C7.92142 12.0783 7.56561 12.0163 7.24213 11.8626C6.91865 11.7089 6.63867 11.4688 6.42978 11.166L1.49857 3.88546C1.36941 3.69958 1.17612 3.57495 0.960574 3.53859C0.745031 3.50222 0.524604 3.55704 0.34706 3.69117C0.169516 3.8253 0.0491581 4.02793 0.0120689 4.25515C-0.0250202 4.48238 0.0241471 4.71589 0.148916 4.90508L5.08566 12.1856C5.45643 12.7282 5.9525 13.1616 6.52666 13.4444C7.10082 13.7272 7.73394 13.85 8.36576 13.8012L16.5826 26.846C16.7639 27.1359 16.9991 27.3838 17.2739 27.5746C17.5487 27.7655 17.8574 27.8953 18.1812 27.9562C18.329 27.985 18.4789 27.9997 18.6292 28C19.0866 27.9998 19.5348 27.8642 19.923 27.6086C20.3112 27.3529 20.6238 26.9875 20.8253 26.5538C21.0269 26.12 21.1093 25.6353 21.0634 25.1545C21.0174 24.6738 20.8448 24.2163 20.5652 23.8339L11.4854 11.4318ZM7.6771 10.2632C7.82958 10.2629 7.97901 10.2181 8.10899 10.1339C8.23897 10.0497 8.34447 9.92933 8.41391 9.78594C8.48335 9.64254 8.51405 9.48171 8.50263 9.3211C8.49121 9.16049 8.43811 9.0063 8.34916 8.87548L3.8494 2.07409C3.72324 1.88348 3.53056 1.75362 3.31376 1.71307C3.09696 1.67253 2.87379 1.72462 2.69334 1.8579C2.5129 1.99117 2.38997 2.19471 2.35159 2.42373C2.31321 2.65275 2.36252 2.8885 2.48868 3.07911L6.99675 9.8805C7.0733 9.99606 7.17512 10.0904 7.29357 10.1555C7.41201 10.2206 7.54358 10.2546 7.6771 10.2545V10.2632Z"
      // fill="#03C2B9"
    />
  )
};

export const Delivery = {
  viewBox: "0 0 51 32",
  body: () => (
    <>
      <path
        d="m 38.571885,8.877286 -3.295107,-0.0208 V 4.400603 c 0,-0.661518 -0.270431,-1.260628 -0.707283,-1.697479 C 34.132644,2.27043 33.533534,2 32.872016,2 h -21.90913 c -0.661518,0 -1.2606283,0.27043 -1.6974793,0.707282 -0.432692,0.432691 -0.707283,1.035963 -0.707283,1.697479 0,0.361963 0.291233,0.649038 0.649036,0.649038 0.361962,0 0.653196,-0.291235 0.653196,-0.649038 0,-0.303715 0.124821,-0.578308 0.3245193,-0.778011 0.199701,-0.1997 0.474296,-0.324519 0.778011,-0.324519 h 21.90913 c 0.299555,0 0.578308,0.124821 0.778011,0.324519 0.1997,0.199701 0.324519,0.474296 0.324519,0.778011 v 20.386392 h -3.673712 c -0.361963,0 -0.653196,0.291235 -0.653196,0.653198 0,0.361961 0.291233,0.653196 0.653196,0.653196 h 4.322748 c 0.361963,0 0.653196,-0.291235 0.653196,-0.653196 v -0.740569 h 2.629429 c 0.299555,-6.777434 10.030937,-7.713543 11.021132,0 h 2.138492 C 51.615015,18.096928 48.353193,15.525747 43.38973,14.947439 43.031927,13.395576 42.353769,11.956048 41.584079,10.533161 40.66461,8.839842 40.452425,8.90641 38.571885,8.877286 Z M 2.6876747,12.288887 c -0.403568,0 -0.732247,-0.291235 -0.732247,-0.649036 0,-0.357803 0.328679,-0.653196 0.732247,-0.653196 h 7.106113 c 0.4035673,0 0.7322463,0.291233 0.7322463,0.653196 0,0.361963 -0.328679,0.649036 -0.7322463,0.649036 z m -2.01367595,3.523932 c -0.898665,0 -0.898665,-1.310554 0,-1.310554 H 8.8160727 c 0.540864,0 0.973555,0.295395 0.973555,0.653198 0,0.361962 -0.436851,0.653196 -0.973555,0.653196 H 0.67399875 Z M 16.887422,24.786993 c 0.361961,0 0.653196,0.291235 0.653196,0.649036 0,0.361963 -0.291235,0.653198 -0.653196,0.653198 h -5.924536 c -0.657358,0 -1.2564682,-0.287075 -1.6974793,-0.740569 -0.432692,-0.453493 -0.7072829,-1.069245 -0.7072829,-1.726601 v -4.784562 c 0,-0.361963 0.2912329,-0.653196 0.649036,-0.653196 0.361962,0 0.653196,0.291233 0.653196,0.653196 v 4.784562 c 0,0.312035 0.128981,0.61159 0.3369992,0.827937 0.199701,0.208024 0.465976,0.336999 0.757209,0.336999 z m 6.619336,-3.607143 c -2.433886,0 -4.410118,1.976232 -4.410118,4.410117 0,2.433885 1.976232,4.410117 4.410118,4.410117 2.433885,0 4.410117,-1.976232 4.410117,-4.410117 0,-2.433885 -1.972072,-4.410117 -4.410117,-4.410117 z m 0,2.716798 c -0.936111,0 -1.697479,0.75721 -1.697479,1.697479 0,0.936111 0.757208,1.697479 1.697479,1.697479 0.936109,0 1.697479,-0.757208 1.697479,-1.697479 -0.0042,-0.940269 -0.76137,-1.697479 -1.697479,-1.697479 z m 19.895454,-3.365834 c -2.433885,0 -4.410117,1.976232 -4.410117,4.410117 0,2.433886 1.976232,4.410118 4.410117,4.410118 2.433886,0 4.410118,-1.976232 4.410118,-4.410118 0,-2.433885 -1.972072,-4.410117 -4.410118,-4.410117 z m -1.693319,4.414277 c 0,0.936111 0.757208,1.697479 1.697479,1.697479 0.936109,0 1.697479,-0.757208 1.697479,-1.697479 0,-0.940271 -0.757208,-1.697479 -1.697479,-1.697479 -0.940271,0 -1.697479,0.76137 -1.697479,1.697479 z m -2.820811,-14.183103 -1.988714,-0.03744 v 4.227055 h 4.210415 c -0.520061,-1.510257 -1.285592,-2.891539 -2.221701,-4.189611 z"
        fillRule="evenodd"
      />
      <path d="m 4.5890177,8.760792 c -0.403567,0 -0.732246,-0.291233 -0.732246,-0.649036 0,-0.361961 0.328679,-0.653196 0.732246,-0.653196 h 6.1700033 c 0.403567,0 0.732246,0.291235 0.732246,0.653196 0,0.361963 -0.328679,0.649036 -0.732246,0.649036 z" />
    </>
  )
};
export const Currency = {
  viewBox: "0 0 18 21",
  pathOutline: true,
  body: () => (
    <g>
      <path
        d="M8.79415 0.917969C4.23918 0.917969 0.533203 4.62359 0.533203 9.17856C0.533203 13.7335 4.23918 17.4392 8.79415 17.4392C13.3491 17.4392 17.0547 13.7335 17.0547 9.17856C17.0547 4.62359 13.3491 0.917969 8.79415 0.917969ZM8.79415 15.9896C5.03827 15.9896 1.98275 12.9341 1.98275 9.17856C1.98275 5.42304 5.03827 2.36752 8.79415 2.36752C12.5497 2.36752 15.6052 5.42304 15.6052 9.17856C15.6052 12.9341 12.5497 15.9896 8.79415 15.9896Z"
        strokeWidth={0}
      />
      <path
        d="M7.808 7.66C7.808 6.976 8.144 6.484 8.9 6.484C9.692 6.484 10.16 7.024 10.184 8.008L11.468 7.948C11.468 6.316 10.508 5.296 8.804 5.296C7.28 5.296 6.26 6.22 6.26 7.624C6.26 8.104 6.38 8.464 6.536 8.8H5.684V9.676H7.004C7.148 9.976 7.268 10.288 7.292 10.684C7.064 10.588 6.812 10.528 6.548 10.528C5.72 10.528 5.132 11.044 5.132 11.812C5.132 12.652 5.732 13.144 6.536 13.144C7.196 13.144 7.712 12.856 8.06 12.388C8.564 12.784 9.2 13.144 10.052 13.144C11.24 13.144 11.936 12.352 11.828 10.696L10.748 10.636C10.748 11.464 10.496 11.836 9.788 11.836C9.296 11.836 8.888 11.632 8.492 11.38C8.54 11.152 8.564 10.9 8.564 10.636C8.564 10.276 8.504 9.964 8.408 9.676H9.704V8.8H8.048C7.916 8.452 7.808 8.092 7.808 7.66ZM6.56 12.268C6.284 12.268 6.068 12.1 6.068 11.836C6.068 11.536 6.248 11.38 6.548 11.38C6.764 11.38 6.98 11.5 7.208 11.68C7.088 12.052 6.884 12.268 6.56 12.268Z"
        strokeWidth={0}
      />
    </g>
  )
};

export const DiscountTag = {
  viewBox: "0 0 512.001 512.001",
  body: () => (
    <>
      <g>
        <g>
          <path
            d="M507.154,244.22l-43.447-43.875l15.689-59.721c2.333-8.881-2.923-17.984-11.78-20.403l-59.564-16.273l-16.273-59.564
			c-2.42-8.857-11.521-14.113-20.403-11.78l-59.72,15.69L267.78,4.846c-6.525-6.461-17.036-6.461-23.56,0l-43.875,43.448
			l-59.721-15.689c-8.883-2.333-17.983,2.923-20.403,11.78l-16.273,59.564l-59.564,16.273c-8.857,2.42-14.113,11.523-11.78,20.403
			l15.689,59.721L4.846,244.22c-6.461,6.525-6.461,17.036,0,23.56l43.448,43.875l-15.689,59.721
			c-2.333,8.881,2.923,17.984,11.78,20.403l59.564,16.273l16.273,59.564c2.42,8.857,11.521,14.114,20.403,11.78l59.721-15.689
			l43.875,43.448c3.262,3.231,7.521,4.846,11.78,4.846c4.259,0,8.518-1.615,11.78-4.846l43.875-43.448l59.721,15.689
			c8.882,2.331,17.983-2.923,20.403-11.78l16.273-59.564l59.564-16.273c8.857-2.42,14.113-11.523,11.78-20.403l-15.689-59.721
			l43.447-43.875C513.615,261.256,513.615,250.745,507.154,244.22z M433.191,294.885c-4.167,4.209-5.801,10.305-4.297,16.034
			l13.904,52.93l-52.79,14.422c-5.713,1.56-10.177,6.024-11.738,11.738l-14.422,52.79l-52.93-13.904
			c-5.73-1.505-11.825,0.128-16.034,4.297L256,471.697l-38.885-38.505c-3.175-3.144-7.424-4.846-11.781-4.846
			c-1.417,0-2.846,0.181-4.252,0.55l-52.93,13.904l-14.422-52.79c-1.56-5.713-6.024-10.177-11.738-11.738l-52.79-14.422
			l13.904-52.93c1.505-5.728-0.129-11.825-4.297-16.034l-38.505-38.885l38.505-38.885c4.168-4.209,5.802-10.305,4.297-16.034
			l-13.904-52.932l52.79-14.422c5.713-1.56,10.177-6.024,11.738-11.738l14.422-52.79l52.93,13.904
			c5.729,1.506,11.825-0.129,16.034-4.297L256,40.302l38.885,38.505c4.209,4.166,10.304,5.804,16.034,4.297l52.93-13.904
			l14.422,52.79c1.56,5.713,6.024,10.177,11.738,11.738l52.79,14.422l-13.904,52.93c-1.505,5.728,0.129,11.825,4.297,16.034
			l38.505,38.885L433.191,294.885z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M189.035,133.229c-30.771,0-55.805,25.034-55.805,55.805s25.034,55.805,55.805,55.805s55.805-25.034,55.805-55.805
			S219.806,133.229,189.035,133.229z M189.035,211.356c-12.308,0-22.322-10.015-22.322-22.322c0-12.308,10.014-22.322,22.322-22.322
			s22.322,10.014,22.322,22.322S201.343,211.356,189.035,211.356z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M322.967,267.161c-30.771,0-55.805,25.034-55.805,55.805c0,30.771,25.034,55.805,55.805,55.805
			c30.771,0,55.805-25.034,55.805-55.805C378.772,292.195,353.738,267.161,322.967,267.161z M322.967,345.288
			c-12.308,0-22.322-10.014-22.322-22.322c0-12.308,10.014-22.322,22.322-22.322c12.308,0,22.322,10.014,22.322,22.322
			C345.289,335.275,335.274,345.288,322.967,345.288z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M345.965,166.035c-6.537-6.538-17.138-6.538-23.676,0L166.035,322.289c-6.538,6.538-6.538,17.138,0,23.676
			c3.269,3.269,7.554,4.904,11.837,4.904s8.569-1.634,11.837-4.904l156.254-156.254
			C352.503,183.173,352.503,172.573,345.965,166.035z"
          />
        </g>
      </g>
    </>
  )
};

export const EmptyHouse = {
  viewBox: "0 0 30 24",
  body: () => (
    <path
      fill="#03C2B9"
      d="M29.9604 11.0846C29.8716 10.8192 29.7145 10.6479 29.489 10.4833C29.0243 10.1406 28.5631 9.79799 28.0984 9.45535C27.504 9.01865 26.9129 8.57859 26.3184 8.13854C26.233 8.07471 26.1476 8.01089 26.0622 7.94706C25.6283 7.62458 25.191 7.30209 24.7571 6.98297C23.4109 5.98528 22.0648 4.99095 20.7187 3.99327C19.5571 3.13331 18.392 2.26999 17.2304 1.41003C16.6701 0.993488 16.1166 0.55679 15.5392 0.160402C15.5324 0.153684 15.5221 0.146966 15.5153 0.143606C15.2556 -0.0478688 14.7397 -0.0478688 14.4801 0.143606C14.0154 0.486246 13.5542 0.828886 13.0896 1.17153C11.9758 1.99453 10.862 2.8209 9.74817 3.64391C8.40205 4.64159 7.05593 5.63592 5.70981 6.63361C4.54819 7.49357 3.38315 8.35689 2.22152 9.21684C1.65779 9.63339 1.09406 10.0499 0.530333 10.4665C0.5235 10.4732 0.51325 10.4799 0.506417 10.4833C0.284342 10.6479 0.113515 10.8125 0.0349342 11.0846C-0.0333967 11.3264 -0.00264782 11.6456 0.137431 11.8605C0.277509 12.0755 0.489335 12.2637 0.748992 12.3241C1.00865 12.3812 1.3298 12.3846 1.54505 12.2233C2.0097 11.8807 2.47093 11.5381 2.93558 11.1954C3.08591 11.0846 3.23965 10.9704 3.38998 10.8595V21.9348C3.38998 22.0289 3.38656 22.1229 3.38998 22.217C3.4139 23.1811 4.15187 23.9672 5.14267 23.994C5.7064 24.0075 6.27013 23.994 6.83044 23.994H11.9963C12.5497 23.994 13.0212 23.5338 13.0212 22.9863V14.9477C13.0212 14.6924 13.0076 14.4337 13.011 14.175C13.4312 14.165 13.8549 14.1885 14.2683 14.1885H16.7418C16.8273 14.1885 16.9127 14.1851 16.9981 14.1851C16.9981 14.3665 16.9878 14.5513 16.9878 14.7293V22.9863C16.9878 23.5305 17.4559 23.994 18.0128 23.994H24.7058C25.2354 23.994 25.741 23.863 26.1203 23.4666C26.4756 23.0971 26.6259 22.6235 26.6259 22.1229V12.4686C26.6259 11.9378 26.6293 11.4071 26.6293 10.8729C26.6669 10.8998 26.7045 10.9267 26.7421 10.9569C27.3024 11.3735 27.8559 11.8102 28.4333 12.2065C28.4401 12.2133 28.4503 12.22 28.4572 12.2233C28.6553 12.3711 29.0209 12.3879 29.2464 12.3241C29.4855 12.2603 29.7418 12.0789 29.858 11.8605C29.9844 11.6254 30.0459 11.3432 29.9604 11.0846ZM19.0343 21.9718V13.8761C19.0309 13.4394 18.8772 13.0531 18.5902 12.7239C18.2622 12.3476 17.7497 12.173 17.2543 12.1662H15.4436C14.545 12.1662 13.6464 12.1528 12.7479 12.1662C11.7673 12.1797 10.9815 12.8985 10.9713 13.8794C10.9679 14.0843 10.9713 14.2893 10.9713 14.4908V21.9751H5.94897C5.77815 21.9751 5.6039 21.9819 5.42966 21.9852C5.41941 21.6325 5.43991 21.2731 5.43991 20.9271V10.5135C5.43991 10.1238 5.44674 9.7308 5.44332 9.33778C5.72006 9.13286 6.00022 8.92795 6.27696 8.72304C7.62308 7.72535 8.9692 6.73103 10.3153 5.73334C11.4769 4.87338 12.642 4.01006 13.8036 3.1501C14.2033 2.85449 14.6099 2.56896 15.0096 2.27335C15.2966 2.48498 15.587 2.69997 15.874 2.9116C16.9878 3.73461 18.1016 4.56097 19.2154 5.38398C20.5615 6.38167 21.9077 7.376 23.2538 8.37368C23.6911 8.69953 24.1318 9.02201 24.5691 9.34785V20.6046C24.5691 21.0614 24.576 21.5216 24.5726 21.9785C24.4564 21.9751 24.3402 21.9718 24.2241 21.9718H19.0343Z"
    />
  )
};

export const EmptyStar = {
  viewBox: "0 0 15 15",
  body: () => (
    <g
      id="Star_Empty"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon
        id="Star"
        fill="#F0F0F0"
        points="7.5 11.82895 2.86474508 14.2658477 3.75 9.10441554 1.11022302e-16 5.44906896 5.18237254 4.69602615 7.5 0 9.81762746 4.69602615 15 5.44906896 11.25 9.10441554 12.1352549 14.2658477"
      />
    </g>
  )
};

export const HiddenIcon = {
  viewBox: "0 0 100 100",
  body: () => (
    <>
      <path
        class="svg-fill-primary"
        d="M70.8,66.1A33.1,33.1,0,0,0,81.9,50a33.4,33.4,0,0,0-47-19.8l-5.9-6A3.4,3.4,0,0,0,24.2,29L71,75.8A3.4,3.4,0,1,0,75.8,71Zm-9.3-9.3-5-5.1a8.8,8.8,0,0,0,.2-1.7A6.7,6.7,0,0,0,50,43.3l-1.7.2-5.1-5A13.1,13.1,0,0,1,50,36.6,13.4,13.4,0,0,1,63.4,50,13.1,13.1,0,0,1,61.5,56.8Z"
      ></path>
      <path
        class="svg-fill-primary"
        d="M36.7,50.8,24.4,38.6A32.7,32.7,0,0,0,18.1,50,33.4,33.4,0,0,0,50,73.4a36.8,36.8,0,0,0,8.2-1l-9-9.1A13.2,13.2,0,0,1,36.7,50.8Z"
      ></path>
    </>
  )
};

export const Envelope = {
  viewBox: "0 0 20 16",
  body: () => (
    <path d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z" />
  )
};

export const Face = {
  viewBox: "0 0 62 62",
  body: () => (
    <path d="M23.2503 30.354C21.4678 30.354 20.0212 31.8007 20.0212 33.5832C20.0212 35.3657 21.4678 36.8123 23.2503 36.8123C25.0328 36.8123 26.4795 35.3657 26.4795 33.5832C26.4795 31.8007 25.0328 30.354 23.2503 30.354ZM38.7503 30.354C36.9678 30.354 35.5212 31.8007 35.5212 33.5832C35.5212 35.3657 36.9678 36.8123 38.7503 36.8123C40.5328 36.8123 41.9795 35.3657 41.9795 33.5832C41.9795 31.8007 40.5328 30.354 38.7503 30.354ZM31.0003 5.1665C16.7403 5.1665 5.16699 16.7398 5.16699 30.9998C5.16699 45.2598 16.7403 56.8332 31.0003 56.8332C45.2603 56.8332 56.8337 45.2598 56.8337 30.9998C56.8337 16.7398 45.2603 5.1665 31.0003 5.1665ZM31.0003 51.6665C19.6078 51.6665 10.3337 42.3923 10.3337 30.9998C10.3337 30.2507 10.3853 29.5015 10.4628 28.7782C16.5595 26.0657 21.3903 21.0798 23.922 14.9057C28.5978 21.519 36.2962 25.8332 45.002 25.8332C47.017 25.8332 48.9545 25.6007 50.8145 25.1615C51.357 26.9957 51.667 28.959 51.667 30.9998C51.667 42.3923 42.3928 51.6665 31.0003 51.6665Z" />
  )
};

export const Facebook = {
  viewBox: "0 0 20 20",
  body: () => (
    <path
      fillRule="nonzero"
      d="M15 10.667h-3.333V20h-4v-9.333H5v-4h2.667V4.4C7.667 2.667 9 0 12.733 0h2.934v4h-2.4c-.267 0-1.6-.133-1.6.667v2H15.4l-.4 4z"
    />
  )
};

export const FacebookF = {
  viewBox: "0 0 96.124 96.123",
  body: () => (
    <g>
      <path
        d="M72.089,0.02L59.624,0C45.62,0,36.57,9.285,36.57,23.656v10.907H24.037c-1.083,0-1.96,0.878-1.96,1.961v15.803
		c0,1.083,0.878,1.96,1.96,1.96h12.533v39.876c0,1.083,0.877,1.96,1.96,1.96h16.352c1.083,0,1.96-0.878,1.96-1.96V54.287h14.654
		c1.083,0,1.96-0.877,1.96-1.96l0.006-15.803c0-0.52-0.207-1.018-0.574-1.386c-0.367-0.368-0.867-0.575-1.387-0.575H56.842v-9.246
		c0-4.444,1.059-6.7,6.848-6.7l8.397-0.003c1.082,0,1.959-0.878,1.959-1.96V1.98C74.046,0.899,73.17,0.022,72.089,0.02z"
      />
    </g>
  )
};

export const FilledCircleTick = {
  viewBox: "0 0 35 35",
  body: () => [
    <g key="teal-tick-g" fill="none" fillRule="evenodd">
      <circle cx="17.5" cy="17.5" r="17" fill="#32c864" stroke="#32c864" />
      <path stroke="#FFF" strokeWidth="3" d="M10 18.019L14.835 22 25 11" />
    </g>
  ]
};

export const Flag = {
  viewBox: "0 0 34 39",
  body: () => (
    <path
      d="M20.8 5.25001L19.9167 0.833344H0.0416565V38.375H4.45832V22.9167H16.825L17.7083 27.3333H33.1667V5.25001H20.8Z"
      fill="#32C864"
    />
  )
};

export const FlatArrow = {
  viewBox: "0 0 9 5",
  body: () => <path d="M4.5 5L0.602886 0.5L8.39711 0.5L4.5 5Z" fill="#81868A" />
};

export const Gift = {
  viewBox: "0 0 464.628 464.628",
  pathOutline: true,
  body: () => (
    <g>
      <path d="m394.33,105.596h-76.136c22.944-22.372 37.216-53.596 37.216-88.096 0-9.665-7.835-17.5-17.5-17.5-44.786,0-84.057,24.045-105.596,59.9-21.539-35.855-60.81-59.9-105.595-59.9-9.665,0-17.5,7.835-17.5,17.5 0,34.5 14.273,65.724 37.216,88.096h-76.137c-9.665,0-17.5,7.835-17.5,17.5v324.033c0,9.665 7.835,17.5 17.5,17.5h324.032c9.665,0 17.5-7.835 17.5-17.5v-324.033c0-9.665-7.835-17.5-17.5-17.5zm-17.5,162.016h-127.016v-127.016h127.016v127.016zm-58.646-230.385c-7.525,32.765-33.378,58.618-66.144,66.143 7.526-32.766 33.379-58.619 66.144-66.143zm-105.596,66.142c-32.765-7.525-58.618-33.378-66.143-66.143 32.765,7.525 58.618,33.378 66.143,66.143zm2.226,37.227v127.016h-127.016v-127.016h127.016zm-127.016,162.016h127.016v127.017h-127.016v-127.017zm162.016,127.016v-127.016h127.016v127.017h-127.016z" />
    </g>
  )
};

export const Giftcard = {
  viewBox: "0 0 576 512",
  pathOutline: true,
  body: () => (
    <g>
      <path d="M512 128h-32.4C489.7 114.6 496 98.08 496 80C496 35.89 460.1 0 416 0c-52.93 0-100.1 60.63-128 106C260.1 60.63 212.9 0 160 0C115.9 0 80 35.89 80 80c0 18.08 6.254 34.59 16.4 48H64C28.65 128 .0001 156.7 .0001 192v256c0 35.35 28.65 64 63.1 64h448c35.35 0 64-28.65 64-64V192C576 156.7 547.3 128 512 128zM416 32c26.47 0 48 21.53 48 48S442.5 128 416 128h-103.9C347.3 69.01 386.8 32 416 32zM160 32c29.22 0 68.67 37.01 103.9 96H160C133.5 128 112 106.5 112 80S133.5 32 160 32zM544 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32v-80h512V448zM544 336H32V192c0-17.64 14.36-32 32-32h180.8L165.6 227.9C158.9 233.6 158.1 243.7 163.8 250.4C172.5 260.5 183.9 254.3 186.4 252.1L288 165.1l101.6 87.08c2.539 2.195 13.88 8.348 22.56-1.734c5.75-6.703 4.969-16.8-1.75-22.55L331.2 160H512c17.64 0 32 14.36 32 32V336z" />
    </g>
  )
};

export const GoogleG = {
  viewBox: "0 0 533.5 544.3",
  body: () => (
    <g>
      <path
        fill="#4285F4"
        d="M533.5,278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1,33.8-25.7,63.7-54.4,82.7v68h87.7
		C503.9,431.2,533.5,361.2,533.5,278.4z"
      />
      <path
        fill="#34A853"
        d="M272.1,544.3c73.4,0,135.3-24.1,180.4-65.7l-87.7-68c-24.4,16.6-55.9,26-92.6,26c-71,0-131.2-47.9-152.8-112.3
		H28.9v70.1C75.1,486.3,169.2,544.3,272.1,544.3z"
      />
      <path
        fill="#FBBC04"
        d="M119.3,324.3c-11.4-33.8-11.4-70.4,0-104.2V150H28.9c-38.6,76.9-38.6,167.5,0,244.4L119.3,324.3z"
      />
      <path
        fill="#EA4335"
        d="M272.1,107.7c38.8-0.6,76.3,14,104.4,40.8l0,0l77.7-77.7C405,24.6,339.7-0.8,272.1,0C169.2,0,75.1,58,28.9,150
		l90.4,70.1C140.8,155.6,201.1,107.7,272.1,107.7z"
      />
    </g>
  )
};

export const GradHatThin = {
  viewBox: "0 0 35 33",
  pathOutline: true,
  body: () => (
    <path d="M34.1226 6.86068L18.1457 0.101224C17.9941 0.0370006 17.8311 0.00390625 17.6664 0.00390625C17.5017 0.00390625 17.3387 0.0370006 17.1871 0.101224L1.21022 6.86068C0.988521 6.95512 0.79948 7.11265 0.666606 7.31368C0.533733 7.51471 0.462891 7.75037 0.462891 7.99135C0.462891 8.23232 0.533733 8.46798 0.666606 8.66901C0.79948 8.87004 0.988521 9.02758 1.21022 9.12202L5.3765 10.8795V17.0244C5.37606 17.7468 5.58782 18.4533 5.98547 19.0564C6.38312 19.6594 6.94915 20.1323 7.61326 20.4165L15.2699 23.6487C16.0281 23.9698 16.843 24.1353 17.6664 24.1353C18.4898 24.1353 19.3048 23.9698 20.0629 23.6487L23.8114 22.1247V24.8408C22.9914 25.1307 22.3003 25.7012 21.8602 26.4514C21.4201 27.2016 21.2594 28.0832 21.4065 28.9404C21.5536 29.7976 21.9989 30.5752 22.6639 31.1358C23.3289 31.6964 24.1706 32.0039 25.0404 32.0039C25.9101 32.0039 26.7518 31.6964 27.4168 31.1358C28.0818 30.5752 28.5272 29.7976 28.6742 28.9404C28.8213 28.0832 28.6606 27.2016 28.2205 26.4514C27.7805 25.7012 27.0893 25.1307 26.2693 24.8408V21.0555L27.7196 20.441C28.3837 20.1569 28.9497 19.684 29.3474 19.0809C29.745 18.4779 29.9568 17.7714 29.9563 17.049V10.9041L34.1226 9.1466C34.3443 9.05216 34.5333 8.89462 34.6662 8.69359C34.7991 8.49256 34.8699 8.2569 34.8699 8.01593C34.8699 7.77495 34.7991 7.53929 34.6662 7.33826C34.5333 7.13723 34.3443 6.9797 34.1226 6.88526V6.86068ZM25.0404 29.4987C24.7973 29.4987 24.5597 29.4266 24.3576 29.2916C24.1555 29.1565 23.9979 28.9646 23.9049 28.74C23.8119 28.5154 23.7876 28.2683 23.835 28.0299C23.8824 27.7915 23.9995 27.5726 24.1713 27.4007C24.3432 27.2288 24.5622 27.1117 24.8006 27.0643C25.039 27.0169 25.2861 27.0412 25.5107 27.1343C25.7352 27.2273 25.9272 27.3848 26.0622 27.5869C26.1973 27.789 26.2693 28.0266 26.2693 28.2697C26.2693 28.5957 26.1399 28.9083 25.9094 29.1387C25.6789 29.3692 25.3663 29.4987 25.0404 29.4987ZM19.1043 21.4119C18.1836 21.7929 17.1492 21.7929 16.2285 21.4119L8.58416 18.1797C8.36203 18.0856 8.17249 17.9282 8.03918 17.7272C7.90587 17.5261 7.83468 17.2903 7.83448 17.049V11.9241L17.1871 15.8815C17.3387 15.9457 17.5017 15.9788 17.6664 15.9788C17.8311 15.9788 17.9941 15.9457 18.1457 15.8815L23.8114 13.5218V19.421L19.1043 21.4119ZM27.4983 17.049C27.4981 17.2903 27.427 17.5261 27.2936 17.7272C27.1603 17.9282 26.9708 18.0856 26.7487 18.1797L26.2693 18.4378V12.4526L27.4983 11.9241V17.049ZM24.3644 10.5845L18.2195 7.51204C17.933 7.39275 17.612 7.38624 17.3209 7.49383C17.0299 7.60141 16.7903 7.81512 16.6502 8.09205C16.5102 8.36898 16.4801 8.68862 16.566 8.98681C16.6519 9.285 16.8475 9.53965 17.1134 9.69965L21.3534 11.8381L17.6664 13.4235L4.84803 7.99135L17.6664 2.5715L30.4848 7.99135L24.3644 10.5845Z" />
  )
};

export const GraphArrow = {
  viewBox: "0 0 24 24",
  strokeOutline: true,
  body: () => (
    <>
      <path
        d="M23 6L13.5 15.5L8.5 10.5L1 18"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      ,
      <path
        d="M17 6H23V12"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
};

export const Guest = {
  viewBox: "0 0 20 20",
  body: () => [
    <path
      key="guest-path"
      d="M13.5 6C13.5 7.933 11.933 9.5 10 9.5C8.067 9.5 6.5 7.933 6.5 6C6.5 4.067 8.067 2.5 10 2.5C11.933 2.5 13.5 4.067 13.5 6Z"
      stroke="#d8d8d8"
      strokeLinecap="square"
      fill="white"
    />,
    <path
      key="guest-path-2"
      d="M17.4353 17.5H2.50218C2.51935 17.357 2.54419 17.1883 2.5801 16.9999C2.69799 16.3813 2.93298 15.5624 3.39853 14.7482C4.31092 13.1525 6.14732 11.5 9.96875 11.5C13.7902 11.5 15.6266 13.1525 16.539 14.7482C17.0045 15.5624 17.2395 16.3813 17.3574 16.9999C17.3933 17.1883 17.4181 17.357 17.4353 17.5Z"
      stroke="#d8d8d8"
      strokeLinecap="square"
      fill="white"
    />,
    <rect key="guest-rect" width="20" height="20" fillOpacity="0" />
  ]
};

export const HalfStar = {
  viewBox: "0 0 15 15",
  body: () => [
    <defs key="half-star-defs">
      <polygon
        id="path-1"
        points="7.5 11.82895 2.86474508 14.2658477 3.75 9.10441554 1.11022302e-16 5.44906896 5.18237254 4.69602615 7.5 0 9.81762746 4.69602615 15 5.44906896 11.25 9.10441554 12.1352549 14.2658477"
      />
    </defs>,
    <g
      key="half-star"
      id="Star_Half"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Rectangle">
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-1" />
        </mask>
        <use id="Mask" fill="#822D50" xlinkHref="#path-1" />
        <rect
          fill="#F0F0F0"
          mask="url(#mask-2)"
          x="7.5"
          y="0"
          width="8"
          height="15"
        />
      </g>
    </g>
  ]
};

export const Hamburger = {
  viewBox: "0 0 34 26",
  body: () => (
    <g>
      <path d="M2 0 H32 C 34.6 0, 34.6 4, 32 4 H2 C -0.6 4, -0.6 0, 2 0" />
      <path d="M2 11 H32 C 34.6 11, 34.6 15, 32 15 H2 C -0.6 15, -0.6 11, 2 11" />
      <path d="M2 22 H32 C 34.6 22, 34.6 26, 32 26 H2 C -0.6 26, -0.6 22, 2 22" />
    </g>
  )
};
// C 34 6, 34 10, 32 10

export const Heart = {
  viewBox: "0 0 24 24",
  body: () => (
    <g
      id="icon/favourite_incative"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M11.9806629,21.9160537 C12.0982105,21.8106239 12.2339359,21.6887225 12.4057578,21.5343145 C12.4354658,21.5076172 12.4354658,21.5076172 12.4651806,21.4809137 C13.4222229,20.6208625 13.8725493,20.2201368 14.427459,19.740255 C15.0627525,19.1906799 15.6021881,18.7305536 16.7078778,17.7921517 C16.7614365,17.7466966 16.7614365,17.7466966 16.8149871,17.7012486 C17.7238438,16.9299036 18.1639714,16.5551047 18.68377,16.1082276 C19.7800153,15.1656321 20.5697319,14.4009737 21.2490838,13.588976 C22.001285,12.6883025 22.5294386,11.7540962 22.8359562,10.7497708 C23.0384593,10.0848249 23.1613339,9.38066007 23.2113784,8.62840182 C23.2709635,7.72661697 23.26617,7.17700285 23.1680032,6.62767691 C22.9583329,5.45806041 22.4378168,4.48885742 21.5867339,3.70519522 C20.6723946,2.86251673 19.5701757,2.39786238 18.2633077,2.2940253 C17.4137071,2.22628885 16.6043992,2.33765667 15.8296236,2.63151579 C14.7349161,3.04626466 13.8245032,3.74851477 13.0630537,4.74084983 C13.0013366,4.82147752 12.9386142,4.90838066 12.8558465,5.02695307 C12.8620208,5.01810793 12.6708749,5.29383809 12.6125016,5.37627668 L11.9772519,6.27341775 L11.3736078,5.35471325 C11.3463368,5.31405108 11.3463368,5.31405108 11.3059544,5.2525751 C11.3021771,5.24662536 11.3021771,5.24662536 11.3012477,5.24512043 C10.9831874,4.74474085 10.6521185,4.33033547 10.2840726,3.98299252 C8.53001555,2.3286192 6.56263521,1.8555583 4.31042254,2.57741033 C2.24745443,3.23821158 0.857599003,5.08448135 0.760421255,7.29319732 C0.728687887,8.01512283 0.769588324,8.75031723 0.88079303,9.49553946 C1.0199717,10.4269938 1.28849802,11.2732316 1.69932168,12.0462764 C2.14873576,12.8925488 2.7694545,13.6843035 3.62517881,14.5471953 C4.43666601,15.3642573 5.13680144,15.9841882 6.73621967,17.3402624 C6.74313578,17.3461262 6.74313578,17.3461262 6.75005247,17.3519906 C6.82338717,17.414168 6.82338717,17.414168 6.8968358,17.476458 C9.31382771,19.5269112 10.5977164,20.6407257 11.9806629,21.9160537 Z"
        id="Stroke-7"
        stroke="#822D50"
        strokeWidth="1.5"
      />
    </g>
  )
};

export const HeartFull = {
  viewBox: "0 0 24 24",
  body: () => (
    <g
      id="icon/favourite_selected"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M12.0205751,21.9874864 C12.1389048,21.8813568 12.275561,21.7586198 12.4487813,21.6029551 C12.4785884,21.5761687 12.4785884,21.5761687 12.5084022,21.5493763 C13.4686231,20.6864686 13.9204424,20.2844145 14.4771861,19.8029466 C15.1145894,19.2515463 15.6558189,18.7898899 16.7651884,17.8483649 C16.8189256,17.8027583 16.8189256,17.8027583 16.8726547,17.7571588 C17.7845449,16.9832393 18.2261424,16.6071887 18.7476792,16.1588173 C19.8476734,15.2129984 20.6401125,14.4457039 21.3218329,13.6308751 C22.0767466,12.7269538 22.6068253,11.7893421 22.9144676,10.7813317 C23.1177036,10.1139794 23.2410206,9.40727928 23.2912442,8.65232799 C23.3510403,7.74734989 23.3462293,7.19573515 23.2476906,6.64432803 C23.0372265,5.47028323 22.5147106,4.49735649 21.6603839,3.71070754 C20.7425766,2.86483281 19.6361545,2.39840656 18.3243841,2.29417996 C17.4715867,2.22618864 16.6592104,2.33797871 15.8815033,2.63294967 C14.7826969,3.04925149 13.8688756,3.75413061 13.104612,4.75013309 C13.0426631,4.8310636 12.9797121,4.91828354 12.8966494,5.03727863 C12.9028378,5.02841311 12.7110623,5.30505155 12.6525029,5.3877529 L12.0172533,6.28489397 L11.4136092,5.36618947 C11.3862245,5.32535738 11.3862245,5.32535738 11.3457498,5.26374113 C11.3419652,5.2577797 11.3419652,5.2577797 11.3410284,5.25626306 C11.021803,4.7540506 10.6895031,4.33810427 10.3200682,3.98945047 C8.5595109,2.32894634 6.58462655,1.85408108 4.32402799,2.57862086 C2.25317987,3.2419462 0.858005774,5.09528123 0.760458404,7.31239819 C0.728612093,8.03689314 0.76965777,8.77469827 0.881256456,9.5225607 C1.02093975,10.4573923 1.29044736,11.3067225 1.70277811,12.0826032 C2.15381895,12.9319388 2.77675193,13.7265179 3.63548893,14.5924476 C4.44974805,15.4123006 5.15225307,16.0343297 6.75705699,17.3949701 C6.76399615,17.4008535 6.76399615,17.4008535 6.7709359,17.4067374 C6.84451498,17.4691221 6.84451498,17.4691221 6.91820796,17.5316192 C9.34420953,19.5897158 10.6324191,20.7072976 12.0205751,21.9874864 Z"
        id="Stroke-7"
        stroke="#FADCDC"
        strokeWidth="1.5"
        fill="#822D50"
      />
    </g>
  )
};

export const HeartInCircleFull = {
  viewBox: "0 0 24 24",
  body: () => [
    <circle key={1} cx="12" cy="12" r="12" fill="#CDD2D2" />,
    <path
      key={2}
      d="M17.993 11.0238C18 10.9377 18 10.889 18 10.889C18 10.1228 17.6839 9.38795 17.1213 8.84616C16.5587 8.30437 15.7957 8 15 8C14.2044 8 13.4413 8.30437 12.8787 8.84616C12.3161 9.38795 12 10.1228 12 10.889C12 10.1228 11.6839 9.38795 11.1213 8.84616C10.5587 8.30437 9.79565 8 9 8C8.20435 8 7.44129 8.30437 6.87868 8.84616C6.31607 9.38795 6 10.1228 6 10.889C6 10.889 6 10.9384 6.00701 11.0238C6.01736 11.2607 6.05801 11.4954 6.12803 11.7228C6.46205 13.0547 7.6653 15.7428 12.0005 18C16.3357 15.7428 17.539 13.0547 17.872 11.7228C17.942 11.4954 17.9826 11.2607 17.993 11.0238Z"
      fill="white"
    />
  ]
};

export const Histogram = {
  viewBox: "0 0 19 17",
  body: () => (
    <g>
      <rect
        opacity="0.8"
        x="1.5332"
        y="8.17871"
        width="3.67138"
        height="7.34275"
        rx="1"
        stroke="#000"
        strokeWidth="1.5"
      />
      <rect
        opacity="0.8"
        x="7.95801"
        y="5.42505"
        width="3.67138"
        height="10.0963"
        rx="1"
        stroke="#000"
        strokeWidth="1.5"
      />
      <rect
        opacity="0.8"
        x="14.3828"
        y="0.835938"
        width="3.67138"
        height="14.6855"
        rx="1"
        stroke="#000"
        strokeWidth="1.5"
      />
    </g>
  )
};

export const House = {
  viewBox: "0 0 20 22",
  strokeOutline: true,
  body: () => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8L10 1L19 8V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V8Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7 21V11H13V21"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
};

export const Inbox = {
  viewBox: "0 0 24 24",
  strokeOutline: true,
  body: () => (
    <>
      <path
        d="M22 13H16L14 16H10L8 13H2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.47 5.19L2 13V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V13L18.53 5.19C18.2093 4.46607 17.4918 3.99946 16.7 4H7.3C6.50822 3.99946 5.79067 4.46607 5.47 5.19Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
};

export const Integration = {
  viewBox: "0 0 24 24",
  strokeOutline: true,
  body: () => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1618 0.758789L14.7809 2.27092C14.7042 3.05193 15.2093 3.93524 16.1045 4.45205C16.9996 4.96886 18.0171 4.96464 18.6552 4.50773L21.3768 6.07904C21.855 6.35518 22.0189 6.96678 21.7428 7.44507L12.9534 22.6688C12.6772 23.1471 12.0656 23.311 11.5873 23.0348L8.86304 21.4619C8.93573 20.6828 8.43101 19.8035 7.53875 19.2884C6.64649 18.7732 5.63265 18.7758 4.99423 19.2283L2.37238 17.7146C1.89409 17.4384 1.73021 16.8268 2.00636 16.3485L10.7958 1.12481C11.0719 0.646521 11.6835 0.482647 12.1618 0.758789Z"
        fill="none"
      />
      <line x1="8.25909" y1="4.69394" x2="19.2061" y2="11.0142" />
    </>
  )
};

export const Instagram = {
  viewBox: "0 0 20 20",
  body: () => (
    <g fillRule="evenodd">
      <path d="M9.984.032c-2.711 0-3.051.01-4.116.06C4.805.14 4.079.309 3.444.556a4.894 4.894 0 0 0-1.768 1.151A4.893 4.893 0 0 0 .524 3.476C.277 4.11.11 4.836.06 5.899.012 6.964 0 7.304 0 10.016c0 2.711.012 3.051.06 4.116.049 1.063.217 1.789.464 2.424a4.893 4.893 0 0 0 1.152 1.768 4.894 4.894 0 0 0 1.768 1.152c.635.247 1.361.415 2.424.464 1.065.048 1.405.06 4.116.06 2.712 0 3.052-.012 4.117-.06 1.062-.049 1.788-.217 2.423-.464a4.894 4.894 0 0 0 1.769-1.152 4.894 4.894 0 0 0 1.151-1.768c.247-.635.416-1.361.464-2.424.049-1.065.06-1.405.06-4.116 0-2.712-.011-3.052-.06-4.117-.048-1.062-.217-1.788-.464-2.423a4.894 4.894 0 0 0-1.151-1.769A4.894 4.894 0 0 0 16.524.556C15.89.309 15.164.14 14.101.092c-1.065-.05-1.405-.06-4.117-.06m0 1.798c2.666 0 2.982.01 4.035.059.973.044 1.502.207 1.854.343.466.182.798.398 1.148.747.35.35.565.682.747 1.148.136.352.299.88.343 1.854.048 1.053.059 1.369.059 4.035 0 2.666-.01 2.981-.059 4.034-.044.974-.207 1.502-.343 1.854a3.092 3.092 0 0 1-.747 1.148c-.35.35-.682.566-1.148.747-.352.137-.88.3-1.854.344-1.053.048-1.369.058-4.035.058-2.666 0-2.982-.01-4.034-.058-.974-.045-1.502-.207-1.854-.344a3.093 3.093 0 0 1-1.148-.747 3.095 3.095 0 0 1-.747-1.148c-.137-.352-.3-.88-.344-1.854-.048-1.053-.058-1.368-.058-4.034 0-2.666.01-2.982.058-4.035.045-.973.207-1.502.344-1.854.181-.466.398-.798.747-1.148.35-.35.682-.565 1.148-.747.352-.136.88-.299 1.854-.343 1.053-.048 1.368-.059 4.034-.059" />
      <path d="M9.984 13.344a3.328 3.328 0 1 1 0-6.656 3.328 3.328 0 0 1 0 6.656m0-8.455a5.127 5.127 0 1 0 0 10.254 5.127 5.127 0 0 0 0-10.254M16.512 4.686a1.198 1.198 0 1 1-2.396 0 1.198 1.198 0 0 1 2.396 0" />
    </g>
  )
};

export const Learn = {
  viewBox: "0 0 152 51",
  body: () => [
    <rect
      x="0.0234375"
      y="6.07422"
      width="150.223"
      height="44.2325"
      transform="rotate(-2.24173 0.0234375 6.07422)"
      fill="url(#pattern0)"
      key={1}
    />,
    <defs key={2}>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          href="#image0"
          transform="translate(0 -0.00823808) scale(0.00352113 0.0119585)"
        />
      </pattern>
      <image
        id="image0"
        width="284"
        height="85"
        href="data:image/png;base64,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"
      />
    </defs>
  ]
};

export const LifeTyre = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={3}
      d="M4.92999 4.92969L9.16999 9.16969"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={4}
      d="M14.83 14.8301L19.07 19.0701"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={5}
      d="M14.83 9.16969L19.07 4.92969"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={6}
      d="M14.83 9.16965L18.36 5.63965"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={7}
      d="M4.92999 19.0701L9.16999 14.8301"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const Live = {
  viewBox: "0 0 29 21",
  body: () => (
    <g fill="#03C2B9">
      <path d="M24.221 0.380903C23.7131 -0.126968 22.9065 -0.126968 22.3986 0.380903C21.8907 0.888775 21.8907 1.69539 22.3986 2.20326C26.9396 6.74423 26.9396 14.1233 22.3986 18.6643C21.8907 19.1721 21.8907 19.9788 22.3986 20.4866C22.6376 20.7256 22.9662 20.875 23.2948 20.875C23.6235 20.875 23.9521 20.7555 24.1911 20.4866C29.7478 14.9299 29.7478 5.90774 24.221 0.380903Z" />
      <path d="M19.9489 4.62309C19.441 4.11522 18.6344 4.11522 18.1265 4.62309C17.6186 5.13096 17.6186 5.93758 18.1265 6.44545C20.3074 8.62631 20.3372 12.2113 18.1265 14.3921C17.6186 14.9 17.6186 15.7066 18.1265 16.2145C18.3655 16.4535 18.6941 16.6029 19.0228 16.6029C19.3514 16.6029 19.68 16.4834 19.919 16.2145C23.1753 13.0179 23.1455 7.81969 19.9489 4.62309Z" />
      <path d="M5.96749 2.20326C6.47536 1.69539 6.47536 0.888775 5.96749 0.380903C5.45962 -0.126968 4.653 -0.126968 4.14513 0.380903C-1.38171 5.90774 -1.38171 14.9299 4.14513 20.4568C4.38412 20.6957 4.71275 20.8451 5.04137 20.8451C5.36999 20.8451 5.69861 20.7256 5.93761 20.4568C6.44548 19.9489 6.44548 19.1423 5.93761 18.6344C1.42652 14.1233 1.42652 6.74423 5.96749 2.20326Z" />
      <path d="M10.2097 6.44545C10.7176 5.93758 10.7176 5.13096 10.2097 4.62309C9.70181 4.11522 8.89519 4.11522 8.38732 4.62309C5.19072 7.81969 5.19072 13.0179 8.38732 16.2145C8.62632 16.4535 8.95494 16.6029 9.28356 16.6029C9.61218 16.6029 9.94081 16.4834 10.1798 16.2145C10.6877 15.7066 10.6877 14.9 10.1798 14.3921C8.02882 12.2113 8.02882 8.62631 10.2097 6.44545Z" />
      <path d="M14.183 12.5996C15.3874 12.5996 16.3639 11.6232 16.3639 10.4188C16.3639 9.21432 15.3874 8.23792 14.183 8.23792C12.9785 8.23792 12.0021 9.21432 12.0021 10.4188C12.0021 11.6232 12.9785 12.5996 14.183 12.5996Z" />
    </g>
  )
};

export const Location = {
  viewBox: "0 0 20 20",
  strokeOutline: true,
  body: () => (
    <g fill="none" fillRule="evenodd">
      <g strokeLinecap="square" transform="translate(3.5 2.5)">
        <circle cx="6.516" cy="5.976" r="2.516" />
        <path d="M2.154 11.127A6.484 6.484 0 0 1 0 6.294C0 2.704 2.91 0 6.5 0S13 2.704 13 6.294c0 1.917-.829 3.64-2.148 4.83C8.988 13.32 6.5 14.91 6.5 14.91s-2.484-1.588-4.347-3.784z" />
      </g>
    </g>
  )
};

export const LocationBold = {
  viewBox: "0 0 17 22",
  body: () => (
    <path
      d="M8.32001 22C8.09289 21.897 7.9025 21.7308 7.77307 21.5226C5.66474 18.6296 3.54052 15.7476 1.44353 12.8458C0.64489 11.7322 0.161311 10.4351 0.0410045 9.08382C-0.313032 5.56383 1.65006 2.17803 4.97936 0.781037C8.21108 -0.57636 11.2635 -0.162761 13.9959 2.00864C14.8199 2.658 15.5034 3.45869 16.0074 4.36477C16.5113 5.27084 16.8258 6.26447 16.9326 7.28863C17.2042 9.34606 16.6483 11.4259 15.3803 13.0966C13.3393 15.8833 11.2968 18.6751 9.25276 21.472C9.11988 21.7011 8.91796 21.8853 8.67405 22H8.32001ZM11.3271 8.28082C11.3292 7.73932 11.1661 7.20928 10.8583 6.75739C10.5505 6.3055 10.1118 5.95192 9.59722 5.74115C9.08267 5.53037 8.5153 5.4718 7.9665 5.5728C7.41769 5.6738 6.91195 5.92987 6.51288 6.30879C6.11382 6.68772 5.83925 7.17257 5.72372 7.70238C5.60819 8.23218 5.65686 8.78327 5.86359 9.28633C6.07033 9.78939 6.42591 10.222 6.8856 10.5296C7.34529 10.8373 7.88857 11.0063 8.4471 11.0154C8.82159 11.0198 9.19329 10.9524 9.54088 10.8173C9.88847 10.6821 10.2051 10.4817 10.4727 10.2277C10.7402 9.97362 10.9534 9.67088 11.1 9.3368C11.2466 9.00272 11.3238 8.64387 11.3271 8.28082Z"
      strokeWidth={0}
    />
  )
};

export const Lock = {
  viewBox: "0 0 31 41",
  body: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.24419 40.3721H27.7558C29.5581 40.3721 31 38.9302 31 37.1279V19.4651C31 17.6628 29.5581 16.4012 27.7558 16.4012V12.0756C27.7558 5.40698 22.3488 0 15.5 0C8.8314 0 3.42442 5.40698 3.42442 12.0756V16.4012H3.24419C1.44186 16.4012 0 17.6628 0 19.4651V37.1279C0 38.9302 1.44186 40.3721 3.24419 40.3721ZM17.3023 29.1977C17.1221 29.3779 17.1221 29.3779 17.1221 29.7384C17.1221 31 17.1221 32.4419 17.1221 33.7035C17.1221 35.5058 14.0581 35.686 14.0581 33.7035C14.0581 32.4419 14.0581 31 14.0581 29.7384C14.0581 29.5581 14.0581 29.3779 13.8779 29.1977C11.3547 27.3953 12.6163 23.7907 15.5 23.7907C18.3837 23.6105 19.8256 27.3953 17.3023 29.1977ZM15.5 5.22674C19.2849 5.22674 22.3488 8.2907 22.3488 12.0756V16.2209H8.65116V12.0756C8.65116 8.2907 11.7151 5.22674 15.5 5.22674Z"
    />
  )
};
export const LockInCircle = {
  viewBox: "0 0 32 32",
  body: () => (
    <>
      <path d="M 16,0 C 7.16408,0 0,7.16408 0,16 0,24.83592 7.16408,32 16,32 24.83592,32 32,24.83592 32,16 32,7.16408 24.83592,0 16,0 Z m 0,30.60898 C 7.93143,30.60898 1.39102,24.06857 1.39102,16 1.39102,7.93143 7.93143,1.39102 16,1.39102 c 8.06857,0 14.60898,6.54041 14.60898,14.60898 0,8.06857 -6.54041,14.60898 -14.60898,14.60898 z" />
      <path d="m 14.43592,12.48653 c 0,-0.8 0.20898,-2.71347 2.25959,-2.71347 1.94939,0 2.25959,1.70449 2.25959,2.71347 v 0.59102 h 1.70449 v -0.59102 c 0,-2.6449 -1.53143,-4.34939 -3.93143,-4.34939 -2.4,0 -3.93143,1.70449 -3.93143,4.34939 v 0.59102 h 1.70449 v -0.59102 z m 6.19102,1.14939 h -7.86286 c -0.94041,0 -1.70449,0.73143 -1.70449,1.66857 V 20.8 c 0,0.90449 0.76408,1.66857 1.70449,1.66857 h 7.85959 c 0.94041,0 1.70449,-0.73143 1.70449,-1.66857 V 15.30449 C 22.33116,14.4 21.56408,13.63592 20.62694,13.63592 Z m -3.37633,4.83265 v 1.25388 c 0,0.31347 -0.2449,0.5551 -0.5551,0.5551 -0.31347,0 -0.5551,-0.2449 -0.5551,-0.5551 v -1.25061 c -0.34939,-0.17306 -0.5551,-0.55511 -0.5551,-0.94041 0,-0.59102 0.48653,-1.11347 1.11347,-1.11347 0.62693,0 1.11346,0.48653 1.11346,1.11347 -0.003,0.38204 -0.21224,0.72816 -0.56163,0.93714 z" />
    </>
  )
};
export const Logout = {
  viewBox: "0 0 592.175 592.176",
  pathOutline: true,
  body: () => (
    <>
      <path
        d="M231.828,101.619v-44.36c-14.04,3.419-27.812,7.975-41.253,13.66c-32.28,13.653-61.261,33.19-86.139,58.067
			c-24.877,24.878-44.414,53.859-58.067,86.139c-14.145,33.442-21.317,68.942-21.317,105.513c0,36.57,7.172,72.07,21.317,105.512
			c13.653,32.281,33.19,61.262,58.067,86.139c24.878,24.879,53.859,44.416,86.139,58.068
			c33.442,14.145,68.942,21.318,105.512,21.318c36.571,0,72.071-7.174,105.513-21.318c32.28-13.652,61.262-33.189,86.14-58.068
			c24.877-24.877,44.414-53.857,58.066-86.139c14.146-33.441,21.317-68.941,21.317-105.512c0-36.571-7.172-72.071-21.317-105.513
			c-13.652-32.28-33.189-61.261-58.066-86.139c-24.878-24.877-53.859-44.415-86.14-58.067c-13.439-5.685-27.212-10.241-41.253-13.66
			v44.36c94.742,27.751,163.936,115.303,163.936,219.02c0,126.029-102.166,228.195-228.195,228.195S67.892,446.668,67.892,320.639
			C67.892,216.923,137.086,129.372,231.828,101.619z"
      />

      <path
        d="M317.508,293.624V93.438V50.436V21.92c0-11.83-9.591-21.42-21.421-21.42c-11.83,0-21.419,9.59-21.419,21.42v28.516v43.003
			v200.186c0,11.83,9.59,21.42,21.419,21.42C307.917,315.045,317.508,305.455,317.508,293.624z"
      />
    </>
  )
};
export const Menu = {
  viewBox: "0 0 28 20",
  body: () => (
    <g>
      <path d="M0 0h28v2H0zM0 9h28v2H0zM0 18h28v2H0z" />
    </g>
  )
};

export const Messenger = {
  viewBox: "0 0 24 24",
  body: () => (
    <path d="M12 0c-6.627 0-12 4.975-12 11.111 0 3.497 1.745 6.616 4.472 8.652v4.237l4.086-2.242c1.09.301 2.246.464 3.442.464 6.627 0 12-4.974 12-11.111 0-6.136-5.373-11.111-12-11.111zm1.193 14.963l-3.056-3.259-5.963 3.259 6.559-6.963 3.13 3.259 5.889-3.259-6.559 6.963z" />
  )
};

export const Minus = {
  viewBox: "0 0 512 512",
  body: () => (
    <path d="M0 208v96c0 8.836 7.164 16 16 16h480c8.836 0 16-7.164 16-16v-96c0-8.836-7.164-16-16-16h-480c-8.836 0-16 7.164-16 16z" />
  )
};

export const MoneySquare = {
  viewBox: "0 0 50 48",
  body: () => (
    <path
      d="M47.25 39.5V42.0833C47.25 44.925 44.925 47.25 42.0833 47.25H5.91667C3.04917 47.25 0.75 44.925 0.75 42.0833V5.91667C0.75 3.075 3.04917 0.75 5.91667 0.75H42.0833C44.925 0.75 47.25 3.075 47.25 5.91667V8.5H24C21.1325 8.5 18.8333 10.825 18.8333 13.6667V34.3333C18.8333 37.175 21.1325 39.5 24 39.5H47.25ZM24 34.3333H49.8333V13.6667H24V34.3333ZM34.3333 27.875C32.1892 27.875 30.4583 26.1442 30.4583 24C30.4583 21.8558 32.1892 20.125 34.3333 20.125C36.4775 20.125 38.2083 21.8558 38.2083 24C38.2083 26.1442 36.4775 27.875 34.3333 27.875Z"
      fill="#00D2C8"
    />
  )
};

export const MoreOptions = {
  viewBox: "0 0 408 408",
  body: () => (
    <path
      d="M204,102c28.05,0,51-22.95,51-51S232.05,0,204,0s-51,22.95-51,51S175.95,102,204,102z M204,153c-28.05,0-51,22.95-51,51
			s22.95,51,51,51s51-22.95,51-51S232.05,153,204,153z M204,306c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51
			S232.05,306,204,306z"
    />
  )
};

export const NarrowTick = {
  viewBox: "0 0 14 14",
  body: () => [
    <path
      key={"narrow-tick"}
      d="M 5,12.21 0,7.2099999 1.41,5.7999999 5,9.38 l 7.59,-7.5900001 1.41,1.42 z"
    />
  ]
};

export const newCalendar = {
  viewBox: "0 0 20 23",
  body: () => (
    <>
      <path
        d="M6.06307 16.0103H3.8736C3.55781 16.0103 3.30518 16.3252 3.30518 16.719V18.1364C3.30518 18.5301 3.55781 18.8451 3.8736 18.8451H6.08412C6.39991 18.8451 6.65254 18.5301 6.65254 18.1364V16.719C6.65254 16.3252 6.39991 16.0103 6.06307 16.0103Z"
        fill="#C4C4C4"
      />
      <path
        d="M6.06307 10.7605H3.8736C3.55781 10.7605 3.30518 11.0755 3.30518 11.4692V12.8866C3.30518 13.2803 3.55781 13.5953 3.8736 13.5953H6.08412C6.39991 13.5953 6.65254 13.2803 6.65254 12.8866V11.4692C6.65254 11.0755 6.39991 10.7605 6.06307 10.7605Z"
        fill="#C4C4C4"
      />
      <path
        d="M16.1263 16.0103H13.9368C13.621 16.0103 13.3684 16.3252 13.3684 16.719V18.1364C13.3684 18.5301 13.621 18.8451 13.9368 18.8451H16.1474C16.4631 18.8451 16.7158 18.5301 16.7158 18.1364V16.719C16.6947 16.3252 16.4421 16.0103 16.1263 16.0103Z"
        fill="#C4C4C4"
      />
      <path
        d="M16.1263 10.7605H13.9368C13.621 10.7605 13.3684 11.0755 13.3684 11.4692V12.8866C13.3684 13.2803 13.621 13.5953 13.9368 13.5953H16.1474C16.4631 13.5953 16.7158 13.2803 16.7158 12.8866V11.4692C16.6947 11.0755 16.4421 10.7605 16.1263 10.7605Z"
        fill="#C4C4C4"
      />
      <path
        d="M11.0946 16.0103H8.90509C8.5893 16.0103 8.33667 16.3252 8.33667 16.719V18.1364C8.33667 18.5301 8.5893 18.8451 8.90509 18.8451H11.1156C11.4314 18.8451 11.684 18.5301 11.684 18.1364V16.719C11.684 16.3252 11.4104 16.0103 11.0946 16.0103Z"
        fill="#C4C4C4"
      />
      <path
        d="M11.0946 10.7605H8.90509C8.5893 10.7605 8.33667 11.0755 8.33667 11.4692V12.8866C8.33667 13.2803 8.5893 13.5953 8.90509 13.5953H11.1156C11.4314 13.5953 11.684 13.2803 11.684 12.8866V11.4692C11.684 11.0755 11.4104 10.7605 11.0946 10.7605Z"
        fill="#C4C4C4"
      />
      <path
        d="M17.8947 2.41364H15.7895V1.70494C15.7895 1.17998 15.4526 0.76001 15.0316 0.76001H13.8737C13.4526 0.76001 13.1158 1.17998 13.1158 1.70494V2.41364H6.88421V1.70494C6.88421 1.17998 6.54737 0.76001 6.12632 0.76001H4.96842C4.54737 0.76001 4.21053 1.17998 4.21053 1.70494V2.41364H2.10526C0.947368 2.41364 0 3.59481 0 5.03846V20.3149C0 21.7585 0.947368 22.9397 2.10526 22.9397H17.8947C19.0526 22.9397 20 21.7585 20 20.3149V5.03846C20 3.56856 19.0526 2.41364 17.8947 2.41364ZM17.8947 21.4961H2.10526C1.57895 21.4961 1.15789 20.9711 1.15789 20.3149V8.13574H18.8421V20.2886C18.8421 20.9448 18.4211 21.4961 17.8947 21.4961Z"
        fill="#C4C4C4"
      />
    </>
  )
};

export const newCalendarOne = {
  viewBox: "0 0 20 23",
  body: () => (
    <>
      <path
        d="M6.06307 16.0103H3.8736C3.55781 16.0103 3.30518 16.3252 3.30518 16.719V18.1364C3.30518 18.5301 3.55781 18.8451 3.8736 18.8451H6.08412C6.39991 18.8451 6.65254 18.5301 6.65254 18.1364V16.719C6.65254 16.3252 6.39991 16.0103 6.06307 16.0103Z"
        fill="#C4C4C4"
      />
      <path
        d="M17.8947 2.41364H15.7895V1.70494C15.7895 1.17998 15.4526 0.76001 15.0316 0.76001H13.8737C13.4526 0.76001 13.1158 1.17998 13.1158 1.70494V2.41364H6.88421V1.70494C6.88421 1.17998 6.54737 0.76001 6.12632 0.76001H4.96842C4.54737 0.76001 4.21053 1.17998 4.21053 1.70494V2.41364H2.10526C0.947368 2.41364 0 3.59481 0 5.03846V20.3149C0 21.7585 0.947368 22.9397 2.10526 22.9397H17.8947C19.0526 22.9397 20 21.7585 20 20.3149V5.03846C20 3.56856 19.0526 2.41364 17.8947 2.41364ZM17.8947 21.4961H2.10526C1.57895 21.4961 1.15789 20.9711 1.15789 20.3149V8.13574H18.8421V20.2886C18.8421 20.9448 18.4211 21.4961 17.8947 21.4961Z"
        fill="#C4C4C4"
      />
    </>
  )
};

export const Note = {
  viewBox: "0 0 1000 1000",
  body: () => (
    <g>
      <path d="M804.2,89.4h-49.5V52c0-23.2-18.8-42-42-42h-15.3c-23.2,0-42,18.8-42,42v37.3H361.5V52c0-23.2-18.8-42-42-42h-15.3c-23.2,0-42,18.8-42,42v37.3h-66.4c-62.5,0-113.4,50.9-113.4,113.4v673.8c0,62.5,50.9,113.4,113.4,113.4h608.4c62.5,0,113.4-50.9,113.4-113.4V202.8C917.6,140.2,866.7,89.4,804.2,89.4z M849.3,876.6c0,24.9-20.2,45.1-45.1,45.1H195.8c-24.9,0-45.1-20.2-45.1-45.1V202.8c0-24.9,20.2-45.1,45.1-45.1h66.4v53.7c0,23.2,18.8,42,42,42h15.3c23.2,0,42-18.8,42-42v-53.7h293.9v53.7c0,23.2,18.8,42,42,42h15.3c23.2,0,42-18.8,42-42v-53.7h49.5c24.9,0,45.1,20.2,45.1,45.1L849.3,876.6L849.3,876.6z" />
      <path d="M731.2,346.1H282.3c-18.9,0-34.2,15.3-34.2,34.2c0,18.9,15.3,34.2,34.2,34.2h448.9c18.9,0,34.2-15.3,34.2-34.2S750,346.1,731.2,346.1z" />
      <path d="M728.8,481.5H279.9c-18.9,0-34.2,15.3-34.2,34.2c0,18.9,15.3,34.2,34.2,34.2h448.9c18.9,0,34.2-15.3,34.2-34.2C762.9,496.8,747.6,481.5,728.8,481.5z" />
      <path d="M726.4,617H277.5c-18.9,0-34.2,15.3-34.2,34.2s15.3,34.2,34.2,34.2h448.9c18.9,0,34.2-15.3,34.2-34.2S745.2,617,726.4,617z" />
      <path d="M724,752.5H275.1c-18.9,0-34.2,15.3-34.2,34.2c0,18.9,15.3,34.2,34.2,34.2H724c18.9,0,34.2-15.3,34.2-34.2C758.1,767.8,742.8,752.5,724,752.5z" />
    </g>
  )
};

export const Notes = {
  viewBox: "0 0 24 24",
  strokeOutline: true,
  body: () => (
    <g
      strokeWidth="1.5"
      // stroke="#000000"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" />
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <line x1="9" y1="7" x2="15" y2="7" />
      <line x1="9" y1="11" x2="15" y2="11" />
      <line x1="9" y1="15" x2="13" y2="15" />
    </g>
  )
};

export const Obby = {
  viewBox: "0 0 500 394",
  body: () => (
    <>
      <g className="background" fill="#822D50">
        <path d="M249.1,0 C102.5,0 0,67.1 0,196.1 C0,326.9 102.5,394 249.1,394 C397.5,394 500,326.9 500,196.1 C500,67.1 397.5,0 249.1,0 Z" />
      </g>
      <g
        className="foreground"
        transform="translate(64.000000, 124.000000)"
        fill="#D7F0FA"
      >
        <path d="M46.3,33 C18.9,33 0.6,53.3 0.6,77.6 C0.6,104.9 20.4,119.6 44.9,119.6 C72.3,119.6 90.6,99.3 90.6,75 C90.6,47.7 70.8,33 46.3,33 Z M46.4,106.3 C36.1,106.3 30.4,94 30.4,72.5 C30.4,54.5 36.4,46.2 44.6,46.2 C54.9,46.2 60.8,58.5 60.8,80 C60.8,98 54.6,106.3 46.4,106.3 Z" />
        <path d="M154.8,33 C144.3,33 135.4,38.7 131.1,49 L131.1,0.3 L103.7,3.6 L103.7,82.5 C103.7,109.8 118.4,119.6 142.9,119.6 C171.6,119.6 187,99.8 187,74 C187,48.7 172.1,33 154.8,33 Z M143.9,106.3 C135.6,106.3 131,99.6 131,84.1 L131,52.9 C132.6,52.1 134.6,51.4 138,51.4 C150.9,51.4 157.6,66.6 157.6,83.1 C157.6,100.4 150.4,106.3 143.9,106.3 Z" />
        <path d="M251.2,33 C240.7,33 231.8,38.7 227.5,49 L227.5,0.3 L200.1,3.6 L200.1,82.5 C200.1,109.8 214.8,119.6 239.3,119.6 C268,119.6 283.4,99.8 283.4,74 C283.4,48.7 268.5,33 251.2,33 Z M240.4,106.3 C232.1,106.3 227.5,99.6 227.5,84.1 L227.5,52.9 C229.1,52.1 231.1,51.4 234.5,51.4 C247.4,51.4 254.1,66.6 254.1,83.1 C254.1,100.4 246.9,106.3 240.4,106.3 Z" />
        <polygon points="353.8 34.6 334.8 81.3 317.2 34.6 286.6 34.6 319.1 114.8 304.3 145.7 321.9 145.7 371.4 34.6" />
      </g>
    </>
  )
};

export const Baluu = {
  viewBox: "0 0 399.000000 127.000000",
  body: () => (
    <>
      <rect
        className="foreground"
        x={4}
        y={4}
        width={390}
        height={119}
        fill="#FFFFFF"
      />
      <g
        transform="translate(0.000000,127.000000) scale(0.100000,-0.100000)"
        fill="#28283C"
        stroke="none"
        className="background"
      >
        <path
          d="M10 630 l0 -630 1980 0 1980 0 0 630 0 630 -1980 0 -1980 0 0 -630z
      m1188 3 l2 -583 -570 0 -570 0 0 578 c0 318 3 582 7 585 3 4 259 6 567 5 l561
      -3 3 -582z m392 182 c0 -96 3 -175 6 -175 3 0 22 12 41 28 33 24 44 27 118 27
      74 0 85 -3 119 -29 105 -79 103 -272 -3 -343 -110 -75 -263 -34 -312 82 -13
      31 -27 541 -15 571 3 7 15 14 26 14 19 0 20 -6 20 -175z m1048 -172 l2 -343
      -25 0 -25 0 0 346 0 345 23 -3 22 -3 3 -342z m-295 43 c39 -17 92 -71 106
      -109 6 -16 11 -84 11 -153 l0 -124 -25 0 c-20 0 -25 5 -25 25 l0 25 -46 -29
      c-90 -57 -178 -49 -250 23 -102 101 -76 277 51 341 38 19 135 19 178 1z m469
      -128 c4 -153 17 -190 73 -214 79 -33 155 -9 186 59 15 34 19 66 19 165 l0 122
      25 0 25 0 0 -122 c0 -151 -9 -186 -60 -231 -91 -83 -233 -65 -291 36 -20 36
      -23 59 -27 179 l-5 138 26 0 25 0 4 -132z m490 0 c5 -151 16 -185 72 -212 71
      -33 157 -9 188 54 14 28 18 61 18 163 l0 127 26 0 26 0 -4 -143 c-3 -136 -4
      -146 -30 -184 -72 -109 -255 -103 -318 10 -20 34 -24 59 -28 163 -5 135 -2
      154 27 154 17 0 19 -10 23 -132z"
        />
        <path
          d="M515 967 c-57 -19 -100 -43 -140 -78 l-35 -31 -37 29 c-70 54 -65 67
      -61 -168 l3 -214 32 -67 c39 -83 108 -154 188 -194 55 -26 69 -29 165 -29 95
      0 110 3 163 28 196 97 279 331 185 526 -31 64 -116 147 -185 178 -47 22 -76
      28 -148 30 -55 2 -105 -2 -130 -10z m220 -207 c87 -54 113 -184 54 -273 -119
      -180 -393 -58 -347 156 12 57 68 120 120 136 49 15 133 6 173 -19z"
        />
        <path
          d="M1672 640 c-114 -70 -101 -253 21 -299 71 -27 163 5 192 66 26 54 18
      163 -15 198 -54 58 -136 72 -198 35z"
        />
        <path
          d="M2195 646 c-118 -51 -127 -243 -15 -301 42 -22 118 -19 158 5 50 31
      72 75 72 146 0 47 -5 69 -23 95 -41 62 -123 85 -192 55z"
        />
      </g>
    </>
  )
};

export const Page = {
  viewBox: "0 0 24 24",
  strokeOutline: true,
  body: () => (
    <>
      <path
        d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2V8H20"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13H8"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17H8"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9H9H8"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
};

export const Pen = {
  viewBox: "0 0 20 22",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1L16 5L5 16H1V12L12 1V1Z"
      stroke="#333333"
      strokeOpacity="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      d="M1 21H19"
      stroke="#333333"
      strokeOpacity="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const People = {
  viewBox: "0 0 58 38",
  body: () => (
    <path
      d="M39.3334 16.4167C43.6217 16.4167 47.0575 12.9551 47.0575 8.66672C47.0575 4.37838 43.6217 0.916718 39.3334 0.916718C35.045 0.916718 31.5834 4.37838 31.5834 8.66672C31.5834 12.9551 35.045 16.4167 39.3334 16.4167ZM18.6667 16.4167C22.955 16.4167 26.3909 12.9551 26.3909 8.66672C26.3909 4.37838 22.955 0.916718 18.6667 0.916718C14.3784 0.916718 10.9167 4.37838 10.9167 8.66672C10.9167 12.9551 14.3784 16.4167 18.6667 16.4167ZM18.6667 21.5834C12.6475 21.5834 0.583366 24.6059 0.583366 30.6251V37.0834H36.75V30.6251C36.75 24.6059 24.6859 21.5834 18.6667 21.5834ZM39.3334 21.5834C38.5842 21.5834 37.7317 21.6351 36.8275 21.7126C39.8242 23.8826 41.9167 26.8017 41.9167 30.6251V37.0834H57.4167V30.6251C57.4167 24.6059 45.3525 21.5834 39.3334 21.5834Z"
      fill="#FBB231"
    />
  )
};

export const PeopleThin = {
  viewBox: "0 0 22 22",
  strokeOutline: true,
  body: () => (
    <>
      <path
        d="M15.5834 19.25V17.4167C15.5834 16.4442 15.1971 15.5116 14.5095 14.8239C13.8218 14.1363 12.8892 13.75 11.9167 13.75H4.58341C3.61095 13.75 2.67832 14.1363 1.99069 14.8239C1.30306 15.5116 0.916748 16.4442 0.916748 17.4167V19.25"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round
    "
      />
      <path
        d="M8.24992 10.0833C10.275 10.0833 11.9166 8.44171 11.9166 6.41667C11.9166 4.39162 10.275 2.75 8.24992 2.75C6.22487 2.75 4.58325 4.39162 4.58325 6.41667C4.58325 8.44171 6.22487 10.0833 8.24992 10.0833Z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0833 19.25V17.4166C21.0826 16.6042 20.8122 15.815 20.3145 15.1729C19.8168 14.5308 19.1199 14.0722 18.3333 13.8691"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 2.86914C15.4555 3.07108 16.1545 3.52978 16.6537 4.17293C17.153 4.81607 17.4239 5.60707 17.4239 6.42122C17.4239 7.23538 17.153 8.02638 16.6537 8.66952C16.1545 9.31266 15.4555 9.77136 14.6667 9.97331"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
};

export const Play = {
  viewBox: "0 0 512 512",
  body: () => <path d="M96 64l320 192-320 192z" />
};

export const PlayRounded = {
  viewBox: "0 0 59 64",
  body: () => (
    <g>
      <path d="M17 43.4908V21.3653C17 18.1927 20.5167 16.2828 23.1779 18.0102L39.9215 28.8789C42.3277 30.4408 42.356 33.953 39.9754 35.5535L23.2317 46.8104C20.5746 48.5968 17 46.6927 17 43.4908Z" />
    </g>
  )
};

export const PlayCircle = {
  viewBox: "0 0 61 61",
  body: () => (
    <path
      d="M30.5 0.916748C14.17 0.916748 0.916626 14.1701 0.916626 30.5001C0.916626 46.8301 14.17 60.0834 30.5 60.0834C46.83 60.0834 60.0833 46.8301 60.0833 30.5001C60.0833 14.1701 46.83 0.916748 30.5 0.916748ZM24.5833 43.8126V17.1876L42.3333 30.5001L24.5833 43.8126Z"
      fill="white"
    />
  )
};

export const Plus = {
  viewBox: "0 0 512 512",
  body: () => (
    <path d="M496 192h-176v-176c0-8.836-7.164-16-16-16h-96c-8.836 0-16 7.164-16 16v176h-176c-8.836 0-16 7.164-16 16v96c0 8.836 7.164 16 16 16h176v176c0 8.836 7.164 16 16 16h96c8.836 0 16-7.164 16-16v-176h176c8.836 0 16-7.164 16-16v-96c0-8.836-7.164-16-16-16z" />
  )
};

export const PointyArrow = {
  viewBox: "0 0 76 75",
  body: () => (
    <path d="M6.4945 18.0458C6.68954 17.5291 7.26652 17.2684 7.78322 17.4634L16.2033 20.6418C16.72 20.8368 16.9808 21.4138 16.7857 21.9305C16.5907 22.4472 16.0137 22.7079 15.497 22.5129L8.01248 19.6877L5.18727 27.1722C4.99223 27.6889 4.41525 27.9497 3.89855 27.7546C3.38185 27.5596 3.1211 26.9826 3.31614 26.4659L6.4945 18.0458ZM72.8393 46.9776C73.3373 47.2164 73.5475 47.8137 73.3087 48.3117L69.4179 56.4272C69.1792 56.9252 68.5819 57.1354 68.0839 56.8966C67.5859 56.6579 67.3757 56.0606 67.6145 55.5626L71.073 48.3488L63.8592 44.8903C63.3612 44.6515 63.151 44.0543 63.3898 43.5563C63.6285 43.0582 64.2258 42.8481 64.7238 43.0868L72.8393 46.9776ZM8.34133 17.9871C11.6803 25.3753 18.8972 35.7163 29.642 42.6487C40.3449 49.5541 54.5676 53.0965 72.0751 46.9361L72.7389 48.8227C54.5932 55.2077 39.7291 51.5369 28.5577 44.3293C17.4282 37.1487 9.98331 26.4768 6.5188 18.8108L8.34133 17.9871Z" />
  )
};

export const PoundSymbol = {
  viewBox: "0 0 12 18",
  body: () => (
    <path d="M0.5 17.25V15.4167C4.16667 13.5833 3.70833 9.91667 3.70833 9.91667H1.41667V8.08333H3.70833C2.79167 3.95833 4.16667 0.75 7.83333 0.75C9.66667 0.75 10.5833 1.20833 10.5833 1.20833V3.04167C5.08333 1.20833 5.08333 5.33333 5.54167 8.08333H9.66667V9.91667H5.54167C5.54167 9.91667 6 13.5833 3.70833 15.4167H11.5V17.25H0.5Z" />
  )
};

export const PriceTag = {
  viewBox: "0 0 490 490",
  body: () => (
    <g id="bold_copy_41_">
      <path
        d="M490,245L369.414,97.617H0V245v147.383h369.414L490,245z M30.625,361.758V245V128.242h324.273L450.432,245l-95.535,116.758
		H30.625z"
      />
      <path
        d="M353.504,202.891c-23.229,0-42.109,18.88-42.109,42.109s18.88,42.109,42.109,42.109c23.229,0,42.109-18.88,42.109-42.109
		S376.718,202.891,353.504,202.891z M353.504,256.484c-6.324,0-11.484-5.16-11.484-11.484c0-6.324,5.16-11.484,11.484-11.484
		c6.324,0,11.484,5.16,11.484,11.484C364.989,251.324,359.828,256.484,353.504,256.484z"
      />
      <rect x="90.145" y="166.676" width="163.323" height="30.625" />
      <rect x="90.145" y="226.395" width="163.323" height="30.625" />
      <rect x="90.145" y="286.083" width="86.761" height="30.625" />
    </g>
  )
};

export const Product = {
  viewBox: "0 0 122.88 114.58",
  pathOutline: true,
  body: () => (
    <g>
      <path d="M118.13,9.54a3.25,3.25,0,0,1,2.2.41,3.28,3.28,0,0,1,2,3l.57,78.83a3.29,3.29,0,0,1-1.59,3L89.12,113.93a3.29,3.29,0,0,1-2,.65,3.07,3.07,0,0,1-.53,0L3.11,105.25A3.28,3.28,0,0,1,0,102V21.78H0A3.28,3.28,0,0,1,2,18.7L43.89.27h0A3.19,3.19,0,0,1,45.63,0l72.5,9.51Zm-37.26,1.7-24.67,14,30.38,3.88,22.5-14.18-28.21-3.7Zm-29,20L50.75,64.62,38.23,56.09,25.72,63.17l2.53-34.91L6.55,25.49V99.05l77.33,8.6V35.36l-32-4.09Zm-19.7-9.09L56.12,8,45.7,6.62,15.24,20l16.95,2.17ZM90.44,34.41v71.12l25.9-15.44-.52-71.68-25.38,16Z" />
    </g>
  )
};

export const Profile = {
  viewBox: "0 0 17 17",
  pathOutline: true,
  body: () => (
    <g>
      <path
        d="M8.83215 1C8.05761 1 7.30047 1.22968 6.65646 1.65999C6.01246 2.0903 5.51052 2.70191 5.21412 3.41749C4.91771 4.13307 4.84016 4.92048 4.99126 5.68013C5.14237 6.43979 5.51534 7.13758 6.06303 7.68526C6.61071 8.23294 7.3085 8.60591 8.06815 8.75702C8.82781 8.90812 9.61521 8.83057 10.3308 8.53417C11.0464 8.23776 11.658 7.73582 12.0883 7.09182C12.5186 6.44781 12.7483 5.69067 12.7483 4.91613C12.7483 3.87751 12.3357 2.88143 11.6013 2.14701C10.8669 1.41259 9.87077 1 8.83215 1ZM8.83215 7.70026C8.27783 7.70025 7.73598 7.53567 7.2753 7.22739C6.81461 6.9191 6.45581 6.48098 6.24439 5.96856C6.03296 5.45614 5.97843 4.89249 6.08769 4.34904C6.19695 3.8056 6.46509 3.30682 6.85813 2.91593C7.25117 2.52504 7.75141 2.25963 8.29545 2.15335C8.83949 2.04707 9.40283 2.10469 9.91408 2.31892C10.4253 2.53315 10.8615 2.89434 11.1672 3.35671C11.473 3.81908 11.6346 4.36182 11.6316 4.91613C11.6275 5.65593 11.3308 6.36405 10.8063 6.88574C10.2817 7.40743 9.57196 7.70027 8.83215 7.70026Z"
        strokeWidth={0}
      />
      <path
        d="M8.83215 1C8.05761 1 7.30047 1.22968 6.65646 1.65999C6.01246 2.0903 5.51052 2.70191 5.21412 3.41749C4.91771 4.13307 4.84016 4.92048 4.99126 5.68013C5.14237 6.43979 5.51534 7.13758 6.06303 7.68526C6.61071 8.23294 7.3085 8.60591 8.06815 8.75702C8.82781 8.90812 9.61521 8.83057 10.3308 8.53417C11.0464 8.23776 11.658 7.73582 12.0883 7.09182C12.5186 6.44781 12.7483 5.69067 12.7483 4.91613C12.7483 3.87751 12.3357 2.88143 11.6013 2.14701C10.8669 1.41259 9.87077 1 8.83215 1ZM8.83215 7.70026C8.27783 7.70025 7.73598 7.53567 7.2753 7.22739C6.81461 6.9191 6.45581 6.48098 6.24439 5.96856C6.03296 5.45614 5.97843 4.89249 6.08769 4.34904C6.19695 3.8056 6.46509 3.30682 6.85813 2.91593C7.25117 2.52504 7.75141 2.25963 8.29545 2.15335C8.83949 2.04707 9.40283 2.10469 9.91408 2.31892C10.4253 2.53315 10.8615 2.89434 11.1672 3.35671C11.473 3.81908 11.6346 4.36182 11.6316 4.91613C11.6275 5.65593 11.3308 6.36405 10.8063 6.88574C10.2817 7.40743 9.57196 7.70027 8.83215 7.70026Z"
        strokeWidth={0}
      />
      <path
        d="M12.4313 9.75009H11.2454C11.09 9.74759 10.9381 9.79528 10.8131 9.88582C10.6881 9.97637 10.5969 10.1047 10.5536 10.2511C10.4384 10.6129 10.2086 10.9291 9.89743 11.1536C9.58631 11.3781 9.21022 11.4991 8.82403 11.4991C8.43784 11.4991 8.06175 11.3781 7.75063 11.1536C7.4395 10.9291 7.20962 10.6129 7.09451 10.2511C7.05117 10.1047 6.95997 9.97637 6.83495 9.88582C6.70994 9.79528 6.55806 9.74759 6.4027 9.75009H5.21674C4.09839 9.75009 3.02585 10.186 2.23505 10.962C1.44426 11.738 1 12.7904 1 13.8878V16.0052C1 16.1638 1.06421 16.3159 1.1785 16.4281C1.2928 16.5402 1.44781 16.6032 1.60945 16.6032C1.77109 16.6032 1.9261 16.5402 2.0404 16.4281C2.15469 16.3159 2.2189 16.1638 2.2189 16.0052V13.8878C2.21889 13.1062 2.53421 12.3563 3.09594 11.802C3.65768 11.2478 4.42015 10.9343 5.21674 10.93H5.84266C5.90778 10.9317 5.97121 10.9507 6.02628 10.9848C6.08136 11.0189 6.12604 11.067 6.15562 11.124C6.4112 11.6013 6.79489 12.001 7.2652 12.2798C7.7355 12.5586 8.27454 12.706 8.82403 12.706C9.37352 12.706 9.91256 12.5586 10.3829 12.2798C10.8532 12.001 11.2369 11.6013 11.4924 11.124C11.522 11.067 11.5667 11.0189 11.6218 10.9848C11.6769 10.9507 11.7403 10.9317 11.8054 10.93H12.4313C13.2308 10.93 13.9975 11.2416 14.5628 11.7963C15.1281 12.351 15.4456 13.1034 15.4456 13.8878V16.0052C15.4456 16.1638 15.5098 16.3159 15.6241 16.4281C15.7384 16.5402 15.8934 16.6032 16.0551 16.6032C16.2167 16.6032 16.3717 16.5402 16.486 16.4281C16.6003 16.3159 16.6645 16.1638 16.6645 16.0052V13.8878C16.6645 13.3431 16.5549 12.8037 16.342 12.3006C16.129 11.7976 15.817 11.3407 15.4237 10.9563C15.0304 10.5718 14.5636 10.2674 14.0501 10.0604C13.5366 9.85342 12.9865 9.74797 12.4313 9.75009Z"
        strokeWidth={0}
      />
      <path
        d="M12.4313 9.75009H11.2454C11.09 9.74759 10.9381 9.79528 10.8131 9.88582C10.6881 9.97637 10.5969 10.1047 10.5536 10.2511C10.4384 10.6129 10.2086 10.9291 9.89743 11.1536C9.58631 11.3781 9.21022 11.4991 8.82403 11.4991C8.43784 11.4991 8.06175 11.3781 7.75063 11.1536C7.4395 10.9291 7.20962 10.6129 7.09451 10.2511C7.05117 10.1047 6.95997 9.97637 6.83495 9.88582C6.70994 9.79528 6.55806 9.74759 6.4027 9.75009H5.21674C4.09839 9.75009 3.02585 10.186 2.23505 10.962C1.44426 11.738 1 12.7904 1 13.8878V16.0052C1 16.1638 1.06421 16.3159 1.1785 16.4281C1.2928 16.5402 1.44781 16.6032 1.60945 16.6032C1.77109 16.6032 1.9261 16.5402 2.0404 16.4281C2.15469 16.3159 2.2189 16.1638 2.2189 16.0052V13.8878C2.21889 13.1062 2.53421 12.3563 3.09594 11.802C3.65768 11.2478 4.42015 10.9343 5.21674 10.93H5.84266C5.90778 10.9317 5.97121 10.9507 6.02628 10.9848C6.08136 11.0189 6.12604 11.067 6.15562 11.124C6.4112 11.6013 6.79489 12.001 7.2652 12.2798C7.7355 12.5586 8.27454 12.706 8.82403 12.706C9.37352 12.706 9.91256 12.5586 10.3829 12.2798C10.8532 12.001 11.2369 11.6013 11.4924 11.124C11.522 11.067 11.5667 11.0189 11.6218 10.9848C11.6769 10.9507 11.7403 10.9317 11.8054 10.93H12.4313C13.2308 10.93 13.9975 11.2416 14.5628 11.7963C15.1281 12.351 15.4456 13.1034 15.4456 13.8878V16.0052C15.4456 16.1638 15.5098 16.3159 15.6241 16.4281C15.7384 16.5402 15.8934 16.6032 16.0551 16.6032C16.2167 16.6032 16.3717 16.5402 16.486 16.4281C16.6003 16.3159 16.6645 16.1638 16.6645 16.0052V13.8878C16.6645 13.3431 16.5549 12.8037 16.342 12.3006C16.129 11.7976 15.817 11.3407 15.4237 10.9563C15.0304 10.5718 14.5636 10.2674 14.0501 10.0604C13.5366 9.85342 12.9865 9.74797 12.4313 9.75009Z"
        strokeWidth={0}
      />
    </g>
  )
};

export const RefreshInCircleFull = {
  viewBox: "0 0 35 35",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5Z"
      fill="#00D2C8"
    />,
    <path
      key={2}
      d="M24.2694 13.6608L24.1818 13.5748L24.0942 13.6608L20.276 17.4108L20.058 17.625H20.3636H23.1008C23.033 20.5995 20.55 23 17.5 23C16.5562 23 15.66 22.7705 14.886 22.3584L14.8051 22.3153L14.7397 22.3796L13.346 23.7483L13.2327 23.8596L13.3676 23.9436C14.5607 24.6867 15.9771 25.125 17.5 25.125C21.7435 25.125 25.1924 21.7821 25.2603 17.625H28H28.3057L28.0876 17.4108L24.2694 13.6608ZM14.6364 17.375H11.8992C11.967 14.4005 14.45 12 17.5 12C18.4438 12 19.34 12.2295 20.114 12.6416L20.1949 12.6847L20.2603 12.6204L21.654 11.2517L21.7673 11.1404L21.6324 11.0564C20.4393 10.3133 19.0229 9.875 17.5 9.875C13.2565 9.875 9.80756 13.2179 9.73966 17.375H7H6.69434L6.91241 17.5892L10.7306 21.3392L10.8182 21.4252L10.9058 21.3392L14.724 17.5892L14.942 17.375H14.6364Z"
      fill="white"
      stroke="white"
      strokeWidth="0.25"
    />
  ]
};

export const RobbinsEggBlueObbyLogo = {
  viewBox: "0 0 131 108",
  body: () => [
    <g key={1} clipPath="url(#clip0)">
      <path
        d="M60.7955 5.62446C25.0162 8.91077 1.49981 27.5375 4.38319 58.9299C7.30682 90.7604 33.8228 104.792 69.6021 101.505C105.821 98.1787 129.337 79.552 126.413 47.7215C123.53 16.329 97.014 2.2978 60.7955 5.62446Z"
        fill="#00D2C8"
      />
      <path
        d="M30.4294 46.9421C23.7422 47.5563 19.7296 52.9066 20.2728 58.8201C20.883 65.4636 26.0439 68.597 32.0234 68.0478C38.7107 67.4336 42.7232 62.0833 42.1801 56.1698C41.5699 49.5263 36.4089 46.3929 30.4294 46.9421ZM32.0922 64.7776C29.5784 65.0085 27.9123 62.143 27.4318 56.9109C27.0294 52.5306 28.3083 50.3763 30.3096 50.1925C32.8234 49.9616 34.5383 52.8225 35.0188 58.0546C35.4212 62.435 34.0935 64.5938 32.0922 64.7776Z"
        fill="#D7F0FA"
      />
      <path
        d="M56.9104 44.5096C54.3478 44.745 52.303 46.3316 51.4838 48.9346L50.3953 37.0833L43.7818 38.5006L45.5453 57.7011C46.1555 64.3446 49.9623 66.3999 55.9418 65.8507C62.9463 65.2074 66.2623 60.0438 65.6856 53.7653C65.1201 47.6084 61.1327 44.1218 56.9104 44.5096ZM55.8885 62.5917C53.8628 62.7778 52.5904 61.2504 52.2439 57.4785L51.5466 49.8859C51.9192 49.6553 52.3917 49.4401 53.2215 49.3639C56.3699 49.0747 58.3448 52.6235 58.7136 56.6388C59.1003 60.8488 57.4749 62.446 55.8885 62.5917Z"
        fill="#D7F0FA"
      />
      <path
        d="M80.4372 42.3487C77.8746 42.5841 75.8299 44.1707 75.0106 46.7737L73.9221 34.9224L67.3086 36.3397L69.0722 55.5402C69.6824 62.1837 73.4891 64.239 79.4686 63.6898C86.4731 63.0465 89.7891 57.8829 89.2124 51.6044C88.6469 45.4476 84.6595 41.9609 80.4372 42.3487ZM79.4398 60.4286C77.4141 60.6146 76.1416 59.0873 75.7952 55.3153L75.0978 47.7227C75.4704 47.4922 75.9429 47.277 76.7727 47.2008C79.9211 46.9116 81.896 50.4604 82.2648 54.4757C82.6515 58.6857 81.0262 60.2829 79.4398 60.4286Z"
        fill="#D7F0FA"
      />
      <path
        d="M105.514 40.4382L101.92 52.2286L96.581 41.2586L89.1128 41.9446L98.8374 60.7329L95.9159 68.5842L100.211 68.1897L109.809 40.0436L105.514 40.4382Z"
        fill="#D7F0FA"
      />
    </g>,
    <defs key={2}>
      <clipPath id="clip0">
        <rect
          y="11.2085"
          width="122.544"
          height="96.2845"
          transform="rotate(-5.24787 0 11.2085)"
          fill="white"
        />
      </clipPath>
    </defs>
  ]
};

export const RoundChevronLeft = {
  viewBox: "0 0 60 60",
  body: () => (
    <>
      <circle
        cx="30"
        cy="30"
        r="28"
        fill="#D7F0FA"
        stroke="#03C2B9"
        strokeWidth="4"
      />
      <path
        key={1}
        d="M28.8606 18.2275L15.9492 29.9997L28.8606 41.7718"
        stroke="#03C2B9"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        key={2}
        d="M17.0879 30.3799H44.8094"
        stroke="#03C2B9"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </>
  )
};

export const RoundChevronRight = {
  viewBox: "0 0 60 60",
  body: () => (
    <>
      <circle
        cx="30"
        cy="30"
        r="28"
        fill="#D7F0FA"
        stroke="#03C2B9"
        strokeWidth="4"
      />
      <path
        key={1}
        d="M32.6589 41.7725L45.5703 30.0003L32.6589 18.2282"
        stroke="#03C2B9"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        key={2}
        d="M17.0879 30.3799H44.8094"
        stroke="#03C2B9"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </>
  )
};

export const Search = {
  viewBox: "0 0 20 20",
  strokeOutline: true,
  body: () => (
    <g
      fill="none"
      fillRule="evenodd"
      // stroke="#565A5C"
      strokeWidth="2"
      transform="translate(1 1)"
    >
      <circle cx="7.5" cy="7.5" r="7.5" />
      <path strokeLinecap="square" d="M13.5 13.5l4 4" />
    </g>
  )
};

export const Shapes = {
  viewBox: "0 0 62 62",
  body: () => (
    <>
      <path d="M31.0003 5.1665L16.792 28.4165H45.2087L31.0003 5.1665Z" />
      <path d="M45.208 56.8335C51.6283 56.8335 56.833 51.6288 56.833 45.2085C56.833 38.7882 51.6283 33.5835 45.208 33.5835C38.7877 33.5835 33.583 38.7882 33.583 45.2085C33.583 51.6288 38.7877 56.8335 45.208 56.8335Z" />
      <path d="M7.75 34.875H28.4167V55.5417H7.75V34.875Z" />
    </>
  )
};

export const ShoppingTag = {
  viewBox: "0 0 22 22",
  body: () => (
    <>
      <path
        d="M15.4222 4.78721L16.0167 4.19267C16.0531 4.15627 16.082 4.11305 16.1018 4.06548C16.1215 4.01791 16.1316 3.96692 16.1316 3.91543C16.1316 3.86394 16.1215 3.81295 16.1018 3.76538C16.082 3.71781 16.0531 3.67459 16.0167 3.63819L13.6555 1.27693C13.6191 1.24052 13.5759 1.21162 13.5283 1.19191C13.4807 1.1722 13.4297 1.16206 13.3782 1.16206C13.3267 1.16206 13.2758 1.1722 13.2282 1.19191C13.1806 1.21163 13.1374 1.24052 13.101 1.27693L1.27724 13.1007C1.24082 13.1371 1.21193 13.1803 1.19222 13.2279C1.17251 13.2755 1.16236 13.3264 1.16236 13.3779C1.16236 13.4294 1.17251 13.4804 1.19222 13.528C1.21193 13.5755 1.24082 13.6188 1.27724 13.6552L3.6385 16.0164C3.6749 16.0528 3.71812 16.0817 3.76569 16.1014C3.81326 16.1212 3.86424 16.1313 3.91573 16.1313C3.96723 16.1313 4.01821 16.1212 4.06578 16.1014C4.11335 16.0817 4.15657 16.0528 4.19297 16.0164L4.4139 15.7955C4.59883 15.6153 4.84681 15.5145 5.105 15.5145C5.36319 15.5144 5.61119 15.6152 5.79616 15.7954C5.97921 15.9788 6.082 16.2274 6.082 16.4866C6.082 16.7457 5.97921 16.9943 5.79616 17.1778L5.57524 17.3987C5.5388 17.4351 5.5099 17.4783 5.49018 17.5259C5.47046 17.5734 5.46031 17.6244 5.46031 17.6759C5.46031 17.7274 5.47046 17.7784 5.49018 17.826C5.5099 17.8736 5.5388 17.9168 5.57524 17.9532L8.42912 20.8071C8.46551 20.8435 8.50873 20.8724 8.5563 20.8921C8.60387 20.9118 8.65486 20.922 8.70636 20.922C8.75785 20.922 8.80885 20.9118 8.85642 20.8921C8.90399 20.8724 8.9472 20.8435 8.9836 20.8071L20.8074 8.98329C20.8438 8.9469 20.8727 8.90368 20.8924 8.85611C20.9121 8.80854 20.9223 8.75755 20.9223 8.70605C20.9223 8.65456 20.9121 8.60357 20.8924 8.556C20.8727 8.50843 20.8438 8.46521 20.8074 8.42882L17.9535 5.57493C17.9171 5.5385 17.8739 5.5096 17.8263 5.48988C17.7787 5.47015 17.7277 5.46 17.6762 5.46C17.6247 5.46 17.5737 5.47015 17.5262 5.48987C17.4786 5.50959 17.4354 5.5385 17.399 5.57493L16.8044 6.16948C16.7144 6.26151 16.6069 6.33464 16.4882 6.38456C16.3695 6.43449 16.242 6.4602 16.1132 6.4602C15.9845 6.4602 15.857 6.43449 15.7383 6.38456C15.6196 6.33464 15.5121 6.26152 15.422 6.16948C15.239 5.98603 15.1362 5.73746 15.1363 5.47832C15.1363 5.21918 15.2391 4.97063 15.4222 4.78721ZM17.3589 6.72395L17.6762 6.40665L19.9756 8.70606L8.70636 19.9753L6.4056 17.6746C6.7109 17.3396 6.87551 16.8999 6.86528 16.4467C6.85504 15.9936 6.67075 15.5618 6.35062 15.2409C6.027 14.9259 5.59612 14.7452 5.14464 14.735C4.69316 14.7249 4.25458 14.886 3.91709 15.1861L2.10895 13.3779L4.66284 10.824L4.94319 11.1044C5.01672 11.1779 5.11644 11.2192 5.22043 11.2192C5.32441 11.2192 5.42414 11.1779 5.49766 11.1044C5.57119 11.0309 5.6125 10.9311 5.6125 10.8271C5.6125 10.7232 5.57119 10.6234 5.49766 10.5499L5.21732 10.2696L13.3782 2.10865L15.185 3.91543L14.8677 4.23274C14.5378 4.56334 14.3526 5.01129 14.3525 5.47832C14.3525 5.94535 14.5377 6.39331 14.8676 6.72396C15.0299 6.88981 15.2237 7.02158 15.4376 7.11154C15.6515 7.2015 15.8812 7.24784 16.1132 7.24784C16.3453 7.24784 16.575 7.2015 16.7889 7.11153C17.0028 7.02157 17.1966 6.8898 17.3589 6.72395Z"
        fill="#666666"
      />
      <path
        d="M15.4222 4.78721L16.0167 4.19267C16.0531 4.15627 16.082 4.11305 16.1018 4.06548C16.1215 4.01791 16.1316 3.96692 16.1316 3.91543C16.1316 3.86394 16.1215 3.81295 16.1018 3.76538C16.082 3.71781 16.0531 3.67459 16.0167 3.63819L13.6555 1.27693C13.6191 1.24052 13.5759 1.21162 13.5283 1.19191C13.4807 1.1722 13.4297 1.16206 13.3782 1.16206C13.3267 1.16206 13.2758 1.1722 13.2282 1.19191C13.1806 1.21163 13.1374 1.24052 13.101 1.27693L1.27724 13.1007C1.24082 13.1371 1.21193 13.1803 1.19222 13.2279C1.17251 13.2755 1.16236 13.3264 1.16236 13.3779C1.16236 13.4294 1.17251 13.4804 1.19222 13.528C1.21193 13.5755 1.24082 13.6188 1.27724 13.6552L3.6385 16.0164C3.6749 16.0528 3.71812 16.0817 3.76569 16.1014C3.81326 16.1212 3.86424 16.1313 3.91573 16.1313C3.96723 16.1313 4.01821 16.1212 4.06578 16.1014C4.11335 16.0817 4.15657 16.0528 4.19297 16.0164L4.4139 15.7955C4.59883 15.6153 4.84681 15.5145 5.105 15.5145C5.36319 15.5144 5.61119 15.6152 5.79616 15.7954C5.97921 15.9788 6.082 16.2274 6.082 16.4866C6.082 16.7457 5.97921 16.9943 5.79616 17.1778L5.57524 17.3987C5.5388 17.4351 5.5099 17.4783 5.49018 17.5259C5.47046 17.5734 5.46031 17.6244 5.46031 17.6759C5.46031 17.7274 5.47046 17.7784 5.49018 17.826C5.5099 17.8736 5.5388 17.9168 5.57524 17.9532L8.42912 20.8071C8.46551 20.8435 8.50873 20.8724 8.5563 20.8921C8.60387 20.9118 8.65486 20.922 8.70636 20.922C8.75785 20.922 8.80885 20.9118 8.85642 20.8921C8.90399 20.8724 8.9472 20.8435 8.9836 20.8071L20.8074 8.98329C20.8438 8.9469 20.8727 8.90368 20.8924 8.85611C20.9121 8.80854 20.9223 8.75755 20.9223 8.70605C20.9223 8.65456 20.9121 8.60357 20.8924 8.556C20.8727 8.50843 20.8438 8.46521 20.8074 8.42882L17.9535 5.57493C17.9171 5.5385 17.8739 5.5096 17.8263 5.48988C17.7787 5.47015 17.7277 5.46 17.6762 5.46C17.6247 5.46 17.5737 5.47015 17.5262 5.48987C17.4786 5.50959 17.4354 5.5385 17.399 5.57493L16.8044 6.16948C16.7144 6.26151 16.6069 6.33464 16.4882 6.38456C16.3695 6.43449 16.242 6.4602 16.1132 6.4602C15.9845 6.4602 15.857 6.43449 15.7383 6.38456C15.6196 6.33464 15.5121 6.26152 15.422 6.16948C15.239 5.98603 15.1362 5.73746 15.1363 5.47832C15.1363 5.21918 15.2391 4.97063 15.4222 4.78721ZM17.3589 6.72395L17.6762 6.40665L19.9756 8.70606L8.70636 19.9753L6.4056 17.6746C6.7109 17.3396 6.87551 16.8999 6.86528 16.4467C6.85504 15.9936 6.67075 15.5618 6.35062 15.2409C6.027 14.9259 5.59612 14.7452 5.14464 14.735C4.69316 14.7249 4.25458 14.886 3.91709 15.1861L2.10895 13.3779L4.66284 10.824L4.94319 11.1044C5.01672 11.1779 5.11644 11.2192 5.22043 11.2192C5.32441 11.2192 5.42414 11.1779 5.49766 11.1044C5.57119 11.0309 5.6125 10.9311 5.6125 10.8271C5.6125 10.7232 5.57119 10.6234 5.49766 10.5499L5.21732 10.2696L13.3782 2.10865L15.185 3.91543L14.8677 4.23274C14.5378 4.56334 14.3526 5.01129 14.3525 5.47832C14.3525 5.94535 14.5377 6.39331 14.8676 6.72396C15.0299 6.88981 15.2237 7.02158 15.4376 7.11154C15.6515 7.2015 15.8812 7.24784 16.1132 7.24784C16.3453 7.24784 16.575 7.2015 16.7889 7.11153C17.0028 7.02157 17.1966 6.8898 17.3589 6.72395Z"
        stroke="#666666"
        strokeWidth="0.4"
      />
      <path
        d="M6.16103 11.7677C6.12461 11.8041 6.09572 11.8473 6.076 11.8949C6.05629 11.9424 6.04615 11.9934 6.04615 12.0449C6.04615 12.0964 6.05629 12.1474 6.076 12.195C6.09572 12.2425 6.12461 12.2858 6.16103 12.3222L6.71862 12.8797C6.79214 12.9533 6.89187 12.9946 6.99585 12.9946C7.09984 12.9946 7.19956 12.9533 7.27309 12.8797C7.34662 12.8062 7.38793 12.7065 7.38793 12.6025C7.38793 12.4985 7.34662 12.3988 7.27309 12.3253L6.7155 11.7677C6.6791 11.7313 6.63588 11.7024 6.58831 11.6827C6.54074 11.663 6.48976 11.6528 6.43826 11.6528C6.38677 11.6528 6.33579 11.663 6.28822 11.6827C6.24065 11.7024 6.19743 11.7313 6.16103 11.7677Z"
        fill="#666666"
      />
      <path
        d="M6.16103 11.7677C6.12461 11.8041 6.09572 11.8473 6.076 11.8949C6.05629 11.9424 6.04615 11.9934 6.04615 12.0449C6.04615 12.0964 6.05629 12.1474 6.076 12.195C6.09572 12.2425 6.12461 12.2858 6.16103 12.3222L6.71862 12.8797C6.79214 12.9533 6.89187 12.9946 6.99585 12.9946C7.09984 12.9946 7.19956 12.9533 7.27309 12.8797C7.34662 12.8062 7.38793 12.7065 7.38793 12.6025C7.38793 12.4985 7.34662 12.3988 7.27309 12.3253L6.7155 11.7677C6.6791 11.7313 6.63588 11.7024 6.58831 11.6827C6.54074 11.663 6.48976 11.6528 6.43826 11.6528C6.38677 11.6528 6.33579 11.663 6.28822 11.6827C6.24065 11.7024 6.19743 11.7313 6.16103 11.7677Z"
        stroke="#666666"
        strokeWidth="0.4"
      />
      <path
        d="M7.93666 13.5436C7.90024 13.58 7.87135 13.6232 7.85164 13.6708C7.83193 13.7183 7.82178 13.7693 7.82178 13.8208C7.82178 13.8723 7.83193 13.9233 7.85164 13.9708C7.87135 14.0184 7.90024 14.0616 7.93666 14.098L8.49411 14.6555C8.56764 14.729 8.66737 14.7703 8.77135 14.7703C8.87534 14.7703 8.97506 14.729 9.04859 14.6555C9.12212 14.582 9.16343 14.4822 9.16343 14.3783C9.16343 14.2743 9.12212 14.1745 9.04859 14.101L8.49114 13.5436C8.45474 13.5071 8.41152 13.4783 8.36395 13.4585C8.31638 13.4388 8.26539 13.4287 8.2139 13.4287C8.16241 13.4287 8.11142 13.4388 8.06385 13.4585C8.01628 13.4783 7.97306 13.5071 7.93666 13.5436Z"
        fill="#666666"
      />
      <path
        d="M7.93666 13.5436C7.90024 13.58 7.87135 13.6232 7.85164 13.6708C7.83193 13.7183 7.82178 13.7693 7.82178 13.8208C7.82178 13.8723 7.83193 13.9233 7.85164 13.9708C7.87135 14.0184 7.90024 14.0616 7.93666 14.098L8.49411 14.6555C8.56764 14.729 8.66737 14.7703 8.77135 14.7703C8.87534 14.7703 8.97506 14.729 9.04859 14.6555C9.12212 14.582 9.16343 14.4822 9.16343 14.3783C9.16343 14.2743 9.12212 14.1745 9.04859 14.101L8.49114 13.5436C8.45474 13.5071 8.41152 13.4783 8.36395 13.4585C8.31638 13.4388 8.26539 13.4287 8.2139 13.4287C8.16241 13.4287 8.11142 13.4388 8.06385 13.4585C8.01628 13.4783 7.97306 13.5071 7.93666 13.5436Z"
        stroke="#666666"
        strokeWidth="0.4"
      />
      <path
        d="M9.71205 15.319C9.67562 15.3553 9.64671 15.3986 9.62699 15.4461C9.60727 15.4937 9.59712 15.5447 9.59712 15.5962C9.59712 15.6477 9.60727 15.6987 9.62699 15.7462C9.64671 15.7938 9.67562 15.837 9.71205 15.8734L10.2695 16.4309C10.343 16.5044 10.4428 16.5457 10.5467 16.5457C10.6507 16.5457 10.7505 16.5044 10.824 16.4309C10.8975 16.3574 10.9388 16.2576 10.9388 16.1536C10.9388 16.0497 10.8975 15.9499 10.824 15.8764L10.2665 15.319C10.2301 15.2825 10.1869 15.2536 10.1393 15.2339C10.0918 15.2142 10.0408 15.204 9.98929 15.204C9.93779 15.204 9.8868 15.2142 9.83923 15.2339C9.79166 15.2536 9.74844 15.2825 9.71205 15.319Z"
        fill="#666666"
      />
      <path
        d="M9.71205 15.319C9.67562 15.3553 9.64671 15.3986 9.62699 15.4461C9.60727 15.4937 9.59712 15.5447 9.59712 15.5962C9.59712 15.6477 9.60727 15.6987 9.62699 15.7462C9.64671 15.7938 9.67562 15.837 9.71205 15.8734L10.2695 16.4309C10.343 16.5044 10.4428 16.5457 10.5467 16.5457C10.6507 16.5457 10.7505 16.5044 10.824 16.4309C10.8975 16.3574 10.9388 16.2576 10.9388 16.1536C10.9388 16.0497 10.8975 15.9499 10.824 15.8764L10.2665 15.319C10.2301 15.2825 10.1869 15.2536 10.1393 15.2339C10.0918 15.2142 10.0408 15.204 9.98929 15.204C9.93779 15.204 9.8868 15.2142 9.83923 15.2339C9.79166 15.2536 9.74844 15.2825 9.71205 15.319Z"
        stroke="#666666"
        strokeWidth="0.4"
      />
    </>
  )
};

export const SpeechBubbleBold = {
  viewBox: "0 0 18 16",
  body: () => (
    <path
      d="M9 16C7.50073 16 6.01727 15.6605 4.69317 15.0179L2.11127 15.5533C2.00409 15.5756 1.89295 15.5713 1.78793 15.5406C1.6829 15.5099 1.58731 15.4539 1.50983 15.3776C1.43234 15.3013 1.37542 15.2072 1.34421 15.1038C1.31301 15.0003 1.30851 14.8909 1.33112 14.7853L1.76532 12.7533C0.608927 11.3682 0 9.73189 0 8C0 3.58832 4.03727 0 9 0C13.9623 0 18 3.58832 18 8C18 12.4112 13.9623 16 9 16ZM13.3902 8.86487C13.5056 8.86481 13.6198 8.84237 13.7264 8.79883C13.833 8.75529 13.9298 8.69151 14.0113 8.61112C14.0928 8.53073 14.1575 8.43531 14.2016 8.3303C14.2457 8.2253 14.2684 8.11277 14.2683 7.99914C14.2682 7.8855 14.2455 7.77299 14.2013 7.66803C14.1571 7.56307 14.0923 7.46771 14.0107 7.3874C13.9291 7.30709 13.8322 7.2434 13.7256 7.19997C13.619 7.15654 13.5047 7.13421 13.3894 7.13427C13.1564 7.13439 12.933 7.22566 12.7683 7.38802C12.6036 7.55037 12.5112 7.77051 12.5113 8C12.5114 8.22949 12.6041 8.44954 12.7689 8.61173C12.9338 8.77392 13.1573 8.86498 13.3902 8.86487ZM9 8.86487C9.11536 8.86481 9.22959 8.84237 9.33615 8.79883C9.44271 8.75529 9.53952 8.69151 9.62106 8.61112C9.70259 8.53073 9.76725 8.43531 9.81135 8.3303C9.85544 8.2253 9.87811 8.11277 9.87805 7.99914C9.87799 7.8855 9.85521 7.77299 9.81101 7.66803C9.76681 7.56307 9.70205 7.46771 9.62043 7.3874C9.53882 7.30709 9.44194 7.2434 9.33534 7.19997C9.22873 7.15654 9.11449 7.13421 8.99912 7.13427C8.76613 7.13439 8.54273 7.22566 8.37807 7.38802C8.2134 7.55037 8.12096 7.77051 8.12107 8C8.12119 8.22949 8.21386 8.44954 8.37869 8.61173C8.54352 8.77392 8.76701 8.86498 9 8.86487ZM4.60976 8.86487C4.72512 8.86481 4.83934 8.84237 4.94591 8.79883C5.05247 8.75529 5.14928 8.69151 5.23081 8.61112C5.31235 8.53073 5.37701 8.43531 5.4211 8.3303C5.4652 8.2253 5.48786 8.11277 5.48781 7.99914C5.48775 7.8855 5.46497 7.77299 5.42077 7.66803C5.37656 7.56307 5.31181 7.46771 5.23019 7.3874C5.14858 7.30709 5.0517 7.2434 4.94509 7.19997C4.83849 7.15654 4.72424 7.13421 4.60888 7.13427C4.37589 7.13439 4.15249 7.22566 3.98782 7.38802C3.82316 7.55037 3.73071 7.77051 3.73083 8C3.73095 8.22949 3.82361 8.44954 3.98844 8.61173C4.15327 8.77392 4.37677 8.86498 4.60976 8.86487Z"
      fill="#822D50"
    />
  )
};

export const Spinner = {
  viewBox: "0 0 30 30",
  body: () => (
    <g fill="none" fillRule="evenodd" strokeWidth="3">
      <circle cx="15" cy="15" r="13.5" stroke="#898989" opacity=".1" />
      <path
        stroke="#28283c"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M28.5 15c0-7.456-6.044-13.5-13.5-13.5"
      />
    </g>
  )
};

export const Star = {
  viewBox: "0 0 15 15",
  body: () => (
    <g strokeWidth={0} fillRule="evenodd">
      <polygon
        id="Star"
        points="7.5 11.82895 2.86474508 14.2658477 3.75 9.10441554 1.11022302e-16 5.44906896 5.18237254 4.69602615 7.5 0 9.81762746 4.69602615 15 5.44906896 11.25 9.10441554 12.1352549 14.2658477"
      />
    </g>
  )
};

export const StarInCircleFull = {
  viewBox: "0 0 24 24",
  body: () => [
    <circle key={1} cx="12" cy="12" r="12" fill="#CDD2D2" />,
    <path
      key={2}
      d="M12 15.1826L15.71 18L14.29 13.4504L18 10.6957H13.45L12 6L10.55 10.6957H6L9.71 13.4504L8.29 18L12 15.1826Z"
      fill="white"
    />
  ]
};

export const StarSquare = {
  viewBox: "0 0 44 44",
  body: () => (
    <path
      d="M38.965 17.1667V38.9167H5.08334V5.08333H26.8333V0.25H5.13167C2.47334 0.25 0.29834 2.425 0.29834 5.08333V38.9167C0.29834 41.575 2.47334 43.75 5.13167 43.75H38.965C41.6233 43.75 43.7983 41.575 43.7983 38.9167V17.1667H38.965ZM34.0833 17.1667L36.355 12.1883L41.3333 9.91667L36.355 7.645L34.0833 2.66667L31.8117 7.645L26.8333 9.91667L31.8117 12.1883L34.0833 17.1667ZM25.0208 18.9792L22 12.3333L18.9792 18.9792L12.3333 22L18.9792 25.0208L22 31.6667L25.0208 25.0208L31.6667 22L25.0208 18.9792Z"
      fill="#822D50"
    />
  )
};

export const Suitcase = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 9C2 7.89543 2.89543 7 4 7H20C21.1046 7 22 7.89543 22 9V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V9Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      d="M16 21V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V21"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const Teacher = {
  viewBox: "0 0 38 31",
  pathOutline: true,
  body: () => (
    <g>
      <path
        strokeWidth={0}
        d="M10.075 20.15C6.22943 20.15 3.09998 17.019 3.09998 13.175C3.09998 9.33095 6.22943 6.19995 10.075 6.19995C13.9205 6.19995 17.05 9.33095 17.05 13.175C17.05 17.019 13.9205 20.15 10.075 20.15ZM10.075 7.74995C7.08348 7.74995 4.64998 10.1835 4.64998 13.175C4.64998 16.1665 7.08348 18.6 10.075 18.6C13.0665 18.6 15.5 16.1665 15.5 13.175C15.5 10.1835 13.0665 7.74995 10.075 7.74995Z"
      />
      <path
        strokeWidth={0}
        d="M19.375 31H0.775C0.3472 31 0 30.6528 0 30.225V27.3823C0 23.1213 2.72955 19.2928 6.79365 17.856L7.3098 19.3176C3.86415 20.5344 1.55 23.7754 1.55 27.3807V29.45H18.6V27.125C18.6 23.6049 16.3014 20.46 12.879 19.3037L13.375 17.8358C17.4267 19.206 20.15 22.9384 20.15 27.125V30.225C20.15 30.6528 19.8013 31 19.375 31Z"
      />
      <path
        strokeWidth={0}
        d="M36.425 26.35H18.6V24.8H35.65V1.55H9.3V7.75H7.75V0.775C7.75 0.3472 8.0972 0 8.525 0H36.425C36.8513 0 37.2 0.3472 37.2 0.775V25.575C37.2 26.0028 36.8513 26.35 36.425 26.35Z"
      />
      <path
        strokeWidth={0}
        d="M29.45 6.20003H20.15C19.7238 6.20003 19.375 5.85283 19.375 5.42502C19.375 4.99722 19.7238 4.65002 20.15 4.65002H29.45C29.8763 4.65002 30.225 4.99722 30.225 5.42502C30.225 5.85283 29.8763 6.20003 29.45 6.20003Z"
      />
      <path
        strokeWidth={0}
        d="M32.55 10.85H20.15C19.7238 10.85 19.375 10.5028 19.375 10.075C19.375 9.64725 19.7238 9.30005 20.15 9.30005H32.55C32.9763 9.30005 33.325 9.64725 33.325 10.075C33.325 10.5028 32.9763 10.85 32.55 10.85Z"
      />
      <path
        strokeWidth={0}
        d="M32.55 15.5H20.15C19.7238 15.5 19.375 15.1528 19.375 14.725C19.375 14.2972 19.7238 13.95 20.15 13.95H32.55C32.9763 13.95 33.325 14.2972 33.325 14.725C33.325 15.1528 32.9763 15.5 32.55 15.5Z"
      />
      <path
        strokeWidth={0}
        d="M17.9583 22.3418C17.7599 22.3418 17.5615 22.2658 17.4096 22.1155C17.1074 21.8163 17.1074 21.3219 17.4096 21.0196L21.7946 16.6362C22.0953 16.3371 22.5882 16.3371 22.8904 16.6362C23.1911 16.9385 23.1911 17.4329 22.8904 17.7321L18.5055 22.1155C18.3551 22.2658 18.1567 22.3418 17.9583 22.3418Z"
      />
    </g>
  )
};

export const ThinTick = {
  viewBox: "0 0 18 14",
  body: () => (
    <path
      stroke="none"
      fill="#8298AB"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.80934 11.3968L16.7878 0.5L17.8499 1.55405L5.81425 13.5L5.76569 13.4518L0.149902 7.88009L1.21198 6.82604L5.80934 11.3968Z"
    />
  )
};

export const ThreeDollarSign = {
  viewBox: "0 0 1000 1000",
  pathOutline: true,
  body: () => (
    // <g>
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
      {/*<path d="M4622.6,5013.9c-632.5-53.7-1215.1-214.6-1782.4-492.5c-500.2-245.3-856.7-498.3-1263-891.2c-417.8-408.2-722.6-828-981.3-1353.1c-241.5-494.5-389.1-979.4-471.5-1552.4c-32.6-226.2-32.6-981.3,0-1207.4c136.1-948.7,504.1-1803.5,1082.9-2506.9c1353.1-1642.5,3595.5-2229,5571.5-1458.5C8043.7-3953.7,9071-2924.5,9569.3-1651.9C9772.5-1128.7,9876-626.6,9897-42c46,1326.3-446.6,2604.6-1374.2,3562.9C7687.2,4383.4,6619.7,4897,5427.6,5008.2C5232.1,5025.4,4800.9,5029.3,4622.6,5013.9z M5676.7,4358.5C6592.9,4205.1,7371,3804.6,8026.5,3151c553.9-553.9,923.8-1197.9,1117.4-1941.5c109.2-415.9,134.2-624.8,134.2-1079c1.9-460-26.8-691.9-134.2-1102c-389.1-1487.3-1567.8-2665.9-3055-3055c-410.1-107.3-642.1-136.1-1102-134.2c-454.2,0-663.1,24.9-1079,134.2c-743.6,193.6-1387.6,563.5-1941.5,1117.4c-663.1,667-1063.7,1456.6-1219,2407.2c-46,295.1-46,952.5,1.9,1245.8c155.2,956.4,553.9,1742.2,1217,2407.2c726.4,726.4,1650.2,1157.6,2685.1,1251.5C4858.4,4421.7,5452.5,4394.9,5676.7,4358.5z" />*/}
      <path d="M4666.7,2169.7l-5.7-272.1l-120.7-32.6C4007.4,1719.3,3672,1288.1,3718,801.3c40.3-435.1,325.8-699.5,1023.5-956.4c295.2-107.3,408.2-168.7,504.1-272.2c101.6-109.2,118.8-218.5,55.6-346.9c-38.3-76.7-65.2-101.6-159.1-149.5c-111.2-55.6-122.7-57.5-383.3-57.5c-304.7,0-456.2,32.6-739.8,153.3c-86.2,36.4-162.9,65.1-166.7,59.4c-3.8-3.8-44.1-151.4-90.1-327.7l-84.3-320.1l105.4-46c197.4-88.2,433.1-145.7,778.1-189.7l90.1-11.5v-268.3v-266.4h277.9h277.9v293.2v291.3l139.9,32.6c222.3,53.7,406.3,155.2,561.6,310.5c212.7,212.7,295.1,412.1,295.1,709.1c0,291.3-76.7,490.7-258.7,670.8c-141.8,141.8-312.4,239.6-672.7,383.3c-375.7,149.5-486.8,205.1-582.6,291.3c-132.2,120.7-141.8,283.7-24.9,394.8c161,153.3,571.1,162.9,973.6,23c105.4-36.4,205.1-70.9,222.3-76.7c24.9-9.6,44.1,42.2,109.2,302.8c44.1,172.5,72.8,318.1,65.2,325.8c-55.6,55.6-414,147.6-697.6,178.2l-111.2,11.5v249.2V2440h-277.9h-276L4666.7,2169.7z" />
      <path d="M2140.7,1236.4v-149.5l-90.1-24.9c-251.1-65.2-427.4-279.8-427.4-515.6c0-247.2,145.7-414,473.4-542.4c341.1-132.2,408.2-180.1,408.2-297.1c0-191.7-297.1-253-642.1-130.3c-72.8,26.8-141.8,49.8-151.4,51.7c-15.3,3.8-36.4-67.1-95.8-304.7c-9.6-34.5,3.8-47.9,82.4-82.4c51.7-21.1,157.2-49.8,235.7-61.3c76.7-11.5,151.4-24.9,164.8-28.8c15.3-3.8,23-51.7,23-151.4V-1144h153.3h151.4l5.7,155.2l5.7,155.3l116.9,38.3c157.1,51.7,287.5,153.3,360.3,283.7c53.7,93.9,59.4,122.7,59.4,258.7c0,128.4-7.7,170.6-49.8,249.2c-57.5,115-187.8,218.5-362.2,289.4c-241.5,99.7-373.7,162.9-415.9,203.2c-44.1,40.2-55.6,115-32.6,178.2c40.2,101.6,318.1,124.6,557.7,44.1l136.1-46l40.3,155.2c23,84.3,40.2,162.9,40.2,176.3c0,26.8-208.9,92-348.8,111.2l-92,11.5v134.2v132.2H2294h-153.3V1236.4z" />
      <path d="M7583.7,1236.4v-149.5l-90.1-24.9c-251.1-65.2-427.4-279.8-427.4-515.6c0-247.2,145.7-414,473.4-542.4c341.2-132.2,408.2-180.1,408.2-297.1c0-191.7-297.1-253-642.1-130.3c-72.8,26.8-141.8,49.8-151.4,51.7c-11.5,3.8-101.6-277.9-107.3-333.5c-1.9-26.8,195.5-93.9,329.6-115c76.7-11.5,151.4-24.9,164.8-28.8c15.3-3.8,23-51.7,23-151.4V-1144h153.3h151.4l5.7,155.2l5.8,155.3l116.9,38.3c241.5,78.6,404.4,268.3,423.6,494.5c26.8,289.4-116.9,473.4-481.1,613.3c-354.6,138-437,212.7-383.3,354.6c40.3,101.6,318.2,124.6,557.7,44.1l138-46l38.3,159.1c23,86.3,40.2,166.7,40.2,176.3c0,23-218.5,90.1-348.8,107.3l-92,11.5v134.2v132.2h-153.3h-153.3V1236.4z" />
      {/*</g>*/}
    </g>
  )
};

export const ThreePeopleThin = {
  viewBox: "0 0 34 28",
  pathOutline: true,
  body: () => (
    <path
      d="M1.71425 26.9886C1.71425 28.0858 0 28.0858 0 26.9886C0 23.5601 2.12567 20.6116 5.07419 19.4459C3.97707 18.5545 3.29137 17.1831 3.29137 15.606C3.29137 12.9318 5.41704 10.7375 8.15984 10.7375C8.91411 10.7375 9.66839 10.9432 10.3541 11.2861C11.2455 10.2575 12.3426 9.36613 13.714 8.81757C12.5483 7.92616 11.8626 6.55475 11.8626 5.04621C11.8626 2.37198 14.0569 0.177734 16.7311 0.177734C19.4053 0.177734 21.5996 2.37198 21.5996 5.04621C21.5996 6.55475 20.8453 7.92616 19.7482 8.81757C21.051 9.36613 22.2167 10.2575 23.1081 11.2861C23.7253 10.9432 24.4795 10.7375 25.3024 10.7375C27.9766 10.7375 30.1708 12.9318 30.1708 15.606C30.1708 17.1831 29.4851 18.5545 28.388 19.4459C31.3365 20.6116 33.4622 23.5601 33.4622 26.9886C33.4622 28.0858 31.6794 28.0858 31.6794 26.9886C31.6794 23.423 28.868 20.5431 25.3024 20.5431C21.8053 20.5431 18.9254 23.423 18.9254 26.9886C18.9254 28.0858 17.2111 28.0858 17.2111 26.9886C17.2111 23.5601 19.2682 20.6116 22.2853 19.4459C21.1882 18.5545 20.4339 17.1831 20.4339 15.606C20.4339 14.3717 20.9139 13.2061 21.7367 12.3832C20.571 10.9432 18.7196 9.98326 16.7311 9.98326C14.674 9.98326 12.8912 10.9432 11.7255 12.3832C12.4798 13.2746 12.9598 14.3717 12.9598 15.606C12.9598 17.1831 12.274 18.5545 11.1769 19.4459C14.1254 20.6116 16.2511 23.5601 16.2511 26.9886C16.2511 28.0858 14.5369 28.0858 14.5369 26.9886C14.5369 23.423 11.6569 20.5431 8.15984 20.5431C4.5942 20.5431 1.71425 23.423 1.71425 26.9886ZM16.7311 1.89199C15.0169 1.89199 13.5769 3.33196 13.5769 5.04621C13.5769 6.76046 15.0169 8.13187 16.7311 8.13187C18.4454 8.13187 19.8168 6.76046 19.8168 5.04621C19.8168 3.33196 18.4454 1.89199 16.7311 1.89199ZM25.3024 12.5204C23.5881 12.5204 22.2167 13.8918 22.2167 15.606C22.2167 17.3888 23.5881 18.7602 25.3024 18.7602C27.0166 18.7602 28.4566 17.3888 28.4566 15.606C28.4566 13.8918 27.0166 12.5204 25.3024 12.5204ZM8.15984 12.5204C6.37702 12.5204 5.00562 13.8918 5.00562 15.606C5.00562 17.3888 6.37702 18.7602 8.15984 18.7602C9.8741 18.7602 11.2455 17.3888 11.2455 15.606C11.2455 13.8918 9.8741 12.5204 8.15984 12.5204Z"
      // fill="#03C2B9"
    />
  )
};

export const Thumbnail = {
  viewBox: "0 0 50 40",
  body: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45 0H5C2.25 0 0 2.25 0 5V35C0 37.75 2.25 40 5 40H45C47.75 40 50 37.75 50 35V5C50 2.25 47.75 0 45 0ZM45 35H5V5H45V35ZM22.5 20H42.5V32.5H22.5V20Z"
    />
  )
};

export const ThumbsUp = {
  viewBox: "0 0 62 62",
  body: () => (
    <path d="M5.16699 51.6665H10.3337C11.7545 51.6665 12.917 50.504 12.917 49.0832V25.8332C12.917 24.4123 11.7545 23.2498 10.3337 23.2498H5.16699V51.6665ZM56.3945 33.2732C56.6787 32.6273 56.8337 31.9298 56.8337 31.2065V28.4165C56.8337 25.5748 54.5087 23.2498 51.667 23.2498H37.4587L39.8353 11.2373C39.9645 10.669 39.887 10.049 39.6287 9.53234C39.0345 8.36984 38.2853 7.31067 37.3553 6.38067L36.167 5.1665L19.6078 21.7257C18.6262 22.7073 18.0837 24.0248 18.0837 25.394V45.6473C18.0837 48.954 20.7962 51.6665 24.1287 51.6665H45.0795C46.8878 51.6665 48.5928 50.7107 49.5228 49.1607L56.3945 33.2732Z" />
  )
};

export const ThumbsUpSticker = {
  viewBox: "0 0 95 120",
  body: () => (
    <>
      <path
        d="M94.5367 59.7735C94.5367 24.5878 78.4286 0 47.4796 0C16.1082 0 0 24.5878 0 59.7735C0 95.3816 16.1082 120 47.4796 120C78.4286 120 94.5367 95.3816 94.5367 59.7735Z"
        fill="#FADCDC"
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="95"
        height="120"
      >
        <path
          d="M94.5367 59.7735C94.5367 24.5878 78.4286 0 47.4796 0C16.1082 0 0 24.5878 0 59.7735C0 95.3816 16.1082 120 47.4796 120C78.4286 120 94.5367 95.3816 94.5367 59.7735Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <mask
          id="mask1"
          maskUnits="userSpaceOnUse"
          x="20"
          y="30"
          width="50"
          height="56"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.5089 42.381L53.4432 30.3939L69.0747 73.3409L36.1403 85.3281L20.5089 42.381Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.3519 35.8867C36.1059 36.7041 36.1392 39.0517 36.1694 41.1232C36.2012 43.3568 36.2452 46.4157 34.3738 49.1752C27.3993 59.5626 28.6792 63.7107 30.034 68.1012C30.1616 68.5136 30.2914 68.9343 30.4159 69.3702C32.4235 77.2908 40.253 82.1075 48.2644 80.349C50.6026 79.8788 52.7384 79.2873 54.7924 78.5397C57.5841 77.5236 60.3001 76.1833 63.0975 74.4416C65.8682 72.7503 67.1725 70.4784 66.5696 68.3756C66.2585 67.2899 65.3945 66.2362 64.2874 65.5149C64.7827 64.2718 64.8672 62.95 64.5689 61.9269C64.2554 60.8504 63.4677 59.8601 62.3883 59.2491C62.9713 57.453 62.7218 56.0694 62.5797 55.5395C62.2925 54.4643 61.5307 53.5086 60.4919 52.9176C60.2304 52.7688 59.9564 52.6454 59.6732 52.5468C59.8321 51.6128 59.6747 50.8645 59.5607 50.4895C58.6846 47.6065 55.4069 47.0879 52.6791 47.8218C52.1402 47.9176 49.9075 48.3278 47.2216 49.0026C47.2013 48.4914 47.1624 48.0277 47.1322 47.6702C47.1201 47.5294 47.1098 47.4096 47.105 47.3184C46.9443 44.7078 46.4475 42.4733 45.5852 40.4864C44.0266 36.8952 41.2769 35.061 38.5801 35.8135C38.5022 35.8353 38.4262 35.8596 38.3526 35.8864L38.3519 35.8867ZM39.1519 38.0846C39.1702 38.0779 39.1889 38.0719 39.2068 38.0662C41.1811 37.5161 42.7712 39.8986 43.4314 41.4197C44.2576 43.3235 44.636 45.4044 44.762 47.4668C44.7973 48.0397 44.9831 49.5751 44.8286 50.7729C44.8286 50.7729 44.9657 52.0398 45.7265 51.8234C49.5555 50.7334 53.1926 50.1066 53.1926 50.1066C55.5257 49.4416 56.9854 50.0885 57.3145 51.1735C57.5907 52.0835 57.3424 53.6963 54.5273 55.2702L54.5918 55.4475C55.2667 55.2193 56.0347 54.9771 56.8835 54.7396C58.6902 54.2346 60.0392 55.1267 60.3127 56.1481C60.5862 57.1695 60.4171 59.1327 58.4943 61.2704L56.9568 61.9453L56.9672 61.9739L59.1925 61.0744C60.9264 60.5893 62.0779 61.769 62.3155 62.5844C62.5534 63.4005 62.2685 65.2972 60.8376 66.3266C59.7819 67.0345 59.2702 67.3767 58.9949 67.5449L59.029 67.6387L60.8391 66.9782C62.2069 66.5924 64.0169 67.9888 64.3127 69.0236C64.6093 70.0581 63.6285 71.3768 61.8581 72.4575C59.2278 74.0952 56.6855 75.3616 53.9925 76.3418C52.034 77.0546 49.9947 77.6159 47.785 78.0593C41.0474 79.5491 34.356 75.4292 32.6834 68.7606C31.322 63.9652 29.2897 60.9488 36.317 50.4824C40.1165 44.8788 37.4565 38.7008 39.1519 38.0846Z"
            fill="#28283C"
          />
        </g>
        <mask
          id="mask2"
          maskUnits="userSpaceOnUse"
          x="-14"
          y="30"
          width="83"
          height="68"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.73293 97.8513L68.4511 73.5679L52.7182 30.3421L-14 54.6255L1.73293 97.8513Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-0.8305 96.656L39.5763 81.9491L29.6577 54.698L-10.7491 69.4049L-0.8305 96.656Z"
            fill="#28283C"
          />
        </g>
      </g>
    </>
  )
};

export const Tick = {
  viewBox: "0 0 512 512",
  body: () => <path d="M432 64l-240 240-112-112-80 80 192 192 320-320z" />
};

export const TickInCircleFull = {
  viewBox: "0 0 35 35",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5Z"
      fill="#32C864"
    />,
    <path
      key={2}
      d="M10 18.019L14.8349 22L25 11"
      fill="#32C864"
      stroke="white"
      strokeWidth="3"
    />
  ]
};

export const Time = {
  viewBox: "0 0 16 16",
  body: () => (
    <g>
      <path
        d="M14.8058 4.51595C14.3241 3.68325 13.682 2.95437 12.9167 2.3715C12.1513 1.78863 11.278 1.36334 10.3472 1.12025C10.2941 1.11712 10.2422 1.10342 10.1945 1.07995C9.16226 0.806315 8.08263 0.762206 7.03155 0.950724C5.98046 1.13924 4.98346 1.55581 4.11069 2.17111C4.03917 2.22139 3.97826 2.28527 3.93142 2.35909C3.88459 2.43292 3.85276 2.51524 3.83774 2.60137C3.82273 2.68749 3.82482 2.77574 3.84391 2.86105C3.86299 2.94637 3.8987 3.02709 3.94898 3.09861C3.99926 3.17013 4.06314 3.23104 4.13696 3.27788C4.21079 3.32471 4.29312 3.35654 4.37924 3.37156C4.46537 3.38657 4.55361 3.38448 4.63893 3.36539C4.72424 3.34631 4.80497 3.3106 4.87648 3.26032C5.59069 2.757 6.40646 2.41621 7.26647 2.26189C8.12647 2.10758 9.00984 2.14349 9.85448 2.36711C9.90759 2.37013 9.95955 2.38384 10.0072 2.40741C11.1403 2.70509 12.1613 3.32843 12.9437 4.20031C13.7262 5.07219 14.2359 6.15435 14.4098 7.3129C14.5836 8.47145 14.414 9.65555 13.9219 10.7187C13.4298 11.7818 12.6367 12.6774 11.6409 13.2945C10.6451 13.9116 9.49026 14.2233 8.31918 14.1909C7.14811 14.1585 6.01224 13.7834 5.05209 13.1122C4.09195 12.4409 3.34967 11.5029 2.9171 10.4141C2.48453 9.32541 2.38065 8.13374 2.61831 6.98658L2.79151 7.29082C2.87896 7.44403 3.02364 7.55626 3.19379 7.60287C3.36393 7.64948 3.54561 7.62665 3.69893 7.53939C3.85225 7.45214 3.96467 7.3076 4.01149 7.13751C4.05832 6.96743 4.03572 6.78572 3.94866 6.63229L2.96784 4.90925C2.92461 4.83326 2.86683 4.76654 2.79781 4.71289C2.72878 4.65923 2.64987 4.6197 2.56556 4.59655C2.48126 4.5734 2.39322 4.56708 2.30648 4.57796C2.21973 4.58884 2.13598 4.61669 2.06 4.65994L0.336965 5.64059C0.260902 5.68378 0.194098 5.74155 0.140371 5.81058C0.0866439 5.8796 0.0470481 5.95854 0.0238459 6.04288C0.000643778 6.12722 -0.00570938 6.21531 0.00514953 6.3021C0.0160084 6.3889 0.0438669 6.4727 0.0871318 6.54873C0.130397 6.62475 0.18822 6.6915 0.257296 6.74517C0.326373 6.79883 0.405349 6.83835 0.489709 6.86148C0.574069 6.8846 0.66216 6.89088 0.748945 6.87994C0.835731 6.869 0.91951 6.84107 0.995494 6.79773L1.33238 6.60601C1.07289 7.76948 1.1014 8.97871 1.41545 10.1287C1.72949 11.2786 2.31956 12.3345 3.13441 13.2046C3.94925 14.0746 4.96421 14.7326 6.09112 15.1213C7.21803 15.51 8.4228 15.6176 9.60077 15.4349C10.7787 15.2522 11.8943 14.7846 12.8505 14.0728C13.8067 13.3609 14.5746 12.4264 15.0876 11.3503C15.6005 10.2743 15.843 9.08928 15.7939 7.89823C15.7448 6.70718 15.4056 5.54614 14.8058 4.51596L14.8058 4.51595Z"
        strokeWidth={0}
      />
      <path
        d="M8.51236 4.02441C8.33581 4.02442 8.1665 4.09456 8.04166 4.2194C7.91683 4.34424 7.84669 4.51355 7.84668 4.6901V8.19176C7.84678 8.23554 7.85119 8.2792 7.85982 8.32212C7.86374 8.34184 7.8711 8.36007 7.87673 8.37912C7.88669 8.42575 7.90514 8.47014 7.93115 8.51009C7.94044 8.52704 7.94787 8.54465 7.95874 8.5609C7.98312 8.59754 8.01105 8.63169 8.04214 8.66284L9.65975 10.2805C9.78464 10.405 9.95385 10.4749 10.1302 10.4748C10.3066 10.4747 10.4757 10.4045 10.6004 10.2798C10.7251 10.1551 10.7953 9.98599 10.7954 9.80962C10.7955 9.63325 10.7256 9.46403 10.6011 9.33915L9.17804 7.91612V4.6901C9.17803 4.51356 9.1079 4.34424 8.98306 4.2194C8.85822 4.09456 8.68891 4.02442 8.51236 4.02441Z"
        strokeWidth={0}
      />
    </g>
  )
};

export const Info = {
  viewBox: "0 0 128 128",
  body: () => (
    <g>
      <circle cx="64" cy="64" r="55" fill="#fff" />
      <path
        className="svg-info"
        fill="#444b54"
        d="M64,122C32,122,6,96,6,64S32,6,64,6s58,26,58,58S96,122,64,122z M64,12c-28.7,0-52,23.3-52,52s23.3,52,52,52 s52-23.3,52-52S92.7,12,64,12z"
      />
      <path
        className="svg-info"
        fill="#444b54"
        d="M64,90c-1.7,0-3-1.3-3-3V61c0-1.7,1.3-3,3-3s3,1.3,3,3v26C67,88.7,65.7,90,64,90z"
      />
      <path
        className="svg-info"
        fill="#444b54"
        d="M64,49c-1.7,0-3-1.3-3-3v-5c0-1.7,1.3-3,3-3s3,1.3,3,3v5C67,47.7,65.7,49,64,49z"
      />
    </g>
  )
};

export const TurnLeft = {
  viewBox: "0 0 86 87",
  body: () => (
    <path d="M1.66969 26.4048C1.56637 26.6093 1.64843 26.8589 1.85297 26.9622L5.18611 28.6457C5.39065 28.7491 5.64021 28.667 5.74353 28.4625C5.84684 28.2579 5.76478 28.0084 5.56024 27.905L2.59745 26.4085L4.09395 23.4458C4.19726 23.2412 4.1152 22.9917 3.91066 22.8883C3.70612 22.785 3.45656 22.8671 3.35325 23.0716L1.66969 26.4048ZM78.5583 59.6401C78.771 59.7254 79.0126 59.6222 79.0979 59.4096L80.4885 55.944C80.5739 55.7313 80.4707 55.4897 80.258 55.4044C80.0453 55.319 79.8037 55.4223 79.7184 55.6349L78.4823 58.7155L75.4018 57.4793C75.1891 57.394 74.9475 57.4972 74.8622 57.7099C74.7768 57.9226 74.8801 58.1641 75.0927 58.2495L78.5583 59.6401ZM2.16964 26.986C11.2747 23.9921 26.0238 22.0204 40.6407 25.8411C55.2375 29.6566 69.7136 39.2491 78.3313 59.4181L79.0944 59.092C70.3663 38.6649 55.6711 28.9122 40.8505 25.0383C26.0499 21.1695 11.1356 23.1643 1.91043 26.1977L2.16964 26.986Z" />
  )
};

export const Twitter = {
  viewBox: "0 0 20 20",
  body: () => (
    <path
      fillRule="nonzero"
      d="M17.914 6.05v.49c0 5.399-4.172 11.656-11.656 11.656-2.332 0-4.418-.736-6.258-1.84h.982c1.963 0 3.68-.614 5.03-1.718-1.84 0-3.313-1.227-3.803-2.822.245 0 .49.123.736.123.368 0 .736 0 1.104-.123C2.21 11.448.736 9.73.736 7.766c.614.369 1.227.492 1.84.492C1.597 7.52.86 6.172.86 4.822c0-.736.245-1.472.613-2.086C3.436 5.19 6.503 6.908 9.94 7.031c-.123-.246-.123-.614-.123-.982C9.816 3.84 11.656 2 13.865 2c1.227 0 2.209.49 2.945 1.35a5.952 5.952 0 0 0 2.577-.982c-.369.982-.982 1.718-1.841 2.209.982-.123 1.718-.368 2.454-.614-.49.736-1.227 1.473-2.086 2.086z"
    />
  )
};

export const User = {
  viewBox: "0 0 40 40",
  body: () => [
    <defs key="user-defs">
      <circle id="a" cx="20" cy="20" r="20" />
    </defs>,
    <g fill="none" fillRule="evenodd" key="user-g">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#FAAA1E" xlinkHref="#a" />
      <g fillRule="nonzero" mask="url(#b)">
        <ellipse cx="19.972" cy="19.87" fill="#FAAA1E" rx="19.972" ry="19.87" />
        <path
          fill="#28283C"
          d="M20.028 27.353c-1.098 0-2.169-.449-3.127-1.177v1.205c0 2.186 6.761 2.102 6.761-.477v-.924c-1.127.868-2.366 1.373-3.634 1.373z"
          opacity=".5"
        />
        <g fill="#28283C">
          <path d="M23.972 28.054V26.12c.986-.785 1.915-1.878 2.648-3.14.253 1.234.901 2.075 1.662 2.075 1.014 0 1.803-1.458 1.803-3.307 0-.925-.198-1.71-.508-2.326.029-.056.085-.112.113-.168.62-1.037 1.042-3.167.817-4.12-.14-.589-.592-1.233-1.24-1.29-.225-.027-.478.029-.732.225.085-.897.085-1.822.057-2.747-.085-1.681-.226-3.503-1.127-4.96-1.296-2.074-4.564-3.083-6-.729-2.395-2.046-5.944-1.485-7.493 1.29-1.578-1.066-4.31-1.57-4.986.784-.507 1.794.986 2.83 2.45 3.56.198.644.451 1.709.677 2.718.028.112.028.224.056.336 0 .112-.028.224-.028.336a1.313 1.313 0 0 0-.733-.056c-.422.084-.732.393-.873.841-.253.869.17 2.466.733 3.447-.536.56-.874 1.626-.874 2.859 0 1.85.79 3.307 1.803 3.307.789 0 1.437-.897 1.69-2.158.76 1.457 1.719 2.634 2.79 3.447v1.597c-2.592 1.065-4.846 3.391-6.62 6.895-2.029 4.007-2.761 8.24-2.761 8.267l.591.112c.028-.14 2.057-11.63 8.817-14.629a3.672 3.672 0 0 0 3.634 3.195 3.637 3.637 0 0 0 3.606-3.11c7.408 3.222 7.493 15.077 7.493 15.217h.591c0-.14-.113-12.584-8.056-15.834zm4.31-3.588c-.536 0-1.099-.953-1.183-2.382.338-.7.647-1.457.873-2.242.31.168.676.168.986.084.056-.028.112-.028.197-.084a4.94 4.94 0 0 1 .366 1.878c-.056 1.625-.676 2.746-1.24 2.746zm-16.113 0c-.563 0-1.211-1.12-1.211-2.718 0-1.065.281-1.878.62-2.354.225.252.422.42.647.476.141.028.282.056.423.056.197.7.422 1.345.704 1.962-.028 1.513-.62 2.578-1.183 2.578zm11.183 3.672c0 1.681-1.38 3.026-3.042 3.026a3.04 3.04 0 0 1-3.042-3.026v-1.374c.873.56 1.83.87 2.76.87h.028c1.127 0 2.254-.393 3.296-1.094v1.598zm-3.296-1.093c-2.845-.028-5.718-3.195-6.901-7.567-.028-.084-.085-.168-.17-.196-.027-.028-.084-.028-.112-.028-.056 0-.084 0-.14.028-.057.056-.17.056-.339 0-.056-.028-.281-.113-.62-.645-.563-.953-.873-2.41-.704-3.027a.541.541 0 0 1 .423-.42c.225-.056.507.028.648.224a.455.455 0 0 0 .197.112c.254 1.485.592 2.97.76 3.083l.085.028.056-.028c.057-.028.085-.112.085-.477-.056-1.681.338-5.016 1.55-6.361 1.154-.168 2.28-.477 3.295-1.01-.282.281-.592.561-.901.785-.282.169-.17.617.169.617 1.83.028 3.549-.7 5.183-1.485-.395.392-.817.728-1.38.953-.31.112-.339.532 0 .644 1.52.533 2.985.308 4.366-.448a15.11 15.11 0 0 1 1.52 5.633c.029.392.536.448.677.084.253-.757.45-1.513.563-2.27.028-.028.057-.056.085-.112.225-.477.479-.729.732-.729.282.028.62.392.732.84.198.814-.197 2.747-.732 3.644-.197.337-.338.393-.394.393-.507.112-.62-.085-.704-.197a.3.3 0 0 0-.226-.168.3.3 0 0 0-.225.028c-.057.028-.113.112-.141.168-1.127 4.54-4.31 7.904-7.437 7.904z" />
          <path d="M19.634 20.991a.312.312 0 0 0-.31-.308c-.197 0-.282-.084-.31-.168-.113-.225 0-.617.197-.87.113-.111.085-.307-.028-.42-.113-.112-.31-.084-.422.029-.367.42-.48 1.064-.282 1.513.14.336.45.504.845.504.169.028.31-.112.31-.28zM22.76 16.367a.575.575 0 0 0-.591.588.575.575 0 0 0 .592.589.575.575 0 0 0 .591-.589.575.575 0 0 0-.592-.589zM16.648 16.563a.575.575 0 0 0-.592.589.575.575 0 0 0 .592.589.593.593 0 0 0 .422-1.01c-.112-.112-.253-.14-.422-.168zM18.14 14.966c-1.267-.533-2.196-.14-2.929.308-.14.084-.197.28-.084.42.056.084.14.14.253.14a.402.402 0 0 0 .17-.056c.253-.168.506-.28.732-.364l.957-.112c.226.028.451.084.676.196.141.056.339 0 .395-.168.028-.14-.028-.308-.17-.364zM24.732 16.199c.057 0 .141-.028.198-.056.14-.112.14-.28.056-.42-.873-1.066-1.887-1.15-2.732-1.094-.17 0-.282.14-.282.309 0 .168.169.28.31.28.31-.028.563 0 .817.028l.901.364c.169.14.366.28.507.477.056.056.14.112.225.112zM23.014 22.869c-.14-.056-.338 0-.394.168-.48 1.149-2.338 1.149-3.127.98a.314.314 0 0 0-.366.225c-.028.168.056.308.225.364.282.056.62.112.986.112 1.099 0 2.338-.336 2.817-1.429.084-.196 0-.364-.14-.42z" />
        </g>
      </g>
    </g>
  ]
};

export const VideoCamera = {
  viewBox: "0 0 32 32",
  body: () => (
    <path
      id="path4"
      d="m 29.998418,13.998714 -6.00099,3.999572 c 0,-1.214564 -0.551777,-2.288735 -1.407196,-3.020085 2.034068,-1.224358 3.40535,-3.431469 3.40535,-5.978135 C 25.995582,5.134358 22.861224,2 18.995515,2 c -3.865708,0 -7.000066,3.134358 -7.000066,7.000066 0,1.962239 0.812974,3.72858 2.112427,4.998648 H 10.44133 c 0.956632,-1.061111 1.557384,-2.455247 1.557384,-3.999571 0,-3.313931 -2.687059,-6.00099 -6.00099,-6.00099 C 2.687059,3.998153 0,6.685212 0,9.999143 0,11.807929 0.816239,13.407757 2.083042,14.508047 0.845623,15.187158 0,16.486611 0,17.998286 v 7.999143 C 0,28.204539 1.792461,29.997 3.999571,29.997 h 15.998286 c 2.20711,0 3.999571,-1.792461 3.999571,-3.999571 v -0.999077 l 6.00099,4.998648 c 1.103555,0 2.001418,-0.894598 2.001418,-2.001418 V 15.996868 c -0.0033,-1.103556 -0.897863,-1.998154 -2.001418,-1.998154 z m -27.997,-3.999571 c 0,-2.210376 1.792461,-3.999572 3.999571,-3.999572 2.207111,0 3.999572,1.789196 3.999572,3.999572 0,2.210375 -1.792461,3.999571 -3.999572,3.999571 -2.210375,-0.0033 -3.999571,-1.792461 -3.999571,-3.999571 z m 19.997857,15.998286 c 0,1.103555 -0.894598,2.001418 -2.001418,2.001418 H 3.999571 c -1.103555,0 -2.001418,-0.894598 -2.001418,-2.001418 v -7.999143 c 0,-1.103556 0.894598,-2.001418 2.001418,-2.001418 h 15.998286 c 1.103555,0 2.001418,0.894598 2.001418,2.001418 z M 18.99878,14.008509 c -2.768683,0 -5.011708,-2.243025 -5.011708,-5.011708 0,-2.768683 2.243025,-5.011708 5.011708,-5.011708 2.768683,0 5.011708,2.243025 5.011708,5.011708 0,2.768683 -2.24629,5.011708 -5.011708,5.011708 z m 10.999638,3.486973 v 9.181057 c 0,0.05224 0,0.07183 0,0.07183 v 1.243948 l -6.00099,-4.995383 v -2.001418 c 0,-0.528923 0,-0.40159 0,-0.999077 l 6.00099,-3.999571 c 0,1.403931 0,0.672581 0,1.498614 z"
    />
  )
};

export const Wait = {
  viewBox: "0 0 20 20",
  body: () => [
    <path
      key="wait-path"
      d="M19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10Z"
      fill="#822D50"
      stroke="#822D50"
    />,
    <g key="wait-g" clipPath="url(#clip0)">
      <path
        d="M14.6264 7.35632L11.9827 10H13.9655C13.9655 12.1876 12.1876 13.9655 9.99997 13.9655C9.33244 13.9655 8.69796 13.8003 8.1494 13.5029L7.18446 14.4678C7.99739 14.9833 8.96233 15.2874 9.99997 15.2874C12.9212 15.2874 15.2873 12.9213 15.2873 10H17.2701L14.6264 7.35632ZM6.03446 10C6.03446 7.81236 7.81233 6.03449 9.99997 6.03449C10.6675 6.03449 11.302 6.19972 11.8505 6.49713L12.8155 5.53219C12.0026 5.01667 11.0376 4.71265 9.99997 4.71265C7.07871 4.71265 4.71262 7.07874 4.71262 10H2.72986L5.37354 12.6437L8.01721 10H6.03446Z"
        fill="white"
      />
    </g>,
    <defs key="wait-defs">
      <clipPath id="clip0">
        <rect
          width="15.8621"
          height="15.8621"
          fill="white"
          transform="translate(2.06897 2.06885)"
        />
      </clipPath>
    </defs>
  ]
};

export const XInCircleEmpty = {
  viewBox: "0 0 37 37",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 18.5C1 8.83502 8.83502 1 18.5 1C28.165 1 36 8.83502 36 18.5C36 28.165 28.165 36 18.5 36C8.83502 36 1 28.165 1 18.5Z"
      fill="white"
      stroke="#D8D8D8"
    />,
    <path
      key={2}
      d="M23.167 25L25 23.167L20.333 18.5L25 13.833L23.167 12L18.5 16.667L13.833 12L12 13.833L16.667 18.5L12 23.167L13.833 25L18.5 20.333L23.167 25Z"
      fill="#787878"
    />
  ]
};

export const Pencil = {
  viewBox: "0 0 32 32",
  body: () => (
    <path d="M23.89,3.72l-2-1.19a3.84,3.84,0,0,0-5.25,1.34l-10,16.85a2.91,2.91,0,0,0-.41,1.66L6.59,29a1,1,0,0,0,.49.81,1,1,0,0,0,.51.14,1,1,0,0,0,.43-.1L14,27h0a2.92,2.92,0,0,0,1.26-1.15L24.63,10h0l.6-1A3.84,3.84,0,0,0,23.89,3.72Zm-4,.28a1.88,1.88,0,0,1,.93.25l2,1.19A1.84,1.84,0,0,1,23.51,8l-.09.15L18.26,5l.09-.15A1.84,1.84,0,0,1,19.93,4ZM14.56,23.05l-.33-.52a1,1,0,0,0-.77-.45L11.73,22l-.94-1.46A1,1,0,0,0,10,20L9.4,20,17.24,6.76,22.4,9.82Zm-1.43,2.12L8.51,27.39l-.27-5.12a.83.83,0,0,1,0-.35L9.38,22l.94,1.46a1,1,0,0,0,.77.45l1.73.12.59.92A1.18,1.18,0,0,1,13.13,25.17Z" />
  )
};

export const Kits = {
  viewBox: "0 0 496 496",
  body: () => (
    <>
      <path d="m396.945312 288h-297.890624l-32 64h28.945312v144h304v-144h28.945312zm-9.890624 16 16 32h-126.109376l-16-32zm-278.109376 0h126.109376l-16 32h-126.109376zm275.054688 176h-128v-56h-16v56h-128v-128h116.945312l11.054688-22.113281v70.113281h16v-70.113281l11.054688 22.113281h116.945312zm0 0" />
      <path d="m128 416h48v16h-48zm0 0" />
      <path d="m128 448h48v16h-48zm0 0" />
      <path d="m192 448h16v16h-16zm0 0" />
      <path d="m211.054688 130.113281 36.945312-9.417969 36.945312 9.410157 2.894532-39.671875 19.625-33.523438-34.710938-15.023437-24.753906-30.605469-24.761719 30.605469-34.710937 15.023437 19.625 33.523438zm22.152343-75.113281 14.792969-18.28125 14.792969 18.289062 21.742187 9.417969-12.375 21.140625-1.777344 24.328125-22.382812-5.703125-22.382812 5.695313-1.777344-24.328125-12.375-21.144532zm0 0" />
      <path d="m87.839844 146.441406 11.625-19.847656-20.59375-8.921875-14.871094-18.390625-14.871094 18.382812-20.59375 8.921876 11.625 19.847656 1.71875 23.671875 22.121094-5.625 22.128906 5.632812zm-15.679688-4.882812-.609375 8.328125-7.550781-1.917969-7.542969 1.917969-.617187-8.328125-4.375-7.480469 7.625-3.300781 4.910156-6.058594 4.902344 6.066406 7.625 3.304688zm0 0" />
      <path d="m455.839844 146.441406 11.625-19.847656-20.59375-8.921875-14.871094-18.390625-14.871094 18.382812-20.59375 8.921876 11.625 19.847656 1.71875 23.671875 22.121094-5.625 22.128906 5.632812zm-15.679688-4.882812-.609375 8.328125-7.550781-1.917969-7.542969 1.917969-.609375-8.328125-4.375-7.480469 7.625-3.300781 4.902344-6.058594 4.902344 6.066406 7.625 3.304688zm0 0" />
      <path d="m99.558594 190.65625c15.234375 10.160156 28.769531 22.558594 40.203125 36.863281l31.6875 39.59375-6.554688-52.417969c-3.421875-27.367187-18.039062-52.558593-40.101562-69.101562l-7.664063-5.746094-23.449218 46.886719zm23.058594-26c13.527343 12.800781 22.703124 29.839844 25.847656 48.273438-10.105469-11.867188-21.570313-22.441407-34.207032-31.554688zm0 0" />
      <path d="m331.105469 214.695312-6.554688 52.417969 31.6875-39.601562c11.441407-14.304688 24.96875-26.703125 40.203125-36.863281l5.871094-3.921876-23.449219-46.886718-7.664062 5.761718c-22.054688 16.542969-36.679688 41.726563-40.09375 69.09375zm50.636719-33.320312c-12.636719 9.113281-24.109376 19.679688-34.207032 31.554688 3.152344-18.433594 12.320313-35.472657 25.847656-48.273438zm0 0" />
      <path d="m280 272h16v-33.519531c0-38.425781 13.542969-75.832031 38.152344-105.359375l-12.296875-10.242188c-26.992188 32.394532-41.855469 73.449219-41.855469 115.601563zm0 0" />
      <path d="m336 96h16v16h-16zm0 0" />
      <path d="m360 64h16v16h-16zm0 0" />
      <path d="m200 272h16v-33.519531c0-42.160157-14.863281-83.207031-41.847656-115.601563l-12.296875 10.242188c24.601562 29.527344 38.144531 66.933594 38.144531 105.359375zm0 0" />
      <path d="m144 96h16v16h-16zm0 0" />
      <path d="m120 64h16v16h-16zm0 0" />
      <path d="m240 136h16v16h-16zm0 0" />
      <path d="m240 168h16v104h-16zm0 0" />
      <path d="m464 216h16v16h-16zm0 0" />
      <path d="m464 248h16v16h-16zm0 0" />
      <path d="m480 232h16v16h-16zm0 0" />
      <path d="m448 232h16v16h-16zm0 0" />
      <path d="m440 0h16v16h-16zm0 0" />
      <path d="m440 32h16v16h-16zm0 0" />
      <path d="m456 16h16v16h-16zm0 0" />
      <path d="m424 16h16v16h-16zm0 0" />
      <path d="m16 248h16v16h-16zm0 0" />
      <path d="m16 280h16v16h-16zm0 0" />
      <path d="m32 264h16v16h-16zm0 0" />
      <path d="m0 264h16v16h-16zm0 0" />
      <path d="m16 0h16v16h-16zm0 0" />
      <path d="m16 32h16v16h-16zm0 0" />
      <path d="m32 16h16v16h-16zm0 0" />
      <path d="m0 16h16v16h-16zm0 0" fill="#FBB231" />
    </>
  )
};

export const Login = {
  viewBox: "0 0 24 24",
  body: () => (
    <g strokeWidth={1.5} fill={"none"}>
      <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
      <path d="M20 12h-13l3 -3m0 6l-3 -3" />
    </g>
  )
};

export const Link = {
  viewBox: "0 0 24 24",
  body: () => (
    <g fill="none" strokeWidth={1.5}>
      <path d="M10 14a3.5 3.5 0 0 0 5 0l4-4a3.5 3.5 0 0 0-5-5l-.5.5" />
      <path d="M14 10a3.5 3.5 0 0 0-5 0l-4 4a3.5 3.5 0 0 0 5 5l.5-.5" />
    </g>
  )
};

export const IDCard = {
  viewBox: "0 0 24 24",
  body: () => (
    <g strokeWidth={1.5} fill={"none"}>
      <rect x="3" y="4" width="18" height="16" rx="3" />
      <circle cx="9" cy="10" r="2" />
      <line x1="15" y1="8" x2="17" y2="8" />
      <line x1="15" y1="12" x2="17" y2="12" />
      <line x1="7" y1="16" x2="17" y2="16" />
    </g>
  )
};

export const Ticket = {
  viewBox: "0 0 24 24",
  body: () => (
    <g strokeWidth={1.5} fill={"none"}>
      <line x1="15" y1="5" x2="15" y2="7" />
      <line x1="15" y1="11" x2="15" y2="13" />
      <line x1="15" y1="17" x2="15" y2="19" />
      <path d="M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2" />
    </g>
  )
};

export const Basket = {
  viewBox: "0 0 24 24",
  body: () => (
    <g strokeWidth={1.5} fill={"none"}>
      <polyline points="7 10 12 4 17 10" />
      <path d="M21 10l-2 8a2 2.5 0 0 1 -2 2h-10a2 2.5 0 0 1 -2 -2l-2 -8z" />
      <circle cx="12" cy="15" r="2" />
    </g>
  )
};

export const BarChartAlt = {
  viewBox: "0 0 24 24",
  body: () => (
    <g strokeWidth={1.5} fill={"none"}>
      <rect x="3" y="12" width="6" height="8" rx="1" />
      <rect x="9" y="8" width="6" height="12" rx="1" />
      <rect x="15" y="4" width="6" height="16" rx="1" />
      <line x1="4" y1="20" x2="18" y2="20" />
    </g>
  )
};

export const Eye = {
  viewBox: "0 0 24 24",
  body: () => (
    <g strokeWidth={1.5} fill="none">
      <circle cx="12" cy="12" r="2" />
      <path d="M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7" />
    </g>
  )
};

export const EyeOff = {
  viewBox: "0 0 24 24",
  body: () => (
    <g strokeWidth={1.5} fill="none">
      <line x1="3" y1="3" x2="21" y2="21" />
      <path d="M10.584 10.587a2 2 0 0 0 2.828 2.83" />
      <path d="M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341" />
    </g>
  )
};

export const Cart = {
  viewBox: "0 0 24 24",
  body: () => (
    <g strokeWidth={1.5} fill="none">
      <circle cx="6" cy="19" r="2" />
      <circle cx="17" cy="19" r="2" />
      <path d="M17 17h-11v-14h-2" />
      <path d="M6 5l14 1l-1 7h-13" />
    </g>
  )
};

export const Desktop = {
  viewBox: "0 0 24 24",
  body: () => (
    <g strokeWidth={1.5} fill="none">
      <rect x="3" y="4" width="18" height="12" rx="1" />
      <line x1="7" y1="20" x2="17" y2="20" />
      <line x1="9" y1="16" x2="9" y2="20" />
      <line x1="15" y1="16" x2="15" y2="20" />
    </g>
  )
};
export const DocumentExport = {
  viewBox: "0 0 24 24",
  body: () => (
    <g fill="none" strokeWidth={1.5}>
      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
      <path d="M11.5 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v5m-5 6h7m-3-3 3 3-3 3" />
    </g>
  )
};

export const CopyAlt = {
  viewBox: "0 0 24 24",
  body: () => (
    <g fill="none" strokeWidth={1.5}>
      <rect x="8" y="8" width="12" height="12" rx="2" />
      <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
    </g>
  )
};

export const WebsiteBuilder = {
  viewBox: "100 100 500 500",
  pathOutline: true,
  body: () => (
    <g>
      <path d="m551.25 157.5c4.832 0 8.75-3.918 8.75-8.75s-3.918-8.75-8.75-8.75-8.75 3.918-8.75 8.75 3.918 8.75 8.75 8.75z" />
      <path d="m516.25 157.5c4.832 0 8.75-3.918 8.75-8.75s-3.918-8.75-8.75-8.75-8.75 3.918-8.75 8.75 3.918 8.75 8.75 8.75z" />
      <path d="m481.25 157.5c4.832 0 8.75-3.918 8.75-8.75s-3.918-8.75-8.75-8.75-8.75 3.918-8.75 8.75 3.918 8.75 8.75 8.75z" />
      <path d="m131.25 455h437.5c6.9609 0 13.641-2.7656 18.562-7.6875s7.6875-11.602 7.6875-18.562v-297.5c0-6.9609-2.7656-13.641-7.6875-18.562s-11.602-7.6875-18.562-7.6875h-236.25c-4.832 0-8.75 3.918-8.75 8.75v87.5c0 2.3203-0.92188 4.5469-2.5625 6.1875s-3.8672 2.5625-6.1875 2.5625h-8.75c-6.9609 0-13.641 2.7656-18.562 7.6875s-7.6875 11.602-7.6875 18.562v43.75c0 2.3203-0.92188 4.5469-2.5625 6.1875s-3.8672 2.5625-6.1875 2.5625h-43.75c-6.9609 0-13.641 2.7656-18.562 7.6875s-7.6875 11.602-7.6875 18.562c0 2.3203-0.92188 4.5469-2.5625 6.1875s-3.8672 2.5625-6.1875 2.5625h-78.75c-4.832 0-8.75 3.918-8.75 8.75v96.25c0 6.9609 2.7656 13.641 7.6875 18.562s11.602 7.6875 18.562 7.6875zm446.25-323.75v43.75h-236.25v-52.5h227.5c2.3203 0 4.5469 0.92188 6.1875 2.5625s2.5625 3.8672 2.5625 6.1875zm-358.75 183.75c0-4.832 3.918-8.75 8.75-8.75h43.75c6.9609 0 13.641-2.7656 18.562-7.6875s7.6875-11.602 7.6875-18.562v-43.75c0-4.832 3.918-8.75 8.75-8.75h8.75c6.9609 0 13.641-2.7656 18.562-7.6875s7.6875-11.602 7.6875-18.562v-8.75h236.25v236.25c0 2.3203-0.92188 4.5469-2.5625 6.1875s-3.8672 2.5625-6.1875 2.5625h-437.5c-4.832 0-8.75-3.918-8.75-8.75v-87.5h70c6.9609 0 13.641-2.7656 18.562-7.6875s7.6875-11.602 7.6875-18.562z" />
      <path d="m144.64 198.27c3.2852 3.3164 7.7578 5.1797 12.426 5.1797s9.1406-1.8633 12.426-5.1797l30.977-31.5h-0.003906c3.3164-3.2852 5.1797-7.7578 5.1797-12.422 0-4.668-1.8633-9.1406-5.1797-12.426l-30.977-31.5h0.003906c-3.2852-3.3125-7.7578-5.1758-12.426-5.1758s-9.1406 1.8633-12.426 5.1758l-30.887 31.5c-3.3125 3.2852-5.1758 7.7578-5.1758 12.426 0 4.6641 1.8633 9.1367 5.1758 12.422zm12.34-75.773 30.977 31.5-30.453 32.023-31.324-31.848z" />
      <path d="m245 190.23h43.75c4.6406 0 9.0938-1.8438 12.375-5.1289 3.2812-3.2812 5.125-7.7305 5.125-12.371v-44.891c0-4.6406-1.8438-9.0898-5.125-12.371-3.2812-3.2852-7.7344-5.1289-12.375-5.1289h-43.75c-4.6406 0-9.0938 1.8438-12.375 5.1289-3.2812 3.2812-5.125 7.7305-5.125 12.371v44.891c0 4.6406 1.8438 9.0898 5.125 12.371 3.2812 3.2852 7.7344 5.1289 12.375 5.1289zm0-62.387h43.75v44.887h-43.75z" />
      <path d="m122.5 306.25h43.75c4.6406 0 9.0938-1.8438 12.375-5.125s5.125-7.7344 5.125-12.375v-45.062c0-4.6406-1.8438-9.0938-5.125-12.375s-7.7344-5.125-12.375-5.125h-43.75c-4.6406 0-9.0938 1.8438-12.375 5.125s-5.125 7.7344-5.125 12.375v45.062c0 4.6406 1.8438 9.0938 5.125 12.375s7.7344 5.125 12.375 5.125zm0-62.387h43.75v44.887h-43.75z" />
      <path d="m201.25 252.96c0 4.6445 1.8438 9.0938 5.125 12.375s7.7344 5.125 12.375 5.125h26.25c4.6406 0 9.0938-1.8438 12.375-5.125s5.125-7.7305 5.125-12.375v-27.035c0-4.6406-1.8438-9.0938-5.125-12.375s-7.7344-5.125-12.375-5.125h-26.25c-4.6406 0-9.0938 1.8438-12.375 5.125s-5.125 7.7344-5.125 12.375zm17.5-27.039h26.25v27.039h-26.25z" />
    </g>
  )
};

export { EmbedFullPage } from "../../icons/EmbedFullPage";
export { EmbedPopover } from "../../icons/EmbedPopover";
export { EmbedPopup } from "../../icons/EmbedPopup";
export { EmbedSideTab } from "../../icons/EmbedSideTab";
export { EmbedSlider } from "../../icons/EmbedSlider";
export { EmbedStandard } from "../../icons/EmbedStandard";
export { LinkTree } from "../../icons/LinkTree";
export { TerrariumSticker } from "../../icons/TerrariumSticker";
export { WellBeingSticker } from "../../icons/WellBeingSticker";
